// Staff cart panel (staff-only; window.STAFF_ORDER gates it): customer pick, doc setup,
// line notes/discount preview, ORG-406 extra lines, the calls case box and — ORG-162
// phase 3 — the vendor-pricelist search («＋ Από τιμοκατάλογο προμηθευτή», kind
// 'pricelist' extra lines keyed by SKU). Plan: calls repo
// docs/superpowers/plans/2026-10-09-products-phase3.md (Part T). Notes:
// docs/projects/theme/reference/staff-cart.md; spec tests/staff-cart/pricelist.spec.js.
(function () {
  var CFG = window.STAFF_ORDER;
  if (!CFG || !CFG.endpoint) return;              // non-staff: do nothing
  var EP = CFG.endpoint.replace(/\/$/, '');
  var ROOT = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  // WORK-259: the strings this file builds itself (snippets/staff-order-panel.liquid sets
  // window.STAFF_CART_I18N from locale keys); the fallbacks are the Greek it used to carry.
  function tr(k, fallback) { var i = window.STAFF_CART_I18N || {}; return i[k] || fallback; }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  // ---- Staff CRM bridge (Cases, spec 2026-08-11) ----
  var CRM = (CFG.crmEndpoint || '').replace(/\/$/, '');
  var CRM_ORIGIN = CRM ? new URL(CRM).origin : '';
  var TOKEN_KEY = 'staffCrm.token.v1';
  var renderCaseBox = function () {};   // real implementation installed in init()

  // The bearer lives in localStorage, not sessionStorage: sessionStorage is
  // per-tab, so opening the store in a new tab left staff tokenless while the
  // 12h token was still perfectly valid — and every /staff/* call then failed
  // before it reached the network. localStorage lets one connect cover the
  // token's whole life across tabs. sessionStorage is still read once so the
  // tabs open at deploy time don't have to reconnect.
  function crmToken() {
    try {
      var raw = localStorage.getItem(TOKEN_KEY);
      if (!raw) {
        raw = sessionStorage.getItem(TOKEN_KEY);
        if (raw) localStorage.setItem(TOKEN_KEY, raw);
      }
      var t = JSON.parse(raw);
      return t && t.exp > Date.now() / 1000 ? t.token : null;
    } catch (e) { return null; }
  }
  function saveTok(token, expiresIn) {
    try {
      localStorage.setItem(TOKEN_KEY, JSON.stringify(
        { token: token, exp: Date.now() / 1000 + (expiresIn || 43200) - 60 }));
    } catch (e) {}
  }
  function dropTok() {
    try { localStorage.removeItem(TOKEN_KEY); } catch (e) {}
    try { sessionStorage.removeItem(TOKEN_KEY); } catch (e) {}
  }

  function crmFetch(path, opt) {
    var t = crmToken();
    if (!t) return Promise.reject({ status: 401 });
    return fetch(CRM + path, Object.assign({}, opt, {
      headers: Object.assign({ 'Authorization': 'Bearer ' + t,
                               'Content-Type': 'application/json' },
                             (opt || {}).headers) }))
      .then(function (r) {
        if (r.status === 401) { dropTok(); renderCaseBox(); throw { status: 401 }; }
        if (!r.ok) throw r;
        return r.json();
      });
  }

  // /staff/* on listen — same bearer as the CRM case box (security
  // cleanup 2026-08-19); 401/403 clears the token so the case box shows
  // Connect. Returns the raw Response so call sites .json() themselves.
  function staffFetch(path, opt) {
    var t = crmToken();
    if (!t) { renderCaseBox(); return Promise.reject({ status: 401 }); }
    var o = Object.assign({}, opt);
    o.headers = Object.assign({ 'Authorization': 'Bearer ' + t },
                              (opt || {}).headers);
    return fetch(EP + path, o).then(function (r) {
      if (r.status === 401 || r.status === 403) {
        dropTok(); renderCaseBox(); throw { status: 401 };
      }
      return r;
    });
  }

  function exchangeCode(code) {
    return fetch(CRM + '/api/staff/token', { method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code }) })
      .then(function (r) {
        if (!r.ok) return false;
        return r.json().then(function (d) { saveTok(d.token, d.expires_in); return true; });
      })
      .catch(function () { return false; });
  }

  // Silent renewal: while the bearer is still alive, trade it for a fresh one
  // so a shift never hits the 12h wall mid-order. The server refuses once the
  // renewal chain outlives its cap (and always refuses an expired token), and
  // that 401 drops the token and redraws the case box as Connect — a dead
  // token is never resurrected here.
  var RENEW_WHEN_LEFT_S = 2 * 3600;
  var RENEW_POLL_MS = 15 * 60 * 1000;
  function tokenSecondsLeft() {
    try {
      var t = JSON.parse(localStorage.getItem(TOKEN_KEY)
                         || sessionStorage.getItem(TOKEN_KEY));
      return t && t.exp ? t.exp - Date.now() / 1000 : 0;
    } catch (e) { return 0; }
  }
  function maybeRenew() {
    if (!CRM || !crmToken()) return;
    var left = tokenSecondsLeft();
    if (left <= 0 || left > RENEW_WHEN_LEFT_S) return;
    crmFetch('/api/staff/renew', { method: 'POST' })
      .then(function (d) { if (d && d.token) saveTok(d.token, d.expires_in); })
      .catch(function () {});   // 401 already dropped the token and redrew the box
  }

  function connectPopup() {
    window.open(CRM + '/staff-connect', 'staff-crm', 'width=460,height=280');
  }
  window.addEventListener('message', function (ev) {
    if (!CRM_ORIGIN || ev.origin !== CRM_ORIGIN) return;
    var d = ev.data || {};
    if (d.type === 'staff-crm-token' && d.token) {
      saveTok(d.token, d.expires_in);
      renderCaseBox();
    }
  });

  // Phone as Zoho should store it: digits only — no spaces, no «+», no country
  // code for Greece. «+30 210 2231624» → «2102231624». Any other country code
  // survives, minus the plus: «+49 69 787486» → «4969787486».
  function normPhone(v) {
    var s = String(v == null ? '' : v).trim();
    if (!s) return '';
    var intl = /^(\+|00)/.test(s);              // country code was spelled out
    var d = s.replace(/\D/g, '');
    if (intl && d.indexOf('00') === 0) d = d.slice(2);
    // 30 is Greece and nothing else — no other country code begins with it, and
    // Greek numbers are 10 digits opening on 2 (landline) or 69 (mobile). So a
    // leading 30 in front of one is the country code even when «+» was omitted.
    if (d.indexOf('30') === 0 && (intl || /^30(2\d{9}|69\d{8})$/.test(d))) d = d.slice(2);
    return d;
  }

  function presetFromEkptosi(e) {
    e = (e || '').toLowerCase();
    if (e.indexOf('insize') > -1) return 'insize';
    if (e.indexOf('20') > -1) return '20';
    if (e.indexOf('10') > -1) return '10';
    if (e.indexOf('5') > -1) return '5';
    return 'none';   // no recorded discount → default to none
  }

  // Variant ids of the cart's lines in a live vendor price promo (sections/cart-offer-lines,
  // WORK-244: a permanent offer is not one, the preset stacks on it): they get
  // no preset % — listen bills them at 0% too (ORG-632). Filled by refreshOffers().
  var offerIds = {};
  // WORK-295 (John 2026-10-26): a gift-promo line loses the preset only for the pieces Shopify
  // counted toward an earned gift: with a YG-DORO code on the cart Shopify splits the insert line,
  // the counted pieces carry a YG-DORO allocation (0 for the inserts, the piece price for a free
  // holder) and the rest carry none. The website gets the same from Shopify itself (it never puts
  // another product discount on a gift's "buy" pieces); listen bills a line sent `gift_used` at 0%.
  function giftUsed(i) {
    return (i.line_level_discount_allocations || []).some(function (a) {
      return a && /^YG-DORO-/i.test(String((a.discount_application && a.discount_application.title) || ''));
    });
  }

  // διακρίβωση lines never take a preset above 10% (listen DIAKRIVOSI_MAX_DISCOUNT);
  // the type is folded like listen's _fold_greek, so a tonos can't slip past the cap.
  var DIAKRIVOSI_TYPE = 'διακριβωσεις', DIAKRIVOSI_MAX = 10;
  function foldGreek(s) {
    return String(s || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // Mirrors the backend line_discount(): percent off for one cart line.
  function lineDiscountPct(preset, vendor, variantId, productType) {
    if (variantId != null && offerIds[String(variantId)]) return 0;
    var pct = 0;
    if (preset === 'insize') {
      pct = (vendor || '').trim().toLowerCase() === 'insize' ? 25 : 20;
    } else if (preset === '20' || preset === '10' || preset === '5') {
      pct = parseInt(preset, 10);
    }
    if (foldGreek(productType) === DIAKRIVOSI_TYPE) pct = Math.min(pct, DIAKRIVOSI_MAX);
    return pct;
  }

  // WORK-233: {qty, code} — the pieces of a cart line a YG-DORO gift code made free, from
  // Shopify's own line allocations (the amount over the piece price before discounts).
  function giftPieces(i) {
    var unit = i.quantity > 0 && i.original_line_price ? i.original_line_price / i.quantity : 0;
    var amount = 0, code = '';
    (i.line_level_discount_allocations || []).forEach(function (a) {
      var title = String((a && a.discount_application && a.discount_application.title) || '');
      if (a && a.amount > 0 && /^YG-DORO-/i.test(title)) { amount += a.amount; code = code || title.toUpperCase(); }
    });
    var qty = unit > 0 ? Math.min(i.quantity, Math.round(amount / unit)) : 0;
    return { qty: qty, code: qty > 0 ? code : '' };
  }

  function formatMoney(cents, currency) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('el-GR', { style: 'currency', currency: currency || 'EUR' }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  // What the preset's % comes off for one line, as listen bills it: a box line
  // whose own % is above the box 10% has no box deal, so it starts from the full
  // 10-piece price (Box10.staffDiscountBase, WORK-295); else the cart line price.
  function discountBase(i, preset) {
    if (window.Box10 && window.Box10.staffDiscountBase) return window.Box10.staffDiscountBase(i, ownPct(i, preset));
    return i.final_line_price != null ? i.final_line_price : (i.price * i.quantity);
  }
  // The preset's % for one cart line: 0 on the pieces that earned a gift (WORK-295).
  function ownPct(i, preset) {
    return giftUsed(i) ? 0 : lineDiscountPct(preset, i.vendor, i.variant_id, i.product_type);
  }
  // The % off discountBase for one line: the preset's own %, except a box line keeps
  // its box 10% instead when that is not smaller (never both, WORK-295).
  function linePct(i, preset) {
    var own = ownPct(i, preset);
    return window.Box10 && window.Box10.staffLinePct ? window.Box10.staffLinePct(i, own) : own;
  }

  // Sum cart line totals (ex-VAT, as the storefront shows them) and the
  // same totals after applying the selected discount preset per line.
  function computeTotals(cart, preset) {
    var sub = 0, disc = 0;
    (cart.items || []).forEach(function (i) {
      sub += i.final_line_price != null ? i.final_line_price : (i.price * i.quantity);
      disc += discountBase(i, preset) * (1 - linePct(i, preset) / 100);
    });
    return { sub: sub, disc: Math.round(disc), currency: cart.currency || 'EUR' };
  }

  function init() {
    var panel = $('[data-staff-panel]');
    if (!panel) return;

    var customerFooter = $('[data-customer-footer]');
    if (customerFooter) customerFooter.hidden = true;   // full replace
    panel.hidden = false;

    // Widen the cart drawer for staff — CSS scopes the extra width to this class
    // (#cart-drawer.cart-drawer--staff), so customer carts stay the normal width.
    var staffCartDrawer = document.getElementById('cart-drawer');
    if (staffCartDrawer) staffCartDrawer.classList.add('cart-drawer--staff');

    var searchEl  = $('[data-staff-contact-search]', panel);
    var searchWrap = $('[data-staff-search-wrap]', panel);
    var resultsEl = $('[data-staff-contact-results]', panel);
    var selectedEl = $('[data-staff-contact-selected]', panel);
    var selNameEl = $('[data-staff-selected-name]', panel);
    var selSubEl  = $('[data-staff-selected-sub]', panel);
    var selPersonEl = $('[data-staff-selected-person]', panel);
    var selAddrEl = $('[data-staff-selected-address]', panel);
    var changeBtn = $('[data-staff-change]', panel);
    var discountEl = $('[data-staff-discount]', panel);
    var docEl     = $('[data-staff-doctype]', panel);
    var docBtns   = panel.querySelectorAll('[data-doctype]');
    var orderAllWrap = $('[data-staff-order-all-wrap]', panel);
    var orderAllEl = $('[data-staff-order-all]', panel);
    var createBtn = $('[data-staff-create]', panel);
    var createHintEl = $('[data-staff-create-hint]', panel);
    var catalogsEl = $('[data-staff-catalogs]', panel);
    var catalogData = null;      // /staff/contact-catalogs payload for `chosen`
    var catalogPicked = {};      // sku -> true while ticked (kept across tab switches)
    var catalogTab = 'lack';     // 'lack' (default) | 'got'
    var CATALOG_DOCS = { invoice: 1, receipt: 1, receipt_novat: 1 };
    var dlDsBtn = $('[data-staff-dl-datasheets]', panel);
    var dlMnBtn = $('[data-staff-dl-manuals]', panel);
    var dlDsCount = $('[data-staff-dl-datasheets-count]', panel);
    var dlMnCount = $('[data-staff-dl-manuals-count]', panel);
    var datasheetUrls = [];
    var manualUrls = [];
    var resultEl  = $('[data-staff-result]', panel);
    var totalsEl  = $('[data-staff-totals]', panel);
    var totalEl   = $('[data-staff-total]', panel);
    var totalDiscEl = $('[data-staff-total-discounted]', panel);
    var totalVatRowEl = $('[data-staff-total-vat-row]', panel);
    var totalVatEl = $('[data-staff-total-vat]', panel);
    var vatLabelEl = $('[data-staff-vat-label]', panel);
    var vatLabel24 = vatLabelEl ? vatLabelEl.textContent : '';   // «Σύνολο (με ΦΠΑ 24%)»
    // WORK-175: the chosen customer's VAT rate — 17 for a Zoho contact on
    // ΜΕΙΩΜΕΝΟ 17% (reduced-VAT islands; Zoho issues their documents at 17% by
    // itself), else 24. listen sends it with the contact's addresses (vat_pct).
    // window.StaffVatMult makes cart-drawer.js's per-line «incl. VAT» follow it;
    // unset (customers, 24%) it keeps its own ×1.24.
    var contactVatPct = 24;
    function vatMult() { return 1 + contactVatPct / 100; }
    function setContactVat(pct) {
      var p = pct === 17 ? 17 : 24;
      if (vatLabelEl) vatLabelEl.textContent = vatLabel24.replace('24%', p + '%');
      if (p === contactVatPct) return;
      contactVatPct = p;
      window.StaffVatMult = p === 24 ? undefined : vatMult();
      renderTotals();
      // refresh, not rerender: rerender paints the drawer's own cached cart, which can
      // be stale (empty) here; refresh re-reads /cart.js like the staff cart's other calls.
      if (window.CartDrawer && window.CartDrawer.refresh) window.CartDrawer.refresh();
    }
    var totalFinalRowEl = $('[data-staff-total-final-row]', panel);
    var totalFinalEl = $('[data-staff-total-final]', panel);
    var newBtn    = $('[data-staff-new]', panel);
    var newForm   = $('[data-staff-newform]', panel);
    var newSaveBtn = $('[data-staff-newform-save]', panel);
    var newBackBtn = $('[data-staff-newform-back]', panel);
    var newErr    = $('[data-staff-newform-error]', panel);
    var shipDiff  = $('[data-nc-shipdiff]', panel);
    var shipWrap  = $('[data-nc-shipwrap]', panel);
    var docTermsEl = $('[data-staff-docterms]', panel);
    var paymentEl = $('[data-staff-payment]', panel);
    var shippingMethodEl = $('[data-staff-shipping-method]', panel);
    var shippingNoteEl = $('[data-staff-shipping-note]', panel);
    var referenceWrapEl = $('[data-staff-reference-wrap]', panel);
    var referenceEl = $('[data-staff-reference]', panel);
    var refNudgeEl = $('[data-staff-ref-nudge]', panel);
    var refNudgeAddEl = $('[data-staff-ref-nudge-add]', panel);
    var retailBtn = $('[data-staff-retail]', panel);
    var adjustmentWrapEl = $('[data-staff-adjustment-wrap]', panel);
    var adjustmentEl = $('[data-staff-adjustment]', panel);
    var shipAddrWrap = $('[data-staff-ship-addr]', panel);
    var shipAddrList = $('[data-staff-ship-addr-list]', panel);
    var shipAddrNewBtn = $('[data-staff-ship-addr-newbtn]', panel);
    var shipAddrForm = $('[data-staff-ship-addr-form]', panel);
    var shipAddrSave = $('[data-staff-ship-addr-save]', panel);
    var shipAddrErr = $('[data-staff-ship-addr-err]', panel);
    var chosenAddrId = null;
    var lineNotes = {};      // cart line key -> staff note text
    var chosen    = null;
    var timer     = null;
    var cartCache = null;
    var totalsTimer = null;
    var cartObserver = null;
    var isStaffDragging = false;                 // set true during an active drag (Task 2)
    var ORDER_KEY = 'staffOrder.lineOrder.v1';
    function loadLineOrder() {
      try { return JSON.parse(sessionStorage.getItem(ORDER_KEY) || '[]'); } catch (e) { return []; }
    }
    function saveLineOrder(keys) {
      try { sessionStorage.setItem(ORDER_KEY, JSON.stringify(keys || [])); } catch (e) {}
    }
    // Representative key of a top-level cart unit (group wrapper or standalone item).
    function unitKey(unit) {
      if (!unit || unit.nodeType !== 1) return null;
      var el = unit.matches('[data-cart-key]') ? unit : unit.querySelector('[data-cart-key]');
      return el ? el.getAttribute('data-cart-key') : null;
    }
    // Reorder the top-level units to match the stored order. Unknown keys (new
    // lines) sort to the end; missing keys are ignored. No-op while dragging.
    function applyStoredOrder() {
      if (isStaffDragging) return;
      var container = document.querySelector('.cart-drawer__items');
      if (!container) return;
      var order = loadLineOrder();
      if (!order.length) return;
      var units = Array.prototype.slice.call(container.children);
      units.sort(function (a, b) {
        var ia = order.indexOf(unitKey(a)); if (ia === -1) ia = Infinity;
        var ib = order.indexOf(unitKey(b)); if (ib === -1) ib = Infinity;
        return ia - ib;
      });
      units.forEach(function (u) { container.appendChild(u); });
    }
    function isDesktop() {
      return !window.matchMedia || window.matchMedia('(min-width: 1025px)').matches;
    }
    function captureOrderFromDOM() {
      var container = document.querySelector('.cart-drawer__items');
      if (!container) return;
      var keys = Array.prototype.slice.call(container.children).map(unitKey).filter(Boolean);
      saveLineOrder(keys);
    }
    // The unit currently being dragged (module-scoped so dragover can move it).
    var draggingUnit = null;
    function getDragAfterElement(container, y) {
      var els = Array.prototype.slice.call(container.children).filter(function (c) { return c !== draggingUnit; });
      var closest = { offset: -Infinity, element: null };
      els.forEach(function (child) {
        var box = child.getBoundingClientRect();
        var offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) closest = { offset: offset, element: child };
      });
      return closest.element;
    }
    // Inject a drag handle into each top-level unit + wire native HTML5 DnD.
    // Desktop + staff only; only with 2+ units. Idempotent per render.
    function wireDrag() {
      if (!isDesktop()) return;
      var container = document.querySelector('.cart-drawer__items');
      if (!container) return;
      var units = Array.prototype.slice.call(container.children);
      if (units.length < 2) return;

      if (!container.__staffDragContainer) {
        container.__staffDragContainer = true;
        container.addEventListener('dragover', function (e) {
          if (!draggingUnit) return;
          e.preventDefault();
          var after = getDragAfterElement(container, e.clientY);
          if (after == null) container.appendChild(draggingUnit);
          else container.insertBefore(draggingUnit, after);
        });
      }

      units.forEach(function (unit) {
        if (unit.__staffDragWired) return;
        unit.__staffDragWired = true;
        unit.classList.add('staff-order__sortable');
        var handle = document.createElement('span');
        handle.className = 'staff-order__drag-handle';
        handle.setAttribute('aria-hidden', 'true');
        handle.setAttribute('title', tr('dragTitle', 'Σύρετε για αναδιάταξη'));
        handle.draggable = true;   // drag starts only from the handle
        handle.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="9" cy="6" r="1.6"/><circle cx="15" cy="6" r="1.6"/><circle cx="9" cy="12" r="1.6"/><circle cx="15" cy="12" r="1.6"/><circle cx="9" cy="18" r="1.6"/><circle cx="15" cy="18" r="1.6"/></svg>';
        unit.insertBefore(handle, unit.firstChild);

        handle.addEventListener('dragstart', function (e) {
          isStaffDragging = true;
          draggingUnit = unit;
          unit.classList.add('is-dragging');
          e.dataTransfer.effectAllowed = 'move';
          try { e.dataTransfer.setData('text/plain', unitKey(unit) || ''); } catch (err) {}
        });
        handle.addEventListener('dragend', function () {
          unit.classList.remove('is-dragging');
          draggingUnit = null;
          captureOrderFromDOM();
          isStaffDragging = false;
        });
      });
    }

    // Persist the selection across cart-drawer re-renders + page navigation (the
    // panel re-inits each time, losing in-memory state). sessionStorage clears on
    // tab close — a fresh staff session starts clean.
    var STORE_KEY = 'staffOrder.v1';
    var activeCase = null;      // {public_id, title, stage, closed} | null
    var caseItems = null;       // {variant_id: item} server mirror | null
    var syncPaused = false;     // pullIntoCart rewrites the cart; don't echo it back
    var cartSeen = {};          // variant_ids the cart actually held — a case item
                                // is only DELETEd on a present→absent transition, so
                                // an unpurchasable item the pull skipped stays put
    function saveState() {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ chosen: chosen, discount: discountEl.value, doc: docEl.value, shipping: shippingMethodEl ? shippingMethodEl.value : '', payment: paymentEl ? paymentEl.value : '', reference: referenceEl ? referenceEl.value : '', adjustment: adjustmentEl ? adjustmentEl.value : '', shipAddr: chosenAddrId, notes: lineNotes, activeCase: activeCase, caseItems: caseItems, cartSeen: cartSeen })); } catch (e) {}
    }
    function loadState() {
      try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
    }

    discountEl.value = 'none';   // default: no discount until a contact dictates one

    var _saved = loadState();
    if (_saved) {
      if (_saved.notes) lineNotes = _saved.notes;
      if (_saved.doc) docEl.value = _saved.doc;
      if (_saved.discount) discountEl.value = _saved.discount;
      if (_saved.shipping && shippingMethodEl) shippingMethodEl.value = _saved.shipping;
      if (_saved.payment && paymentEl) paymentEl.value = _saved.payment;
      if (_saved.reference && referenceEl) referenceEl.value = _saved.reference;
      if (_saved.adjustment && adjustmentEl) adjustmentEl.value = _saved.adjustment;
      if (_saved.shipAddr) chosenAddrId = _saved.shipAddr;
      if (_saved.chosen && _saved.chosen.contact_id) { chosen = _saved.chosen; renderSelected(chosen); loadShipAddresses(chosen.contact_id, _saved.shipAddr); loadCatalogs(chosen.contact_id); }
      if (_saved.activeCase) activeCase = _saved.activeCase;
      if (_saved.caseItems) caseItems = _saved.caseItems;
      if (_saved.cartSeen) cartSeen = _saved.cartSeen;
    }

    // ---- Staff extra lines (ORG-406) -------------------------------------------
    // A variant Shopify's cart refuses (stock ≤ 0 on a DENY vendor → /cart/add 422)
    // can still go on a quote / order / invoice. The variants table gives staff an
    // «add for quote» button on those rows; the line is held HERE, beside the Shopify
    // cart, in localStorage (the cookie cart's lifetime, shared across tabs).
    // withExtras() merges them into every cart object the panel reads, as pseudo-lines
    // keyed 'staffx:<variant_id>', so totals, discount badges, notes, drag order, case
    // sync and the create-doc payload treat them like any other line. listen needs
    // nothing new: Zoho lines resolve by SKU, and a Shopify draft order accepts a DENY
    // variant (draftOrderCalculate, 2026-10-03). The drawer rows are painted by this
    // file, never by cart-drawer.js, whose buttons only act on data-cart-* attributes.
    var EXTRA_KEY = 'staffOrder.extraLines.v1';
    var EXTRA_PREFIX = 'staffx:';
    var rawCart = null;          // last Shopify cart as fetched, before the merge
    function extraLabel(k) { return panel.getAttribute('data-extra-' + k) || ''; }
    function loadExtras() {
      try {
        var a = JSON.parse(localStorage.getItem(EXTRA_KEY) || '[]');
        return Array.isArray(a) ? a : [];
      } catch (e) { return []; }
    }
    function saveExtras(list) {
      try {
        if (list.length) localStorage.setItem(EXTRA_KEY, JSON.stringify(list));
        else localStorage.removeItem(EXTRA_KEY);
      } catch (e) {}
    }
    // ORG-162 phase 3: a vendor-pricelist line (kind 'pricelist') has no Shopify
    // variant, so an extra line is keyed by its variant id when it has one and by its
    // SKU otherwise. Every lookup, the 'staffx:' row key and the row handlers go
    // through this — an ORG-406 line keeps exactly the key it always had.
    function extraKey(x) {
      return x.variant_id ? String(x.variant_id) : 'sku:' + (x.sku || '');
    }
    function withExtras(cart) {
      var extras = loadExtras();
      if (!cart || !extras.length) return cart;
      var out = Object.assign({}, cart);
      var weight = cart.total_weight || 0;
      out.items = (cart.items || []).concat(extras.map(function (x) {
        var price = parseInt(x.price, 10) || 0;
        var qty = parseInt(x.qty, 10) || 1;
        weight += (parseInt(x.grams, 10) || 0) * qty;
        var line = {
          key: EXTRA_PREFIX + extraKey(x), product_id: x.product_id || '',
          sku: x.sku || '', quantity: qty, price: price, final_line_price: price * qty,
          vendor: x.vendor || '', product_type: x.product_type || '',
          product_title: x.title || x.sku || '', variant_title: x.variant_title || '',
          image: x.image || '', url: x.url || '', properties: {},
          staffExtra: true, delivery: x.delivery || '', kind: x.kind || ''
        };
        // Only a real (numeric) variant id becomes id/variant_id: a pricelist line has
        // none, and Number(undefined) would hand NaN to everything keyed by variant.
        if (/^\d+$/.test(String(x.variant_id || ''))) {
          line.id = Number(x.variant_id); line.variant_id = Number(x.variant_id);
        }
        if (x.kind === 'pricelist') {
          line.zoho = x.zoho || 'none'; line.status = x.status || '';
          line.eu_stock = x.eu_stock == null ? null : x.eu_stock;
        }
        return line;
      }));
      out.total_weight = weight;
      return out;
    }
    function extraQty(key) {
      var hit = loadExtras().filter(function (x) { return extraKey(x) === String(key); })[0];
      return hit ? (parseInt(hit.qty, 10) || 0) : 0;
    }
    // «+» count on the variants-table buttons, so staff see what is already held.
    function paintExtraCounts() {
      var by = {};
      loadExtras().forEach(function (x) { by[extraKey(x)] = parseInt(x.qty, 10) || 0; });
      document.querySelectorAll('[data-staff-extra-add]').forEach(function (b) {
        var n = by[b.getAttribute('data-variant-id')] || 0;
        var c = b.querySelector('[data-staff-extra-count]');
        b.classList.toggle('is-added', n > 0);
        if (c) { c.textContent = n ? String(n) : ''; c.hidden = !n; }
      });
    }
    function changeExtras(fn) {
      saveExtras(fn(loadExtras()).filter(function (x) { return (parseInt(x.qty, 10) || 0) > 0; }));
      paintExtraCounts();
      if (rawCart) applyCart(rawCart); else refreshTotals();
      injectLineNotes();
    }
    function addExtra(x, qty) {
      changeExtras(function (list) {
        var hit = list.filter(function (e) { return extraKey(e) === extraKey(x); })[0];
        if (hit) hit.qty = (parseInt(hit.qty, 10) || 0) + qty;
        else { x.qty = qty; list.push(x); }
        return list;
      });
    }
    function setExtraQty(key, qty) {
      changeExtras(function (list) {
        list.forEach(function (e) { if (extraKey(e) === String(key)) e.qty = qty; });
        return list;
      });
    }
    var EXTRA_TRASH = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
    // «Θα δημιουργηθεί στο Zoho μαζί με την προσφορά»: the document word follows the
    // chosen doc type (ORG-162).
    function plDocWord() { return plLabel('doc-' + docEl.value) || plLabel('doc-quote'); }
    function plZohoText() { return plLabel('line-zoho').replace('{doc}', plDocWord()); }
    function extraRowHtml(i, currency) {
      var rm = escapeHtml(extraLabel('remove'));
      var pl = i.kind === 'pricelist';
      // A pricelist line (ORG-162) is not on the site: no photo, no link, its own badge,
      // the vendor + EU stock, and what Zoho will do with it. The lead phrase is the
      // line's delivery text, painted by renderDeliveryNotes() like every other line.
      var image = pl
        ? '<div class="cart-drawer__item-image-wrap staff-order__pl-nophoto" aria-hidden="true"><span>' + escapeHtml(plLabel('no-photo')) + '</span></div>'
        : '<a class="cart-drawer__item-image-wrap" href="' + escapeHtml(i.url) + '" tabindex="-1" aria-hidden="true">'
          + (i.image ? '<img class="cart-drawer__item-image" src="' + escapeHtml(i.image) + '" alt="" loading="lazy">' : '')
          + '</a>';
      var title = pl
        ? '<span class="cart-drawer__item-title" title="' + escapeHtml(i.product_title) + '">' + escapeHtml(i.product_title) + '</span>'
        : '<a class="cart-drawer__item-title" href="' + escapeHtml(i.url) + '" title="' + escapeHtml(i.product_title) + '">' + escapeHtml(i.product_title) + '</a>';
      var plInfo = pl
        ? '<p class="staff-order__pl-meta" data-staffx-meta>' + escapeHtml([i.vendor, i.eu_stock != null ? 'EU: ' + i.eu_stock : ''].filter(Boolean).join(' · ')) + '</p>'
          + (i.zoho === 'none' ? '<p class="staff-order__pl-zoho" data-staffx-zoho>' + escapeHtml(plZohoText()) + '</p>' : '')
        : '';
      return '<div class="cart-drawer__item staff-order__extra' + (pl ? ' staff-order__extra--pl' : '') + '" data-staffx-row data-cart-key="' + escapeHtml(i.key) + '">'
        + image
        + '<div class="cart-drawer__item-details">'
        + '<p class="staff-order__extra-badge">' + escapeHtml(pl ? plLabel('line-badge') : extraLabel('badge')) + '</p>'
        + title
        + (i.sku ? '<p class="cart-drawer__item-sku"><span class="cart-drawer__item-sku-label">SKU:</span> ' + escapeHtml(i.sku) + '</p>' : '')
        + plInfo
        + '<div class="cart-drawer__item-bottom-row">'
        + '<div class="cart-drawer__qty" role="group">'
        + '<button type="button" data-staffx-minus aria-label="−">−</button>'
        + '<input class="cart-drawer__qty-value" type="number" min="0" step="1" inputmode="numeric" value="' + i.quantity + '" data-staffx-qty>'
        + '<button type="button" data-staffx-plus aria-label="+">+</button>'
        + '</div>'
        + '<button type="button" class="cart-drawer__item-remove" data-staffx-remove aria-label="' + rm + '" title="' + rm + '">' + EXTRA_TRASH + '</button>'
        + '</div></div>'
        + '<div class="cart-drawer__item-price"><div class="cart-drawer__item-line-price" data-staffx-price>'
        + extraPriceHtml(i, currency) + '</div></div>'
        + '</div>';
    }
    // Same stacked ex-VAT / incl-VAT markup + wording as cart-drawer.js renderItem(),
    // so an extra line can't be misread as a VAT-inclusive price.
    function extraPriceHtml(i, currency) {
      var S = window.CartDrawerStrings || {};
      return '<span class="vat-prices__line vat-prices__line--excl"><span class="money">' + formatMoney(i.final_line_price, currency)
        + '</span> <span class="vat-prices__tag">' + escapeHtml(S.vatExcl || '') + '</span></span>'
        + '<span class="vat-prices__line vat-prices__line--incl"><span class="money">' + formatMoney(Math.round(i.final_line_price * vatMult()), currency)
        + '</span> <span class="vat-prices__tag">' + escapeHtml(S.vatIncl || '') + '</span></span>';
    }
    // Paint / update / drop the extra rows in the drawer. Called from
    // renderLineDiscounts() while the cart observer is disconnected, and BEFORE the
    // stored drag order is applied, so the rows sort and wire like real lines. Rows
    // that already exist are updated in place (keeps an open note field alive).
    function renderExtraRows() {
      var body = document.querySelector('[data-cart-drawer-body]');
      if (!body || !cartCache) return;
      var extras = (cartCache.items || []).filter(function (i) { return i.staffExtra; });
      renderPricelistNote(extras);
      var container = body.querySelector('.cart-drawer__items');
      if (!container) {
        if (!extras.length) return;
        // The Shopify cart is empty, so cart-drawer.js painted its empty state.
        body.innerHTML = '<div class="cart-drawer__items"></div>';
        container = body.firstChild;
      }
      var want = {};
      extras.forEach(function (i) { want[i.key] = i; });
      container.querySelectorAll('[data-staffx-row]').forEach(function (row) {
        var i = want[row.getAttribute('data-cart-key')];
        if (!i) { row.remove(); return; }
        delete want[i.key];
        var q = row.querySelector('[data-staffx-qty]');
        if (q && document.activeElement !== q) q.value = i.quantity;
        var pr = row.querySelector('[data-staffx-price]');
        if (pr) pr.innerHTML = extraPriceHtml(i, cartCache.currency);
        var zn = row.querySelector('[data-staffx-zoho]');
        if (zn) zn.textContent = plZohoText();     // doc type may have changed
      });
      Object.keys(want).forEach(function (k) {
        container.insertAdjacentHTML('beforeend', extraRowHtml(want[k], cartCache.currency));
      });
      // Last extra gone and nothing from Shopify left: give the drawer its empty state back.
      if (!container.children.length && window.CartDrawer && window.CartDrawer.rerender) {
        window.CartDrawer.rerender();
      }
    }
    // Above Create: which pricelist lines listen will create in Zoho with this document.
    function renderPricelistNote(extras) {
      var el = panel.querySelector('[data-pl-note]');
      if (!el) return;
      var fresh = (extras || []).filter(function (i) { return i.kind === 'pricelist' && i.zoho === 'none'; });
      el.hidden = !fresh.length;
      if (!fresh.length) { el.textContent = ''; return; }
      el.textContent = plLabel(fresh.length === 1 ? 'note-one' : 'note-many')
        .replace('{n}', String(fresh.length))
        .replace('{skus}', fresh.map(function (i) { return i.sku; }).join(', '))
        .replace('{doc}', plDocWord());
    }
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-staff-extra-add]');
      if (add) {
        e.preventDefault();
        var d = add.dataset;
        addExtra({ variant_id: d.variantId, product_id: d.productId, sku: d.sku,
                   title: d.title, variant_title: d.variantTitle, price: d.price,
                   vendor: d.vendor, product_type: d.productType, grams: d.grams,
                   image: d.image, url: d.url, delivery: d.delivery }, 1);
        if (window.CartDrawer && window.CartDrawer.open) window.CartDrawer.open();
        return;
      }
      var row = e.target.closest('[data-staffx-row]');
      if (!row) return;
      var xk = row.getAttribute('data-cart-key').slice(EXTRA_PREFIX.length);   // extraKey()
      if (e.target.closest('[data-staffx-plus]')) { e.preventDefault(); setExtraQty(xk, extraQty(xk) + 1); }
      else if (e.target.closest('[data-staffx-minus]')) { e.preventDefault(); setExtraQty(xk, Math.max(0, extraQty(xk) - 1)); }
      else if (e.target.closest('[data-staffx-remove]')) { e.preventDefault(); setExtraQty(xk, 0); }
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-staffx-qty]')) return;
      var row = e.target.closest('[data-staffx-row]');
      if (!row) return;
      var v = parseInt(e.target.value, 10);
      setExtraQty(row.getAttribute('data-cart-key').slice(EXTRA_PREFIX.length), isNaN(v) || v < 0 ? 0 : v);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-staffx-qty]')) { e.preventDefault(); e.target.blur(); }
    });
    // Another tab changed the extras: repaint here too.
    window.addEventListener('storage', function (e) {
      if (e.key !== EXTRA_KEY) return;
      paintExtraCounts();
      if (rawCart) { applyCart(rawCart); injectLineNotes(); }
    });
    paintExtraCounts();

    // ---- Vendor pricelist rows (ORG-162 phase 3; in the quick-add search since WORK-299) ----
    // Any item of the vendor pricelists (calls GET /api/staff/pricelist-search, read-only)
    // that is not on the site shows in the quick-add dropdown, under the site's own hits
    // (qaRender). calls decides what a row may do (`add`: add / open / none + `why`) and
    // sends the ex-VAT list price and the cost; the cart applies the customer's preset itself
    // (lineDiscountPct), so a preset change repaints without a new search. Adding holds the
    // row as a staff extra line of kind 'pricelist', keyed by SKU (extraKey), whose delivery
    // phrase is calls' lead phrase; listen creates the Zoho item when the document is made.
    // The labels live on the hidden [data-pl] holder in snippets/staff-order-panel.liquid.
    function plLabel(k) {
      var box = panel.querySelector('[data-pl]');
      return (box && box.getAttribute('data-pl-' + k)) || '';
    }
    // The pricelist is reachable only through calls: a crmEndpoint and a live bearer.
    function plOn() { return !!(CRM && crmToken()); }
    function plMoney(cents) { return formatMoney(cents, (cartCache && cartCache.currency) || 'EUR'); }
    function plPct(x) {
      return x.toLocaleString('el-GR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';
    }
    function plListCents(r) { return Math.round((Number(r.list) || 0) * 100); }
    // Price after the customer's discount, margin and the cost basis, for one row.
    function plFigures(r) {
      var pct = lineDiscountPct(discountEl.value, r.vendor, null, r.product_type);
      var list = plListCents(r);
      var disc = Math.round(list * (1 - pct / 100));
      var cost = r.cost != null && Number(r.cost) > 0 ? Math.round(Number(r.cost) * 100) : null;
      var margin = (cost != null && disc > 0) ? (disc - cost) / disc * 100 : null;
      var basis = cost != null
        ? plLabel('basis-' + (r.cost_basis || 'net')).replace('{cost}', plMoney(cost))
        : plLabel('no-cost');
      return { pct: pct, list: list, disc: disc, margin: margin, basis: basis };
    }
    function plPriceHtml(r) {
      if (!(Number(r.list) > 0)) return '<span class="staff-order__pl-price">—</span>';
      var f = plFigures(r);
      var S = window.CartDrawerStrings || {};
      return '<span class="staff-order__pl-price" data-pl-price data-cents="' + f.disc + '">' + escapeHtml(plMoney(f.disc))
        + (S.vatExcl ? ' <span class="staff-order__pl-vat">' + escapeHtml(S.vatExcl) + '</span>' : '') + '</span>'
        + '<span class="staff-order__pl-list" data-pl-list>' + escapeHtml(plLabel('list')) + ' ' + escapeHtml(plMoney(f.list))
        + (f.pct ? ' · −' + f.pct + '%' : '') + '</span>'
        + '<span class="staff-order__pl-margin' + (f.margin != null && f.margin < 0 ? ' is-neg' : '')
        + '" data-pl-margin title="' + escapeHtml(f.basis) + '">' + escapeHtml(plLabel('margin')) + ' '
        + (f.margin == null ? '—' : escapeHtml(plPct(f.margin))) + '</span>';
    }
    // The extra line a pricelist row becomes.
    function plExtraOf(r) {
      return { kind: 'pricelist', sku: r.sku, title: r.title, vendor: r.vendor,
               product_type: r.product_type || '', price: String(plListCents(r)),
               delivery: (r.lead && r.lead.phrase) || '', zoho: r.zoho || 'none',
               status: r.status || '', eu_stock: r.eu_stock == null ? null : r.eu_stock };
    }

    // ---- Quick add by SKU / barcode (WORK-242) ----------------------------------
    // «Γρήγορη προσθήκη με κωδικό» (snippets/staff-quick-sku.liquid), pinned under the drawer
    // header. Lookup = the storefront predictive search on variants.sku + variants.barcode,
    // rendered as JSON by sections/staff-sku-lookup.liquid (no server of ours; active,
    // published products only). One code: suggestions while typing, Enter adds the
    // highlighted row (an exact match sorts first). Enter before the suggestions are on
    // screen (a barcode scanner types the code + Enter at once) waits for the lookup and adds
    // only an EXACT match. Several pasted codes: a check list, then one add. An available
    // variant goes to the Shopify cart; one the cart refuses becomes an ORG-406 extra line.
    // While the cart reaches calls (plOn), the same text also asks the vendor pricelists
    // (WORK-299): their rows that are not on the site follow the site's, in a second section
    // of the same dropdown, and ↑ ↓ / Enter move across both. Only a site variant is ever
    // added blind: the scanner path takes an exact site match or nothing, so a pricelist row
    // (a new Zoho item) always needs staff to see it highlighted. New lines join the END of the
    // line order, so the document lists them in the order the codes came in, and carry a
    // «ΜΟΛΙΣ ΠΡΟΣΤΕΘΗΚΕ» mark for a few seconds (qaPaintNew, run in renderLineDiscounts).
    var qa = document.querySelector('[data-staff-qa]');
    var qaIn = qa && $('[data-qa-input]', qa);
    var qaQty = qa && $('[data-qa-qty]', qa);
    var qaWrap = qa && $('[data-qa-wrap]', qa);
    var qaDrop = qa && $('[data-qa-drop]', qa);
    var qaList = qa && $('[data-qa-list]', qa);
    var qaSiteHead = qa && $('[data-qa-site-head]', qa);
    var qaPlSec = qa && $('[data-qa-pl-sec]', qa);
    var qaPlList = qa && $('[data-qa-pl-list]', qa);
    var qaPlMsg = qa && $('[data-qa-pl-msg]', qa);
    var qaPlVendor = qa && $('[data-qa-pl-vendor]', qa);
    var qaMoreEl = qa && $('[data-qa-more]', qa);
    var qaCheck = qa && $('[data-qa-check]', qa);
    var qaToast = qa && $('[data-qa-toast]', qa);
    var qaVs = [];            // every variant the last lookup returned
    var qaRows = [];          // the suggestions on screen (variants)
    var qaFor = null;         // the input text those suggestions answer
    var qaActive = -1;        // index into qaNav(): site rows first, then addable pricelist rows
    // The pricelist answer: rows not on the site, for the code `q` and supplier `vendor`.
    var qaPl = { rows: [], q: null, vendor: '', err: '' };
    var plSeq = 0, plTimer = null, plVendorsLoaded = false;
    var qaSeq = 0, qaTimer = null, qaToastTimer = null, qaNewTimer = null;
    var qaCache = {};         // normalised query -> Promise<variants>
    var qaNew = {};           // cart line key -> time its «just added» mark ends
    var qaItems = null;       // the pasted list's rows while the check list is open
    var QA_NEW_MS = 5000, QA_SHOW = 8;
    var QA_ICON = {
      ok: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>',
      warn: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
      no: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
      clock: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>',
      plus: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
    };
    function qaLabel(k) { return (qa && qa.getAttribute('data-ql-' + k)) || ''; }
    function qaNorm(s) { return String(s || '').toUpperCase().replace(/\s+/g, ' ').trim(); }
    function qaLoose(s) { return String(s || '').toUpperCase().replace(/[^0-9A-ZΑ-Ω]/g, ''); }
    // «IST-TA1S 3», «IST-TA1S*3», «IST-TA1S×3» → code + quantity. The whole text is tried as a
    // SKU first (qaMatch), because some SKUs end in a number after a space («PCE-MCM 10»).
    function qaParse(raw) {
      var s = String(raw || '').replace(/\s+/g, ' ').trim();
      var m = s.match(/^(.+?)\s*[*×]\s*(\d{1,4})$/) || s.match(/^(.+?) (\d{1,4})$/);
      return { code: s, head: m ? m[1].trim() : s, qty: m ? parseInt(m[2], 10) : 0 };
    }
    function qaLookup(q) {
      var key = qaNorm(q);
      if (qaCache[key]) return qaCache[key];
      var p = fetch(ROOT + 'search/suggest?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=10&resources[limit_scope]=each'
        + '&resources[options][fields]=variants.sku,variants.barcode&section_id=staff-sku-lookup',
        { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw r; return r.text(); })
        .then(function (html) {
          var m = html.match(/<script type="application\/json" data-staff-sku-json>([\s\S]*?)<\/script>/);
          var a = m ? JSON.parse(m[1]) : [];
          return a.filter(function (v) { return v && v.sku; });
        });
      qaCache[key] = p;
      p.catch(function () { delete qaCache[key]; });
      return p;
    }
    // The one variant this text names exactly (SKU or barcode; then ignoring spaces and
    // dashes, if that leaves exactly one), with the quantity the text carried.
    function qaExact(vs, code) {
      var c = qaNorm(code);
      var hit = vs.filter(function (v) { return qaNorm(v.sku) === c || (v.barcode && qaNorm(v.barcode) === c); })[0];
      if (hit) return hit;
      var l = qaLoose(code);
      var loose = l ? vs.filter(function (v) { return qaLoose(v.sku) === l; }) : [];
      return loose.length === 1 ? loose[0] : null;
    }
    function qaMatch(vs, raw) {
      var p = qaParse(raw);
      var v = qaExact(vs, p.code);
      if (v) return { v: v, qty: 0 };
      if (p.head !== p.code) { v = qaExact(vs, p.head); if (v) return { v: v, qty: p.qty }; }
      return null;
    }
    function qaSuggest(vs, raw) {
      var p = qaParse(raw);
      var exact = qaMatch(vs, raw);
      var needle = qaLoose(p.head), bar = p.head.replace(/\s/g, '');
      var out = [];
      vs.forEach(function (v, n) {
        var s = qaLoose(v.sku);
        var rank = exact && exact.v === v ? 0
          : (needle && s.indexOf(needle) === 0) || (v.barcode && String(v.barcode).indexOf(bar) === 0) ? 1
          : needle && s.indexOf(needle) > 0 ? 2 : -1;
        if (rank >= 0) out.push({ v: v, rank: rank, n: n });
      });
      out.sort(function (a, b) { return a.rank - b.rank || a.n - b.n; });
      return out.map(function (o) { return o.v; });
    }
    function qaMoney(cents) { return formatMoney(cents, (cartCache && cartCache.currency) || 'EUR'); }
    function qaStatusHtml(v) {
      var k = v.stock === 'out' ? 'out' : v.stock === 'stock' ? 'stock' : 'order';
      var icon = k === 'out' ? QA_ICON.warn : k === 'order' ? QA_ICON.clock : QA_ICON.ok;
      return '<span class="staff-qa__st staff-qa__st--' + k + '">' + icon + escapeHtml(qaLabel(k)) + '</span>';
    }
    function qaSkuHtml(sku, head) {
      var u = String(sku).toUpperCase(), h = qaNorm(head), at = h ? u.indexOf(h) : -1;
      if (at < 0) return escapeHtml(sku);
      return escapeHtml(sku.slice(0, at)) + '<mark>' + escapeHtml(sku.slice(at, at + h.length)) + '</mark>'
        + escapeHtml(sku.slice(at + h.length));
    }
    // A pasted code the site doesn't have: put it in the bar, whose dropdown asks the pricelist.
    function qaPlButton(code) {
      if (!plOn()) return '';
      return '<button type="button" class="staff-qa__pl" data-qa-pl="' + escapeHtml(code) + '">' + escapeHtml(qaLabel('pl')) + '</button>';
    }
    function qaOpen(open) {
      qaDrop.hidden = !open;
      qaIn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) { qaIn.removeAttribute('aria-activedescendant'); qaFor = null; }
    }
    // The pricelist rows that answer the text in the bar now (none while that answer is due).
    function qaPlShown() {
      return plOn() && qaPl.q === qaParse(qaIn.value).head && !qaPl.err ? qaPl.rows : [];
    }
    // The site rows that answer the text in the bar now (the pricelist can answer first).
    function qaSiteShown() { return qaFor === qaIn.value ? qaRows.slice(0, QA_SHOW) : []; }
    // What ↑ ↓ / Enter walk through: the site rows on screen, then the addable pricelist rows.
    function qaNav() {
      return qaSiteShown().map(function (v) { return { v: v }; })
        .concat(qaPlShown().filter(function (r) { return r.add === 'add'; }).map(function (r) { return { r: r }; }));
    }
    function qaPlRowHtml(r, n, head) {
      var ok = r.add === 'add';
      var chips = ['<span class="staff-order__pl-chip staff-order__pl-chip--' + (r.zoho === 'none' ? 'new' : 'zoho')
        + '" data-pl-presence>' + escapeHtml(qaLabel(r.zoho === 'none' ? 'pl-new' : 'pl-zoho')) + '</span>'];
      var lead = (r.lead && r.lead.phrase) || '';
      var eu = r.eu_stock != null ? r.vendor + ' EU: ' + r.eu_stock : '';
      if (eu || lead) {
        chips.push('<span class="staff-order__pl-chip staff-order__pl-chip--lead' + (r.lead && r.lead['class'] === 'ask' ? ' is-ask' : '')
          + '" data-pl-lead>' + escapeHtml([eu, lead].filter(Boolean).join(' · ')) + '</span>');
      }
      if (r.status && r.status !== 'stock' && r.status !== '–') {
        chips.push('<span class="staff-order__pl-chip staff-order__pl-chip--status" data-pl-status title="'
          + escapeHtml(plLabel('st-' + r.status) || r.status) + '">' + escapeHtml(r.status) + '</span>');
      }
      if (r.moq) chips.push('<span class="staff-order__pl-chip">' + escapeHtml(plLabel('moq')) + ' ' + escapeHtml(String(r.moq)) + '</span>');
      // A row calls won't let us add says why, in words, and is not a stop for ↑ ↓.
      if (!ok) chips.push('<span class="staff-order__pl-chip staff-order__pl-chip--why" data-pl-why>' + QA_ICON.no
        + escapeHtml(r.why || qaLabel('pl-off')) + '</span>');
      return '<li class="staff-qa__opt staff-qa__opt--pl' + (ok ? (n === qaActive ? ' is-active' : '') : ' is-off') + '"'
        + (ok ? ' role="option" id="staff-qa-opt-' + n + '" aria-selected="' + (n === qaActive) + '" data-qa-i="' + n + '"'
              : ' aria-disabled="true"')
        + ' data-pl-row data-sku="' + escapeHtml(r.sku) + '" data-pl-action="' + escapeHtml(r.add || 'none') + '">'
        + '<span class="staff-qa__main"><span class="staff-order__pl-id"><span class="staff-qa__sku">' + qaSkuHtml(r.sku, head) + '</span> · '
        + escapeHtml(r.vendor) + (r.vendor_sku ? ' <span class="staff-order__pl-vsku">(' + escapeHtml(r.vendor_sku) + ')</span>' : '') + '</span>'
        + '<span class="staff-order__pl-title" title="' + escapeHtml(r.title) + '">' + escapeHtml(r.title) + '</span>'
        + '<span class="staff-order__pl-chips">' + chips.join('') + '</span></span>'
        + '<span class="staff-qa__side staff-order__pl-side">' + plPriceHtml(r) + '</span></li>';
    }
    function qaRender() {
      var raw = qaIn.value, head = qaParse(raw).head;
      var S = window.CartDrawerStrings || {};
      var nav = qaNav();
      if (qaActive >= nav.length) qaActive = nav.length - 1;
      if (qaActive < 0 && nav.length) qaActive = 0;
      // Site section. Not answered yet (the pricelist can answer first): say so.
      var site = qaSiteShown();
      if (qaFor !== raw) {
        qaList.innerHTML = '<li class="staff-qa__wait">' + escapeHtml(qaLabel('searching')) + '</li>';
      } else if (!site.length) {
        qaList.innerHTML = '<li class="staff-qa__none" data-qa-none>' + QA_ICON.no
          + '<span>' + escapeHtml(qaLabel('none-msg')) + ' «' + escapeHtml(qaParse(raw).code) + '»</span></li>';
      } else {
        qaList.innerHTML = site.map(function (v, n) {
          var sub = [v.title, v.variant_title, v.vendor].filter(Boolean).join(' · ');
          return '<li class="staff-qa__opt' + (n === qaActive ? ' is-active' : '') + '" role="option" id="staff-qa-opt-' + n
            + '" aria-selected="' + (n === qaActive) + '" data-qa-i="' + n + '" data-sku="' + escapeHtml(v.sku) + '">'
            + '<span class="staff-qa__thumb">' + (v.image ? '<img src="' + escapeHtml(v.image) + '" alt="" loading="lazy">' : '') + '</span>'
            + '<span class="staff-qa__main"><span class="staff-qa__sku">' + qaSkuHtml(v.sku, head) + '</span>'
            + '<span class="staff-qa__sub" title="' + escapeHtml(sub) + '">' + escapeHtml(sub) + '</span></span>'
            + '<span class="staff-qa__side"><span class="staff-qa__price">' + escapeHtml(qaMoney(v.price))
            + (S.vatExcl ? ' <small>' + escapeHtml(S.vatExcl) + '</small>' : '') + '</span>' + qaStatusHtml(v) + '</span></li>';
        }).join('');
      }
      var more = qaFor === raw ? qaRows.length - QA_SHOW : 0;
      qaMoreEl.textContent = more > 0 ? qaLabel('more').replace('{n}', String(more)) : '';
      // Pricelist section: only while the cart reaches calls; headings only when it is there.
      var on = plOn();
      if (qaSiteHead) qaSiteHead.hidden = !on;
      if (qaPlSec) {
        qaPlSec.hidden = !on;
        var rows = qaPlShown(), answered = on && qaPl.q === head;
        var msg = !answered ? qaLabel('pl-searching')
          : qaPl.err ? qaPl.err
          : !rows.length ? plLabel('empty') + ' «' + head + '»' : '';
        qaPlMsg.hidden = !on || !msg;
        qaPlMsg.textContent = msg;
        qaPlMsg.classList.toggle('is-error', answered && !!qaPl.err);
        var n = site.length;
        qaPlList.innerHTML = rows.map(function (r) {
          var html = qaPlRowHtml(r, n, head);
          if (r.add === 'add') n++;
          return html;
        }).join('');
        qaPlList.hidden = !rows.length;
      }
      if (qaActive >= 0) qaIn.setAttribute('aria-activedescendant', 'staff-qa-opt-' + qaActive);
      else qaIn.removeAttribute('aria-activedescendant');
      qaOpen(true);
    }
    // A preset change moves the pricelist prices: repaint an open dropdown (no new request).
    function qaPlRepaint() {
      if (qaDrop && !qaDrop.hidden && qaPlShown().length) qaRender();
    }
    function qaShow(vs, raw) {
      qaVs = vs; qaFor = raw;
      qaRows = qaSuggest(vs, raw);
      qaActive = qaNav().length ? 0 : -1;
      qaRender();
      qaFor = raw;
    }
    function qaQtyVal() { var n = parseInt(qaQty.value, 10); return n > 0 ? n : 1; }
    // Ask the pricelist for the code in the bar (and the supplier picked), unless that answer is
    // already here. Late answers are dropped (plSeq); calls down → its own words, in the section.
    function plQuery() {
      clearTimeout(plTimer);
      var head = qaParse(qaIn.value).head;
      var vendor = qaPlVendor ? qaPlVendor.value : '';
      if (!plOn() || qaNorm(head).length < 2) { ++plSeq; qaPl = { rows: [], q: null, vendor: '', err: '' }; return; }
      if (qaPl.q === head && qaPl.vendor === vendor && !qaPl.err) return;
      var my = ++plSeq;
      qaPl = { rows: [], q: null, vendor: vendor, err: '' };
      plTimer = setTimeout(function () {
        crmFetch('/api/staff/pricelist-search?q=' + encodeURIComponent(head) + '&vendor=' + encodeURIComponent(vendor))
          .then(function (d) {
            if (my !== plSeq) return;
            qaPl = { rows: ((d && d.rows) || []).filter(function (r) { return !r.on_shop; }), q: head, vendor: vendor, err: '' };
            if (!qaDrop.hidden) qaRender();
          }, function (e) {
            if (my !== plSeq) return;
            if (e && e.status === 401) { qaPl = { rows: [], q: null, vendor: '', err: '' }; flashConnect(); return; }
            // 503 {detail: {code: 'ops_down', message}}: say it in the server's words.
            var body = (e && typeof e.json === 'function') ? e.json().catch(function () { return null; }) : Promise.resolve(null);
            return body.then(function (j) {
              if (my !== plSeq) return;
              qaPl = { rows: [], q: head, vendor: vendor, err: (j && j.detail && j.detail.message) || plLabel('down') };
              if (!qaDrop.hidden) qaRender();
            });
          });
      }, 250);
    }
    function plLoadVendors() {
      if (plVendorsLoaded || !qaPlVendor || !plOn()) return;
      plVendorsLoaded = true;
      crmFetch('/api/staff/pricelist-vendors')
        .then(function (d) {
          (d && d.vendors || []).forEach(function (v) {
            var o = document.createElement('option');
            o.value = v.vendor; o.textContent = v.vendor;
            qaPlVendor.appendChild(o);
          });
        })
        .catch(function () { plVendorsLoaded = false; });   // try again on the next focus
    }
    // The token went away (401, expiry) or came back: the pricelist section follows it.
    // renderCaseBox() calls this on every token change.
    function syncPricelistBox() {
      if (!qa || !qaDrop) return;
      if (!plOn()) { ++plSeq; clearTimeout(plTimer); qaPl = { rows: [], q: null, vendor: '', err: '' }; }
      else if (!qaDrop.hidden) plQuery();
      if (!qaDrop.hidden) qaRender();
    }
    function qaSearch() {
      clearTimeout(qaTimer);
      var raw = qaIn.value;
      var my = ++qaSeq;
      plQuery();
      if (qaNorm(raw).length < 2) { qaOpen(false); qaWrap.classList.remove('is-searching'); return; }
      qaTimer = setTimeout(function () {
        qaWrap.classList.add('is-searching');
        qaLookup(qaParse(raw).head).then(function (vs) {
          if (my === qaSeq) qaShow(vs, raw);
        }, function () {
          if (my !== qaSeq) return;
          qaFor = null;
          qaShowToast(qaLabel('down'), true);
        }).then(function () { if (my === qaSeq) qaWrap.classList.remove('is-searching'); });
      }, 180);
    }
    function qaEnter() {
      var raw = qaIn.value;
      if (!qaNorm(raw)) return;
      var nav = qaNav();
      if (qaFor === raw && qaActive >= 0 && nav[qaActive]) { qaPick(nav[qaActive]); return; }
      // Nothing on screen answers this text yet: look it up and take an exact SITE match only.
      clearTimeout(qaTimer);
      var my = ++qaSeq;
      plQuery();
      qaWrap.classList.add('is-searching');
      qaLookup(qaParse(raw).head).then(function (vs) {
        if (my !== qaSeq) return;
        var m = qaMatch(vs, raw);
        if (m) qaAddOne(m.v, m.qty || qaQtyVal());
        else qaShow(vs, raw);
      }, function () { if (my === qaSeq) qaShowToast(qaLabel('down'), true); })
        .then(function () { if (my === qaSeq) qaWrap.classList.remove('is-searching'); });
    }
    // it = one qaNav() entry: { v } a site variant, { r } a pricelist row.
    function qaPick(it) {
      if (!it) return;
      var raw = qaIn.value;
      if (it.r) {
        // «TF-125 3» = 3 pieces, unless the whole text is the SKU itself.
        var p = qaParse(raw);
        var qty = qaNorm(it.r.sku) !== qaNorm(p.code) && p.head !== p.code && p.qty ? p.qty : qaQtyVal();
        qaAddOne({ sku: it.r.sku, available: false, pl: plExtraOf(it.r) }, qty);
        return;
      }
      var m = qaMatch(qaVs, raw);
      qaAddOne(it.v, (m && m.v === it.v && m.qty) || qaQtyVal());
    }
    // Keys of the drawer's top-level units, in the order staff see them.
    function qaOrderNow() {
      var c = document.querySelector('.cart-drawer__items');
      return c ? Array.prototype.slice.call(c.children).map(unitKey).filter(Boolean) : [];
    }
    function qaExtraOf(v) {
      return { variant_id: String(v.variant_id), product_id: String(v.product_id), sku: v.sku,
               title: v.title, variant_title: v.variant_title || '', price: String(v.price),
               vendor: v.vendor || '', product_type: v.product_type || '', grams: String(v.grams || 0),
               image: v.image || '', url: v.url || '', delivery: v.delivery || '' };
    }
    function qaPostAdd(items) {
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items.map(function (it) { return { id: Number(it.v.variant_id), quantity: it.qty }; }) })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok) throw { status: r.status, message: d.description || d.message || String(r.status) };
          return d.items || [];
        });
      });
    }
    // Add [{v, qty}] in that order. Resolves to one {ok, key, prev, error} per item. Shopify
    // takes the cart's items in one call; if it refuses the batch, each goes alone so one
    // refusal (more than the stock of a DENY item) can't block the rest. Whether a line is
    // new, and its quantity before, come from Shopify's answer (the line's quantity after the
    // add), not from the drawer, which can still be painting an older cart.
    function qaPut(items) {
      var extrasBefore = {};
      loadExtras().forEach(function (x) { extrasBefore[extraKey(x)] = parseInt(x.qty, 10) || 0; });
      var res = items.map(function () { return { ok: false }; });
      var shop = [];
      items.forEach(function (it, n) { if (it.v.available) shop.push(n); });
      function took(lines, n) {
        var it = items[n];
        var line = lines.filter(function (l) { return String(l.variant_id || l.id) === String(it.v.variant_id); })[0];
        var prev = line ? Math.max(0, line.quantity - it.qty) : 0;
        res[n] = { ok: true, key: line && line.key, prev: prev, isNew: prev === 0 };
      }
      var step = !shop.length ? Promise.resolve()
        : qaPostAdd(shop.map(function (n) { return items[n]; })).then(function (lines) {
          shop.forEach(function (n) { took(lines, n); });
        }, function (err) {
          if (shop.length === 1) { res[shop[0]] = { ok: false, error: err.message }; return; }
          return shop.reduce(function (p, n) {
            return p.then(function () {
              return qaPostAdd([items[n]]).then(function (lines) { took(lines, n); },
                function (e) { res[n] = { ok: false, error: e.message }; });
            });
          }, Promise.resolve());
        });
      return step.then(function () {
        items.forEach(function (it, n) {
          if (it.v.available) return;
          // A pricelist row (qaPick) carries its line ready-made; a refused variant becomes one.
          var x = it.v.pl ? Object.assign({}, it.v.pl) : qaExtraOf(it.v), k = extraKey(x), prev = extrasBefore[k] || 0;
          addExtra(x, it.qty);
          res[n] = { ok: true, key: EXTRA_PREFIX + k, extra: k, prev: prev, isNew: prev === 0 };
        });
        var until = Date.now() + QA_NEW_MS;
        res.forEach(function (r) { if (r.ok && r.key) qaNew[r.key] = until; });
        clearTimeout(qaNewTimer);
        qaNewTimer = setTimeout(qaPaintNew, QA_NEW_MS + 50);
        var done = window.CartDrawer && window.CartDrawer.refresh ? window.CartDrawer.refresh() : Promise.resolve();
        return Promise.resolve(done).then(function () {
          // The drawer now shows the fresh cart. New lines go to the end, in the order given;
          // everything else keeps the place staff see it in.
          var fresh = res.filter(function (r) { return r.ok && r.key && r.isNew; }).map(function (r) { return r.key; });
          if (fresh.length) {
            saveLineOrder(qaOrderNow().filter(function (k) { return fresh.indexOf(k) === -1; }).concat(fresh));
            renderLineDiscounts();     // re-sorts with the observer off (applyStoredOrder)
          }
          var first = res.filter(function (r) { return r.ok && r.key; })[0];
          var row = first && document.querySelector('.cart-drawer__items [data-cart-key="' + (window.CSS && CSS.escape ? CSS.escape(first.key) : first.key) + '"]');
          if (row && row.scrollIntoView) {
            var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            row.scrollIntoView({ block: 'nearest', behavior: calm ? 'auto' : 'smooth' });
          }
          return res;
        });
      });
    }
    function qaUndo(r) {
      if (r.extra) { setExtraQty(r.extra, r.prev); return; }
      if (window.CartDrawer && window.CartDrawer.change) window.CartDrawer.change(r.key, r.prev);
    }
    function qaAddOne(v, qty) {
      qa.classList.add('is-busy');
      qaPut([{ v: v, qty: qty }]).then(function (res) {
        var r = res[0];
        if (!r.ok) { qaShowToast(qaLabel('error') + ' ' + (r.error || v.sku), true); return; }
        qaIn.value = ''; qaQty.value = '1';
        qaOpen(false); qaRows = []; qaVs = [];
        ++plSeq; clearTimeout(plTimer);   // an answer still due is for the code just added
        qaShowToast(qaLabel('added') + ' ' + v.sku + ' ×' + qty, false, r);
      }, function () { qaShowToast(qaLabel('error') + ' ' + v.sku, true); })
        .then(function () { qa.classList.remove('is-busy'); qaIn.focus(); });
    }
    function qaShowToast(text, isError, undo) {
      clearTimeout(qaToastTimer);
      qaToast.classList.toggle('is-error', !!isError);
      qaToast.innerHTML = (isError ? QA_ICON.no : QA_ICON.ok) + '<span>' + escapeHtml(text) + '</span>'
        + (undo ? '<button type="button" class="staff-qa__undo" data-qa-undo>' + escapeHtml(qaLabel('undo')) + '</button>' : '');
      qaToast.hidden = false;
      var b = qaToast.querySelector('[data-qa-undo]');
      if (b) b.addEventListener('click', function () { qaUndo(undo); qaToast.hidden = true; qaIn.focus(); });
      qaToastTimer = setTimeout(function () { qaToast.hidden = true; }, isError ? 8000 : 6000);
    }
    // The «just added» mark: a class on the row + a label staff-owned for the cart
    // observer (OWN_DOM), repainted on every render until it runs out.
    function qaPaintNew() {
      if (!qa) return;
      var now = Date.now();
      Object.keys(qaNew).forEach(function (k) { if (qaNew[k] < now) delete qaNew[k]; });
      document.querySelectorAll('.cart-drawer__items .cart-drawer__item[data-cart-key]').forEach(function (row) {
        var on = !!qaNew[row.getAttribute('data-cart-key')];
        row.classList.toggle('staff-qa-new', on);
        var tag = row.querySelector('[data-staff-qa-new]');
        if (on && !tag) row.insertAdjacentHTML('beforeend', '<span class="staff-qa-newtag" data-staff-qa-new>' + QA_ICON.plus + escapeHtml(qaLabel('new')) + '</span>');
        else if (!on && tag) tag.remove();
      });
    }
    // ---- pasted list -------------------------------------------------------------
    // Lines (or, with no line breaks, commas / semicolons). A spreadsheet row keeps its
    // first cell as the code and its first whole-number cell after it as the quantity.
    function qaSplit(t) {
      var parts = /[\r\n]/.test(t) ? t.split(/\r?\n|\r/) : t.split(/[;,]/);
      return parts.map(function (s) {
        if (s.indexOf('\t') === -1) return s.replace(/\s+/g, ' ').trim();
        var cells = s.split('\t').map(function (c) { return c.trim(); });
        var code = cells.shift() || '';
        var n = cells.filter(function (c) { return /^\d{1,4}$/.test(c); })[0];
        return code + (n ? ' *' + n : '');
      }).filter(Boolean).slice(0, 60);
    }
    function qaListStart(lines) {
      qaOpen(false);
      qaItems = lines.map(function (raw) {
        var p = qaParse(raw);
        return { raw: raw, code: p.head, qty: p.qty || 1, state: 'wait', v: null };
      });
      qaListRender();
      var queue = qaItems.slice();
      var mine = qaItems;
      function next() {
        var it = queue.shift();
        if (!it) return Promise.resolve();
        return qaLookup(qaParse(it.raw).head).then(function (vs) {
          var m = qaMatch(vs, it.raw);
          // A whole-line match («PCE-MCM 10» is a SKU) carries no quantity.
          if (m) { it.v = m.v; it.code = m.v.sku; it.qty = m.qty || 1; }
          it.state = !m ? 'none' : m.v.available ? 'ok' : 'out';
        }, function () { it.state = 'none'; }).then(function () { if (qaItems === mine) qaListRender(); return next(); });
      }
      Promise.all([next(), next(), next(), next()]);
    }
    function qaListRender() {
      if (!qaItems) { qaCheck.hidden = true; qaCheck.innerHTML = ''; return; }
      var count = { ok: 0, out: 0, none: 0, wait: 0, err: 0 };
      qaItems.forEach(function (it) { count[it.state]++; });
      var addable = qaItems.filter(function (it) { return (it.state === 'ok' || it.state === 'out') && it.qty > 0; }).length;
      var sum = [];
      function said(k, n) { return qaLabel(n === 1 ? k + '-1' : k).replace('{n}', n); }
      if (count.ok) sum.push(said('sum-found', count.ok));
      if (count.out) sum.push(said('sum-out', count.out));
      if (count.none + count.err) sum.push(said('sum-none', count.none + count.err));
      if (count.wait) sum.push(qaLabel('searching'));
      var rows = qaItems.map(function (it, n) {
        var st, sub;
        if (it.state === 'wait') { st = '<span class="staff-qa__st staff-qa__st--wait">' + escapeHtml(qaLabel('searching')) + '</span>'; sub = ''; }
        else if (it.state === 'none' || it.state === 'err') {
          st = '<span class="staff-qa__st staff-qa__st--none">' + QA_ICON.no + escapeHtml(qaLabel('none')) + '</span>';
          sub = it.error ? '<span class="staff-qa__chk-err">' + escapeHtml(qaLabel('error') + ' ' + it.error) + '</span>' : qaPlButton(qaParse(it.raw).head);
        } else {
          var out = it.state === 'out';
          st = '<span class="staff-qa__st staff-qa__st--' + (out ? 'out' : 'stock') + '">' + (out ? QA_ICON.warn : QA_ICON.ok)
            + escapeHtml(qaLabel(out ? 'out' : 'found')) + '</span>';
          sub = '<span class="staff-qa__sub">' + escapeHtml(out ? it.v.title + ' · ' + qaLabel('out-note') : it.v.title + ' · ' + qaMoney(it.v.price)) + '</span>';
        }
        return '<li class="staff-qa__chk-row is-' + it.state + '" data-qa-r="' + n + '">'
          + '<span class="staff-qa__main"><span class="staff-qa__sku">' + escapeHtml(it.code) + '</span>' + sub + '</span>'
          + '<input class="staff-qa__chk-qty" type="number" min="0" step="1" inputmode="numeric" value="' + it.qty + '" aria-label="' + escapeHtml(tr('pieces', 'Τεμάχια') + ' ' + it.code) + '" data-qa-rq>'
          + st + '</li>';
      }).join('');
      qaCheck.innerHTML = '<div class="staff-qa__chk-head"><span>' + escapeHtml(said('pasted', qaItems.length)) + '</span>'
        + '<span data-qa-sum>' + escapeHtml(sum.join(' · ')) + '</span></div>'
        + '<ul class="staff-qa__chk-list">' + rows + '</ul>'
        + '<div class="staff-qa__chk-foot">'
        + (addable ? '<button type="button" class="staff-qa__btn" data-qa-list-add' + (count.wait ? ' disabled' : '') + '>'
          + escapeHtml(addable === 1 ? qaLabel('add-1') : qaLabel('add-n').replace('{n}', addable)) + '</button>' : '')
        + '<button type="button" class="staff-qa__btn staff-qa__btn--ghost" data-qa-list-cancel>'
        + escapeHtml(addable ? qaLabel('cancel') : qaLabel('close')) + '</button></div>';
      qaCheck.hidden = false;
    }
    function qaListAdd() {
      var picked = qaItems.filter(function (it) { return (it.state === 'ok' || it.state === 'out') && it.qty > 0; });
      if (!picked.length) return;
      qa.classList.add('is-busy');
      qaPut(picked.map(function (it) { return { v: it.v, qty: it.qty }; })).then(function (res) {
        var added = 0;
        res.forEach(function (r, n) {
          if (r.ok) { picked[n].state = 'done'; added++; }
          else { picked[n].state = 'err'; picked[n].error = r.error || ''; }
        });
        qaItems = qaItems.filter(function (it) { return it.state !== 'done' && !(it.state !== 'none' && it.state !== 'err' && it.qty === 0); });
        if (!qaItems.length) qaItems = null;
        qaListRender();
        if (added) qaShowToast(qaLabel('added-n').replace('{n}', added), false);
      }).then(function () { qa.classList.remove('is-busy'); qaIn.focus(); });
    }
    // «Αναζήτηση στον τιμοκατάλογο» on a pasted code: the bar searches it (site + pricelist).
    function qaFind(code) {
      qaIn.value = code;
      qaFor = null;
      qaIn.focus();
      qaSearch();
    }
    if (qa && qaIn && qaDrop && qaCheck) {
      qa.hidden = false;
      qaIn.addEventListener('input', function () { qaFor = null; qaSearch(); });
      qaIn.addEventListener('paste', function (e) {
        var t = (e.clipboardData && e.clipboardData.getData('text')) || '';
        var lines = qaSplit(t);
        if (lines.length < 2) return;      // one code: paste it and search as if typed
        e.preventDefault();
        qaIn.value = '';
        qaListStart(lines);
      });
      qaIn.addEventListener('keydown', function (e) {
        var n = qaDrop.hidden ? 0 : qaNav().length;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!n) return;
          e.preventDefault();
          qaActive = (qaActive + (e.key === 'ArrowDown' ? 1 : -1) + n) % n;
          qaRender();
        } else if (e.key === 'Enter') {
          e.preventDefault();               // the /cart page wraps the drawer area in a form
          qaEnter();
        } else if (e.key === 'Escape') {
          if (!qaDrop.hidden) { e.stopPropagation(); qaOpen(false); }
          else if (qaIn.value) { e.stopPropagation(); qaIn.value = ''; qaSearch(); }
        }
      });
      qaQty.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); qaEnter(); }
        if (e.key === 'Escape') e.stopPropagation();
      });
      $('[data-qa-add]', qa).addEventListener('click', function () { qaEnter(); qaIn.focus(); });
      [qaList, qaPlList].forEach(function (ul) {
        if (!ul) return;
        ul.addEventListener('mousedown', function (e) { e.preventDefault(); });   // keep the focus in the field
        ul.addEventListener('click', function (e) {
          var li = e.target.closest('[data-qa-i]');
          if (li) qaPick(qaNav()[+li.getAttribute('data-qa-i')]);
        });
      });
      if (qaPlVendor) {
        qaPlVendor.addEventListener('change', function () { plQuery(); qaRender(); qaIn.focus(); });
        qaPlVendor.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { e.stopPropagation(); qaOpen(false); qaIn.focus(); }
        });
      }
      qaIn.addEventListener('blur', function () {
        setTimeout(function () { if (document.activeElement !== qaIn && !qa.contains(document.activeElement)) qaOpen(false); }, 150);
      });
      // Back in the field with a code still in it: show its answers again (cached, and the
      // pricelist is not asked twice), e.g. after picking a discount preset.
      qaIn.addEventListener('focus', function () {
        plLoadVendors();
        if (qaNorm(qaIn.value).length >= 2) qaSearch();
      });
      qaCheck.addEventListener('input', function (e) {
        if (!e.target.matches('[data-qa-rq]') || !qaItems) return;
        var it = qaItems[+e.target.closest('[data-qa-r]').getAttribute('data-qa-r')];
        var v = parseInt(e.target.value, 10);
        if (it) it.qty = isNaN(v) || v < 0 ? 0 : v;
        var sum = qaCheck.querySelector('[data-qa-list-add]');
        var addable = qaItems.filter(function (x) { return (x.state === 'ok' || x.state === 'out') && x.qty > 0; }).length;
        if (sum) sum.textContent = addable === 1 ? qaLabel('add-1') : qaLabel('add-n').replace('{n}', addable);
      });
      qaCheck.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('[data-qa-rq]')) { e.preventDefault(); e.target.blur(); }
        if (e.key === 'Escape') e.stopPropagation();
      });
      qaCheck.addEventListener('click', function (e) {
        if (e.target.closest('[data-qa-list-add]')) { qaListAdd(); return; }
        if (e.target.closest('[data-qa-list-cancel]')) { qaItems = null; qaListRender(); qaIn.focus(); return; }
        var pl = e.target.closest('[data-qa-pl]');
        if (pl) qaFind(pl.getAttribute('data-qa-pl'));
      });
      // «/» anywhere on the site (not while typing elsewhere): open the cart, focus the bar.
      document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        e.preventDefault();
        var drawer = document.getElementById('cart-drawer');
        if (drawer && !drawer.classList.contains('is-open') && window.CartDrawer && window.CartDrawer.open) window.CartDrawer.open();
        setTimeout(function () { qaIn.focus(); }, drawer && drawer.classList.contains('is-open') ? 0 : 320);
      });
    }

    // ---- active Case (client-side UI context; items are server-canonical) ----
    var caseBox = $('[data-case-box]', panel);
    var CASE_PICKER = false;   // ORG-772: the case pick button + chip, off until cases are used
    function caseLabel(k) { return panel.getAttribute('data-case-' + k) || k; }
    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;',
                 "'": '&#39;' }[c];
      });
    }

    function mirror(items) {
      var m = {};
      (items || []).forEach(function (i) { m[i.variant_id] = i; });
      return m;
    }

    function clearCase(noticeKey) {
      activeCase = null; caseItems = null; cartSeen = {};
      saveState();
      renderCaseBox(noticeKey ? caseLabel(noticeKey) : '');
    }

    // ---- Arriving from Missive «Add Shopify» or a calls case link (WORK-299) ----
    // Missive opens the store contact-first (staffMode=fresh, staffContact=<Zoho id>, plus
    // staffCase when the conversation has one); the calls app's buttons send staffCase alone.
    // Either can land on a cart that already holds another order — the lines live in the
    // cookie cart and localStorage, shared by every tab. So the arrival asks first, in a card
    // above the quick-add bar («Ήρθατε από Missive για …»), whenever there is something to
    // lose: lines in the cart, or another customer selected. «Νέο καλάθι» / «Άνοιξε την
    // υπόθεση» empties the whole order as «Άδειασμα» does (resetAll) before taking the new one;
    // «Κράτα τα είδη» keeps the lines and only changes the customer (or adds them to the case);
    // «Άκυρο» changes nothing. With nothing to lose it just goes ahead and says so in a note.
    // Mockup John picked 2026-10-26 (WORK-299). Until then Missive emptied the lines without
    // asking and kept the previous customer, discount and reference; calls used window.confirm.
    var arrBox = null;
    var ARR_ICON = {
      arrive: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>',
      ok: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>',
      x: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
    };
    function arrLabel(k) { return panel.getAttribute('data-arr-' + k) || ''; }
    function arrFill(t, map) { return t.replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
    function arrItems(n) { return n === 1 ? arrLabel('items-1') : arrLabel('items').replace('{n}', String(n)); }
    function arrClose() { if (arrBox) { arrBox.remove(); arrBox = null; } }
    function arrShow(cls, html) {
      arrClose();
      arrBox = document.createElement('div');
      arrBox.className = 'staff-arrive ' + cls;
      arrBox.setAttribute('data-staff-arrive', '');
      arrBox.setAttribute('role', 'region');
      arrBox.innerHTML = html;
      var bar = document.querySelector('[data-staff-qa]');
      if (bar && bar.parentNode) bar.parentNode.insertBefore(arrBox, bar);
      else panel.insertBefore(arrBox, panel.firstChild);
      return arrBox;
    }
    function arrNote(text) {
      var box = arrShow('staff-arrive--note', ARR_ICON.ok + '<span data-arrive-note>' + escapeHtml(text) + '</span>'
        + '<button type="button" class="staff-arrive__close" data-arrive-do="close" aria-label="' + escapeHtml(arrLabel('close')) + '">' + ARR_ICON.x + '</button>');
      box.querySelector('[data-arrive-do="close"]').addEventListener('click', arrClose);
    }
    // Open the drawer on the cart as it is now, so the lines show beside the question.
    function arrOpenDrawer() {
      if (window.CartDrawer && window.CartDrawer.open) window.CartDrawer.open();
      if (window.CartDrawer && window.CartDrawer.refresh) window.CartDrawer.refresh();
    }
    async function fetchContactById(contactId) {
      if (!contactId) return null;
      try {
        var r = await staffFetch('/staff/contact-by-id?contact_id=' + encodeURIComponent(contactId));
        var d = await r.json();
        return d && d.ok && d.match ? d.match : null;
      } catch (e) { return null; }   // the manual search is still there
    }
    // The whole order back to empty, as «Άδειασμα» does (cart-drawer.js: clear.js → reset).
    async function newOrder() {
      syncPaused = true;
      try { await fetch(ROOT + 'cart/clear.js', { method: 'POST', credentials: 'same-origin' }); }
      catch (e) { /* best-effort — a stale line is better than a dead boot */ }
      finally { syncPaused = false; }
      await resetAll();
    }
    // a = { pid: case number | null, contact: Zoho contact id | null, src: 'missive' | 'calls' }
    async function arrive(a) {
      var got = await Promise.all([
        fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); }).then(withExtras)
          .catch(function () { return { items: [] }; }),
        fetchContactById(a.contact),
        a.pid ? crmFetch('/api/cases/' + a.pid + '/items').catch(function (e) { return { failed: e }; }) : null
      ]);
      var items = (got[0] && got[0].items) || [];
      var target = got[1];
      var cs = got[2] && !got[2].failed ? got[2] : null;
      if (a.pid && !cs) {
        // A deleted/closed case (or calls down): carry on contact-first, and say so.
        if (got[2] && got[2].failed && got[2].failed.status === 401) return;
        renderCaseBox(caseLabel('gone'));
      }
      var cur = chosen;
      var same = !!(target && cur && String(cur.contact_id) === String(target.contact_id));
      var src = arrLabel('src-' + a.src);
      var caseId = cs && cs.case && cs.case.public_id;
      var caseN = cs ? (cs.items || []).length : 0;
      var who = target ? '«' + target.contact_name + '»' : '';
      var what = [who, caseId ? arrFill(arrLabel('case'), { id: caseId }) : ''].filter(Boolean).join(' · ')
        || arrLabel('new-order');
      function noteText() {
        if (target) return arrFill(arrLabel('note'), { who: target.contact_name, src: src });
        if (caseId) return arrFill(arrLabel('note-case'), { id: caseId, src: src });
        return arrFill(arrLabel('note-plain'), { src: src });
      }
      async function take(mode) {
        if (mode === 'new') {
          await newOrder();
          if (cs) await activateCase(a.pid, 'pull');   // the cart becomes the case's lines
        } else if (cs) {
          await activateCase(a.pid, 'import');          // the case gains the cart's lines
        }
        // Missive's matched contact is authoritative over whatever the case selected.
        if (target && !(chosen && String(chosen.contact_id) === String(target.contact_id))) selectContact(target);
        renderCaseBox();
        if (window.CartDrawer && window.CartDrawer.refresh) window.CartDrawer.refresh();
        arrNote(noteText());
      }

      if (!items.length && (!cur || same)) {   // nothing to lose: go ahead, say what happened
        await take('new');
        arrOpenDrawer();
        return;
      }

      // Something to lose: ask.
      var skus = items.slice(0, 3).map(function (i) { return i.sku || i.product_title; }).filter(Boolean).join(', ')
        + (items.length > 3 ? ', …' : '');
      var now = items.length
        ? arrFill(arrLabel(cur ? 'cart-for' : 'cart'), { items: arrItems(items.length), cur: cur ? cur.contact_name : '', skus: skus })
        : arrFill(arrLabel('cust-only'), { cur: cur.contact_name });
      var opts = [];
      if (cs) {
        opts.push({ act: 'new', label: arrFill(arrLabel('open-case'), { id: caseId }),
                    sub: arrFill(arrLabel('open-case-sub'), { items: arrItems(caseN) }) });
        if (items.length) opts.push({ act: 'keep', label: arrFill(arrLabel('import'), { items: arrItems(items.length) }),
                                      sub: arrFill(arrLabel('import-sub'), { items: arrItems(caseN) }) });
      } else {
        opts.push({ act: 'new', label: target ? arrFill(arrLabel('new'), { who: who }) : arrLabel('new-plain'),
                    sub: arrLabel('new-sub') });
        if (target && items.length) opts.push({ act: 'keep', label: arrFill(arrLabel('keep'), { items: arrItems(items.length), who: who }),
                                                sub: arrLabel(same ? 'keep-same-sub' : 'keep-sub') });
      }
      opts.push({ act: 'cancel', label: cur ? arrFill(arrLabel('cancel-cur'), { cur: cur.contact_name }) : arrLabel('cancel'),
                  sub: arrLabel('cancel-sub') });
      var box = arrShow('staff-arrive--ask',
        '<div class="staff-arrive__head">' + ARR_ICON.arrive + '<div>'
        + '<p class="staff-arrive__title" data-arrive-title>' + escapeHtml(arrFill(arrLabel('title'), { src: src, what: what })) + '</p>'
        + (cs ? '<p class="staff-arrive__text" data-arrive-case>' + escapeHtml(arrFill(arrLabel('case-has'), { id: caseId, items: arrItems(caseN) })) + '</p>' : '')
        + '<p class="staff-arrive__text" data-arrive-now>' + escapeHtml(now) + '</p></div></div>'
        + '<div class="staff-arrive__opts">' + opts.map(function (o, n) {
          return '<button type="button" class="staff-arrive__opt' + (n === 0 ? ' is-primary' : '') + '" data-arrive-do="' + o.act + '">'
            + '<span class="staff-arrive__opt-label">' + escapeHtml(o.label) + '</span>'
            + '<span class="staff-arrive__opt-sub">' + escapeHtml(o.sub) + '</span></button>';
        }).join('') + '</div>');
      box.querySelectorAll('[data-arrive-do]').forEach(function (b) {
        b.addEventListener('click', function () {
          var act = b.getAttribute('data-arrive-do');
          if (act === 'cancel') { arrClose(); return; }
          box.querySelectorAll('[data-arrive-do]').forEach(function (x) { x.disabled = true; });
          box.classList.add('is-busy');
          take(act).catch(function () { arrClose(); });
        });
      });
      arrOpenDrawer();
      setTimeout(function () { var p = box.querySelector('.is-primary'); if (p && arrBox === box) p.focus(); }, 350);
    }

    renderCaseBox = function (notice) {
      syncPricelistBox();
      if (!caseBox || !CRM) return;
      var html = '';
      if (!crmToken()) {
        // Connecting is a precondition for the whole panel, not the optional
        // case pick it used to look like — so it gets its own solid styling and
        // a line saying what stops working without it. Staff don't know what a
        // "CRM" is; the copy talks about searching customers instead.
        html = '<button type="button" data-case-do="connect"'
          + ' class="staff-order__case-btn staff-order__case-btn--connect">'
          + escapeHtml(caseLabel('connect')) + '</button>'
          + '<div class="staff-order__case-hint">'
          + escapeHtml(caseLabel('connect_hint')) + '</div>';
      } else if (!CASE_PICKER) {
        // ORG-772: cases are not in use yet, so a connected box draws nothing (no
        // «Επιλογή υπόθεσης», no case chip, even for a stale activeCase in
        // sessionStorage). The pick/chip markup below stays for when they return.
      } else if (!activeCase) {
        html = '<button type="button" data-case-do="pick" class="staff-order__case-btn">'
          + escapeHtml(caseLabel('select')) + '</button>';
      } else {
        html = '<div class="staff-order__case-chip"><b>#' + escapeHtml(activeCase.public_id) + '</b> '
          + escapeHtml(activeCase.title || '')
          + ' <button type="button" data-case-do="pick" class="staff-order__case-link">'
          + escapeHtml(caseLabel('change'))
          + '</button> <button type="button" data-case-do="clear" class="staff-order__case-link">'
          + escapeHtml(caseLabel('clear')) + '</button></div>';
      }
      if (notice) html += '<div class="staff-order__case-note">' + escapeHtml(notice) + '</div>';
      caseBox.innerHTML = html;
      // Locked until connected: everything under the case box is dimmed and
      // inert, so Connect is the only thing in the panel that can be clicked.
      panel.classList.toggle('is-locked', !crmToken());
      caseBox.querySelectorAll('[data-case-do]').forEach(function (b) {
        b.addEventListener('click', function () {
          var act = b.getAttribute('data-case-do');
          if (act === 'connect') connectPopup();
          if (act === 'clear') clearCase();
          if (act === 'pick') openCasePicker();
        });
      });
    };

    // The locked controls are pointer-events:none, so a click on any of them
    // lands here on the panel itself — answer it by pulsing the one thing that
    // is still live rather than letting the tap vanish.
    panel.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-locked')) return;
      if (caseBox && caseBox.contains(e.target)) return;
      flashConnect();
    });

    function openCasePicker() {
      if (!crmToken()) { connectPopup(); return; }
      caseBox.innerHTML = '<input type="text" class="staff-order__input" data-case-q placeholder="'
        + escapeHtml(caseLabel('search'))
        + '"><ul class="staff-order__results" data-case-results></ul>';
      var inp = caseBox.querySelector('[data-case-q]');
      var ul = caseBox.querySelector('[data-case-results]');
      // The full open-case list shows immediately; typing narrows it.
      // seq drops out-of-order responses (same shape as cartSeq).
      var seq = 0;
      function load(q) {
        var mySeq = ++seq;
        crmFetch('/api/cases?filter=open&q=' + encodeURIComponent(q))
          .then(function (d) {
            if (mySeq !== seq) return;
            ul.innerHTML = '';
            (d.cases || []).forEach(function (c) {
              var li = document.createElement('li');
              li.className = 'staff-order__result-item';
              li.textContent = '#' + c.public_id + ' ' + (c.title || '') + ' — '
                + (c.party_name || c.party_phone || '');
              li.addEventListener('click', function () {
                activateCase(c.public_id, null);
              });
              ul.appendChild(li);
            });
            if (!(d.cases || []).length) {
              var none = document.createElement('li');
              none.className = 'staff-order__result-empty';
              none.textContent = '—';
              ul.appendChild(none);
            }
            ul.hidden = false;
          })
          .catch(function () { /* 401 already re-rendered the box */ });
      }
      var t = null;
      inp.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { load(inp.value.trim()); }, 250);
      });
      load('');
      inp.focus();
      // Round trip (spec 2026-08-20 §31): creating a NEW case lives in the
      // CRM, so this row only opens it prefilled — no form grows here.
      var mk = document.createElement('button');
      mk.type = 'button';
      mk.className = 'staff-order__case-link staff-order__case-create';
      mk.textContent = caseLabel('createnew');
      mk.addEventListener('click', createCaseInCrm);
      caseBox.appendChild(mk);
    }

    async function createCaseInCrm() {
      var cart = withExtras(await fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }));
      var lines = (cart.items || []).filter(function (li) { return li.kind !== 'pricelist'; }).map(function (li) {
        return { variant_id: String(li.variant_id),
                 product_id: String(li.product_id || ''), sku: li.sku,
                 title: li.product_title, unit_price: li.price / 100,
                 qty: li.quantity };
      });
      // Carry the selected customer so the CRM modal opens pre-linked with a
      // sensible title, instead of a blank «New case» the staffer must name
      // and re-pick (polish 2026-08-25). No customer selected -> lines only,
      // as before.
      var qs = 'from=cart&lines=' + encodeURIComponent(JSON.stringify(lines));
      if (chosen && chosen.contact_id) {
        qs += '&contact_id=' + encodeURIComponent(chosen.contact_id)
            + '&contact_name=' + encodeURIComponent(chosen.contact_name || '');
      }
      var url = CRM + '/cases/new?' + qs;
      // A URL past ~6KB risks server header limits; not a real staff cart.
      if (url.length > 6000) { renderCaseBox(caseLabel('toolong')); return; }
      window.open(url, '_blank');
      renderCaseBox();
    }

    async function activateCase(pid, mode) {
      var d;
      try { d = await crmFetch('/api/cases/' + pid + '/items'); }
      catch (e) { if (e.status !== 401) clearCase('gone'); return; }
      var cart = withExtras(await fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }));
      if (mode === null) {
        if (!cart.items.length) mode = 'pull';
        else mode = window.confirm(caseLabel('add') + ';\nOK = ' + caseLabel('add')
          + ' / Cancel = ' + caseLabel('use')) ? 'import' : 'pull';
      }
      if (mode === 'import' && cart.items.length) {
        var lines = cart.items.filter(function (li) { return li.kind !== 'pricelist'; }).map(function (li) {
          return { variant_id: String(li.variant_id),
                   product_id: String(li.product_id || ''), sku: li.sku,
                   title: li.product_title, unit_price: li.price / 100,
                   qty: li.quantity };
        });
        try {
          await crmFetch('/api/cases/' + pid + '/items/import',
            { method: 'POST', body: JSON.stringify({ lines: lines }) });
        } catch (e) { renderCaseBox(caseLabel('err')); return; }
      }
      var fresh;
      try { fresh = await crmFetch('/api/cases/' + pid + '/items'); }
      catch (e) { clearCase('gone'); return; }
      activeCase = fresh.case;
      caseItems = mirror(fresh.items);
      saveState();
      await pullIntoCart(fresh.items, mode === 'import');
      // Auto-select the case's linked customer (2026-08-24): the case carries
      // zoho_contact_id from the CRM/Missive, and the document this cart will
      // create should go to that customer — staff shouldn't re-search someone
      // the case already names. selectContact() brings the whole prefill
      // (discount, courier, payment terms, ship addresses) exactly as a
      // manual pick would. The case is the authority: a mismatched earlier
      // selection is replaced. Best-effort — tokenless/network failure just
      // leaves the manual search, which is where staff were anyway.
      var caseCid = fresh.case && fresh.case.zoho_contact_id;
      if (caseCid && (!chosen || String(chosen.contact_id) !== String(caseCid))) {
        try {
          var cbr = await staffFetch('/staff/contact-by-id?contact_id='
            + encodeURIComponent(caseCid));
          var cbd = await cbr.json();
          if (cbd && cbd.ok && cbd.match) selectContact(cbd.match);
        } catch (e) { /* manual search still available */ }
      }
      renderCaseBox();
    }

    // keepPl: the case took the cart's lines (import), so the pricelist lines it cannot hold
    // (no variant id, ORG-162) stay in the cart beside the case's.
    async function pullIntoCart(items, keepPl) {
      syncPaused = true;
      var skipped = 0;
      var seen = {};
      var extras = [];   // ORG-406: what Shopify refuses is held as a staff extra line
      try {
        await fetch(ROOT + 'cart/clear.js', { method: 'POST', credentials: 'same-origin' });
        for (var k = 0; k < items.length; k++) {
          var i = items[k];
          var r = await fetch(ROOT + 'cart/add.js', { method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(i.variant_id),
                                             quantity: i.qty }] }) });
          if (r.ok) { seen[i.variant_id] = true; continue; }
          if (r.status === 422 && i.sku) {
            // Unavailable in the storefront cart, but still quotable: keep it as an
            // extra line so it reaches the document (and stays synced to the Case).
            extras.push({ variant_id: String(i.variant_id), product_id: String(i.product_id || ''),
                          sku: i.sku, title: i.title || i.sku,
                          price: Math.round((parseFloat(i.unit_price) || 0) * 100), qty: i.qty });
            seen[i.variant_id] = true;
          } else {
            skipped++;                   // unknown/deleted variant: stays on the Case
          }
        }
      } finally {
        if (keepPl) extras = extras.concat(loadExtras().filter(function (x) { return x.kind === 'pricelist'; }));
        syncPaused = false; cartSeen = seen; saveExtras(extras); paintExtraCounts(); saveState();
      }
      if (skipped) renderCaseBox(caseLabel('skip'));
      if (window.CartDrawer && window.CartDrawer.refresh) window.CartDrawer.refresh();
    }

    // ---- attached mode: every cart change writes through to the Case ----
    var syncTimers = {};

    function putCaseItem(v, line) {
      crmFetch('/api/cases/' + activeCase.public_id + '/items/'
        + encodeURIComponent(v),
        { method: 'PUT', body: JSON.stringify(line) })
        .then(function (d) { if (caseItems) { caseItems[v] = d.item; saveState(); } })
        .catch(function (e) { if (e.status !== 401) renderCaseBox(caseLabel('err')); });
    }

    async function syncCaseFromCart(cart) {
      if (!activeCase || !caseItems || syncPaused || !crmToken()) return;
      if (!cart) {
        try {
          cart = withExtras(await fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); }));
        } catch (e) { return; }
      }
      var now = {};
      (cart.items || []).forEach(function (li) {
        // Case items are keyed by variant id; a pricelist line has none (ORG-162, ISSUES).
        if (li.kind === 'pricelist') return;
        now[String(li.variant_id)] = {
          qty: li.quantity, sku: li.sku, product_id: String(li.product_id),
          title: li.product_title, unit_price: li.price / 100 };
      });
      Object.keys(now).forEach(function (v) {
        var server = caseItems[v];
        if (!server || server.qty !== now[v].qty) {
          clearTimeout(syncTimers[v]);
          syncTimers[v] = setTimeout(function () { putCaseItem(v, now[v]); }, 600);
        }
      });
      Object.keys(caseItems).forEach(function (v) {
        if (v in now) return;
        if (!cartSeen[v]) return;   // the cart never held it (unpurchasable pull skip)
        clearTimeout(syncTimers[v]);
        delete caseItems[v];
        crmFetch('/api/cases/' + activeCase.public_id + '/items/'
          + encodeURIComponent(v), { method: 'DELETE' })
          .catch(function (e) { if (e.status !== 401) renderCaseBox(caseLabel('err')); });
      });
      cartSeen = {};
      Object.keys(now).forEach(function (v) { cartSeen[v] = true; });
      saveState();
    }

    // Boot revalidation (spec rule 4): deep-link params first, then a
    // rehydrated case is re-fetched so a deleted/closed one clears itself.
    (async function caseBoot() {
      if (!CRM || !caseBox) return;
      var u = new URL(location.href);
      var pid = u.searchParams.get('staffCase');
      var code = u.searchParams.get('staffCode');
      // staffMode=fresh = Missive's «Add Shopify» (staffContact = the conversation's matched
      // contact, staffCase when it already had a case); staffCase alone = the calls app's
      // buttons. Either arrival goes through arrive(), which asks before it replaces an order.
      var fmode = u.searchParams.get('staffMode');
      var contact = u.searchParams.get('staffContact');
      if (pid || code || fmode || contact) {
        u.searchParams.delete('staffCase'); u.searchParams.delete('staffCode');
        u.searchParams.delete('staffMode'); u.searchParams.delete('staffContact');
        history.replaceState(null, '', u.pathname
          + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '')
          + u.hash);
      }
      if (code) await exchangeCode(code);
      // Staff reload pages constantly, so the load-time check does most of the
      // work; the poll only matters for a tab left open across the threshold.
      maybeRenew();
      setInterval(maybeRenew, RENEW_POLL_MS);
      if ((pid || fmode === 'fresh') && crmToken()) {
        await arrive({ pid: pid ? parseInt(pid, 10) : null, contact: contact,
                       src: fmode === 'fresh' ? 'missive' : 'calls' });
      } else if (activeCase && crmToken()) {
        try {
          var d = await crmFetch('/api/cases/' + activeCase.public_id + '/items');
          activeCase = d.case; caseItems = mirror(d.items); saveState();
          renderCaseBox();
        } catch (e) { if (e.status !== 401) clearCase('gone'); }
      } else {
        renderCaseBox();
      }
    })();

    // Round trip (spec 2026-08-20): the CRM tab createCaseInCrm opened
    // announces the case it just created; attach exactly as if it had been
    // picked from the picker — import is idempotent (the CRM already
    // imported these lines), then the normal pull leaves the cart
    // identical but attached.
    window.addEventListener('message', function (e) {
      if (!CRM_ORIGIN || e.origin !== CRM_ORIGIN) return;
      var d = e.data;
      if (!d || d.type !== 'staff-case-created') return;
      activateCase(parseInt(d.public_id, 10), 'import');
    });

    function renderTotals() {
      if (!cartCache || !totalsEl) return;
      var t = computeTotals(cartCache, discountEl.value);
      if (totalEl) totalEl.textContent = formatMoney(t.sub, t.currency);
      // No discount selected (or none applied) → show a dash, not a repeat.
      if (totalDiscEl) totalDiscEl.textContent = (t.disc === t.sub) ? '—' : formatMoney(t.disc, t.currency);
      // Incl-VAT preview of the after-discount total (products only — a charged
      // shipping line is priced server-side and isn't included here). Hidden for
      // the no-VAT receipt; the customer's rate (vatMult, WORK-175), as in the
      // free-shipping computation below.
      var dt = docEl.value;
      var vatApplies = dt !== 'receipt_novat';
      var incl = Math.round(t.disc * vatMult());
      if (totalVatRowEl) totalVatRowEl.hidden = !vatApplies;
      if (totalVatEl && vatApplies) totalVatEl.textContent = formatMoney(incl, t.currency);
      // Final amount after the staff-typed «Προσαρμογή» — on the incl-VAT total
      // where VAT applies (Zoho adds the adjustment after tax), else on the
      // ex-VAT total. Only for the doc types that send the adjustment.
      var adjVal = adjustmentEl ? parseFloat(adjustmentEl.value) : NaN;
      var showFinal = (dt === 'invoice' || dt === 'receipt' || dt === 'receipt_novat') && adjVal && isFinite(adjVal);
      if (totalFinalRowEl) totalFinalRowEl.hidden = !showFinal;
      if (totalFinalEl && showFinal) {
        totalFinalEl.textContent = formatMoney((vatApplies ? incl : t.disc) + Math.round(adjVal * 100), t.currency);
      }
      totalsEl.hidden = (cartCache.items || []).length === 0;
      qaPlRepaint();           // the pricelist rows follow the preset too (ORG-162)
      renderLineDiscounts();
      renderShippingNote();
    }

    // --- Shipping method / free-shipping logic -------------------------------
    // Free shipping when the after-discount, VAT-inclusive total reaches €80 AND
    // the cart weighs ≤ 7 kg. Only chargeable methods (option carries a
    // data-ship-sku) are affected; ΧΠ / pickup / no-item methods never charge.
    // Weight lives only in the Shopify cart, so this decision is client-side; the
    // backend trusts the resulting charge_shipping flag and owns the SKU mapping.
    var FREE_SHIP_MIN_INCL = 80;     // € incl VAT, after discount
    var FREE_SHIP_MAX_KG = 7;        // kg
    function selectedShipOption() {
      if (!shippingMethodEl) return null;
      return shippingMethodEl.options[shippingMethodEl.selectedIndex] || null;
    }
    function computeShipping(cart) {
      var opt = selectedShipOption();
      var sku = opt ? (opt.getAttribute('data-ship-sku') || '') : '';
      var t = computeTotals(cart || { items: [] }, discountEl.value);
      var inclAfterDiscount = (t.disc / 100) * vatMult();
      var weightKg = ((cart && cart.total_weight) || 0) / 1000;
      var heavy = weightKg > FREE_SHIP_MAX_KG;
      var chargeable = !!sku;
      var free = chargeable && inclAfterDiscount >= FREE_SHIP_MIN_INCL && !heavy;
      return {
        method: shippingMethodEl ? shippingMethodEl.value : '',
        sku: sku, chargeable: chargeable, free: free, heavy: heavy,
        weightKg: weightKg, charge: chargeable && !free
      };
    }
    function renderShippingNote() {
      if (!shippingNoteEl) return;
      var method = shippingMethodEl ? shippingMethodEl.value : '';
      if (!method || !cartCache) { shippingNoteEl.hidden = true; shippingNoteEl.textContent = ''; return; }
      var s = computeShipping(cartCache);
      if (!s.chargeable) { shippingNoteEl.hidden = true; shippingNoteEl.textContent = ''; return; }
      var txt, mod;
      if (s.free) { txt = shippingNoteEl.dataset.labelFree; mod = 'is-free'; }
      else if (s.heavy) { txt = (shippingNoteEl.dataset.labelWeight || '').replace('{kg}', s.weightKg.toFixed(1)); mod = 'is-charge'; }
      else { txt = shippingNoteEl.dataset.labelCharge; mod = 'is-charge'; }
      shippingNoteEl.textContent = txt || '';
      shippingNoteEl.className = 'staff-order__shipping-note ' + mod;
      shippingNoteEl.hidden = false;
    }
    if (shippingMethodEl) {
      shippingMethodEl.addEventListener('change', function () { renderShippingNote(); saveState(); });
    }
    // Persist on every keystroke — the panel is rebuilt on each drawer re-render
    // (qty steppers etc.), so anything not in sessionStorage is lost mid-typing.
    if (referenceEl) referenceEl.addEventListener('input', saveState);

    // «Μήπως ξέχασες να βάλεις reference;» — a quote or sales order with no reference gets
    // one reminder on Create; Create again goes ahead without one. Typing in the field, a
    // doc-type change or a reset puts the reminder away (and re-arms it).
    // An empty Reference on a quote / sales order is drawn amber with a warning icon and
    // the hint as placeholder (John 2026-10-15, option A), so it is noticed before Create.
    function syncRefAttn() {
      if (!referenceWrapEl || !referenceEl) return;
      var dt = docEl.value;
      referenceWrapEl.classList.toggle('is-attn', (dt === 'quote' || dt === 'salesorder') && !referenceEl.value.trim());
    }
    if (referenceEl) referenceEl.addEventListener('input', syncRefAttn);
    function hideRefNudge() {
      if (refNudgeEl) refNudgeEl.hidden = true;
      if (referenceEl) referenceEl.classList.remove('is-nudged');
    }
    if (referenceEl) referenceEl.addEventListener('input', hideRefNudge);
    if (refNudgeAddEl) refNudgeAddEl.addEventListener('click', function () {
      if (!referenceEl) return;
      referenceEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      referenceEl.focus({ preventScroll: true });
    });
    if (adjustmentEl) adjustmentEl.addEventListener('input', function () { renderTotals(); saveState(); });

    // Staff-only: preview the selected discount preset on each cart line. The
    // discount is NOT applied to the Shopify cart (it's applied server-side in
    // Zoho at create time) — this is a visual aid for the staffer on the phone:
    // strike the original line price and show the discounted price + percent.
    function renderLineDiscounts() {
      // Detach the cart observer while we mutate line DOM — our own badge/strike
      // writes are childList changes inside [data-cart-drawer-body], which would
      // otherwise retrigger the observer → refreshTotals → render loop.
      if (cartObserver) cartObserver.disconnect();
      renderExtraRows();
      applyStoredOrder();
      wireDrag();
      // WORK-233 (John 2026-10-20): a line the preset discounts is drawn exactly as a tier
      // customer's drawer draws Shopify's discount — struck price, then the price after it
      // (box lines: the box pills, «−10%» only while the box deal holds) — from the drawer's own
      // markup (CartDrawer.priceParts). A line back at 0% gets the drawer's markup back.
      var preset = discountEl.value;
      var CD = window.CartDrawer;
      if (cartCache && CD && CD.priceParts) {
        var nodesByKey = {};
        document.querySelectorAll('.cart-drawer__item[data-cart-key]').forEach(function (n) {
          nodesByKey[n.getAttribute('data-cart-key')] = n;
        });
        (cartCache.items || []).forEach(function (i) {
          var node = nodesByKey[i.key];
          var lineEl = node && node.querySelector('.cart-drawer__item-line-price');
          if (!lineEl) return;
          var pct = preset && preset !== 'none' ? linePct(i, preset) : 0;
          if (!pct && !lineEl.hasAttribute('data-staff-view')) return;   // the drawer's own markup stands
          var view = null;
          if (pct) {
            // A box line with a % on top has lost its box deal (WORK-295: never both).
            var isBox = !!(window.Box10 && window.Box10.isBoxItem && window.Box10.isBoxItem(i));
            view = { final: Math.round(discountBase(i, preset) * (1 - pct / 100)), pct: pct,
                     boxDeal: !isBox };
            lineEl.setAttribute('data-staff-view', String(pct));
          } else {
            lineEl.removeAttribute('data-staff-view');
          }
          var html = i.staffExtra && !view ? extraPriceHtml(i, cartCache.currency) : CD.priceParts(i, view).line;
          if (lineEl.innerHTML !== html) lineEl.innerHTML = html;
        });
      }
      qaPaintNew();   // WORK-242: the «just added» mark, while the observer is off
      observeCart();
    }

    // Per-variant delivery inputs harvested from the rendered cart, keyed by variant id.
    // Quantity-independent by construction, so this survives every stepper tap and only
    // needs refreshing when the product set changes.
    var deliveryFacts = {};

    function collectDocUrls(cartHtml) {
      var ds = {}, mn = {};
      var doc = new DOMParser().parseFromString(cartHtml, 'text/html');
      doc.querySelectorAll('[data-cartitem-key]').forEach(function (el) {
        var d = el.getAttribute('data-cartitem-datasheets');
        if (d) { try { JSON.parse(d).forEach(function (u) { if (u) ds[u] = 1; }); } catch (e) {} }
        // data-cartitem-manuals is the list form (one manual per variant) and
        // already falls back to the single custom.manual, so prefer it.
        var ml = el.getAttribute('data-cartitem-manuals');
        var mlParsed = null;
        if (ml) { try { mlParsed = JSON.parse(ml); } catch (e) {} }
        if (mlParsed && mlParsed.length) {
          mlParsed.forEach(function (u) { if (u) mn[u] = 1; });
        } else {
          var m = el.getAttribute('data-cartitem-manual');
          if (m) { mn[m] = 1; }
        }
        var vid = el.getAttribute('data-cartitem-id');
        if (vid) {
          deliveryFacts[vid] = {
            inv: parseInt(el.getAttribute('data-cartitem-inv'), 10) || 0,
            instock: el.getAttribute('data-cartitem-instock') || '',
            readyOne: el.getAttribute('data-cartitem-readyone') || '',
            readyMany: el.getAttribute('data-cartitem-readymany') || '',
            lead: el.getAttribute('data-cartitem-lead') || '',
            whole: el.getAttribute('data-cartitem-whole') || ''
          };
        }
      });
      return { datasheets: Object.keys(ds), manuals: Object.keys(mn) };
    }

    // Mirror of the delivery rule in snippets/cart-item.liquid. Only the SHAPE lives
    // here — every Greek word comes from the attributes that snippet emits, so the
    // wording can never drift between the /cart page and the drawer.
    // CHANGE BOTH TOGETHER if the rule itself changes.
    function deliveryPhrase(variantId, qty) {
      var f = deliveryFacts[variantId];
      if (!f) return '';
      if (f.inv >= qty) return f.instock;
      if (f.inv > 0) {
        return f.inv + ' ' + (f.inv === 1 ? f.readyOne : f.readyMany) +
               ' + ' + (qty - f.inv) + ' ' + f.lead;
      }
      return f.whole;
    }
    function setDlBtn(btn, countEl, n) {
      if (btn) btn.disabled = n === 0;
      if (countEl) countEl.textContent = n ? '(' + n + ')' : '';
    }
    // Signature of WHICH products are in the cart, ignoring quantities. Datasheets and
    // manuals are product metafields, so they cannot change when a quantity does.
    var docUrlsSig = null;
    function cartProductSig(cart) {
      if (!cart || !cart.items) return null;
      return cart.items.map(function (i) { return i.variant_id; }).sort().join(',');
    }
    // Fetching /cart costs ~536KB and a full Liquid page render (measured 2026-07-28) —
    // the only place the datasheet/manual URLs exist is that HTML. Skipping it when the
    // product set is unchanged takes that cost off every qty tap, which is the common case.
    // Pass force:true when there is no reliable cart to compare against.
    function refreshDocButtons(cart, force) {
      var sig = cartProductSig(cart);
      if (!force && sig !== null && sig === docUrlsSig) {
        setDlBtn(dlDsBtn, dlDsCount, datasheetUrls.length);
        setDlBtn(dlMnBtn, dlMnCount, manualUrls.length);
        return;
      }
      // ?sections= renders just the cart section instead of the whole page: 117KB vs
      // 536KB (measured 2026-07-28) for the same data-cartitem-* attributes.
      fetch(ROOT + 'cart?sections=static-cart')
        .then(function (r) { return r.json(); })
        .then(function (j) { return j['static-cart'] || ''; })
        .then(function (html) {
        var u = collectDocUrls(html);
        datasheetUrls = u.datasheets;
        manualUrls = u.manuals;
        docUrlsSig = sig;   // null when unknown, so the next call re-fetches
        setDlBtn(dlDsBtn, dlDsCount, datasheetUrls.length);
        setDlBtn(dlMnBtn, dlMnCount, manualUrls.length);
        // Repaint the delivery text now the facts exist. applyCart() calls
        // renderDeliveryNotes() synchronously on the line after this fetch STARTS, so a
        // variant appearing for the first time had no facts yet and rendered blank —
        // visible when adding the first piece of a product. Everything after that looked
        // fine because the facts were cached by then.
        renderDeliveryNotes(cartCache);
      }).catch(function () {});
    }
    function downloadAll(urls) {
      urls.forEach(function (url, i) {
        setTimeout(function () {
          var a = document.createElement('a');
          a.href = url; a.setAttribute('download', ''); a.rel = 'noopener';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
        }, i * 300);
      });
    }
    if (dlDsBtn) dlDsBtn.addEventListener('click', function () { downloadAll(datasheetUrls); });
    if (dlMnBtn) dlMnBtn.addEventListener('click', function () { downloadAll(manualUrls); });
    // Everything that has to happen once a fresh cart is known. Split out from
    // refreshTotals() so the drawer path can call it synchronously with the cart that
    // cart:updated already carries, instead of paying for a second /cart.js round-trip
    // and letting the totals + per-line discount badges land ~150ms after the rows —
    // which grew every row late and was half of the bounce staff reported.
    // ORG-632: which lines are on offer — asked of the server only when the set of
    // variants in the cart changes, then the totals and badges are redrawn.
    var offersFor = null;
    function refreshOffers(cart) {
      var ids = ((cart && cart.items) || []).map(function (i) { return String(i.variant_id); }).sort().join(',');
      if (ids === offersFor) return;
      offersFor = ids;
      if (!ids) { offerIds = {}; return; }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?sections=cart-offer-lines', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('?sections=cart-offer-lines ' + r.status); return r.json(); })
        .then(function (json) {
          var html = (json && json['cart-offer-lines']) || '';
          function idSet(attr) {
            var m = new RegExp(attr + '[^>]*>([\\s\\S]*?)<\\/script>').exec(html);
            var next = {};
            (m ? JSON.parse(m[1]) : []).forEach(function (v) { next[String(v)] = true; });
            return next;
          }
          offerIds = idSet('data-cart-offer-lines');
          renderTotals();
        })
        .catch(function (err) { offersFor = null; console.error('[StaffOrder] offer lines', err); });
    }
    function applyCart(cart) {
      if (!cart) return;
      rawCart = cart;
      cart = withExtras(cart);
      cartCache = cart;
      // Drop notes whose line has left the cart, so a note can never reattach to a
      // different item. Done against a fresh cart, never against the previous cycle's
      // cartCache. Must persist: lineNotes is re-hydrated from sessionStorage on every
      // page init, so an unpersisted delete resurrects the note on the next navigation
      // and re-attaches it to the same line key.
      var liveKeys = {}, dropped = false;
      (cart.items || []).forEach(function (i) { liveKeys[i.key] = true; });
      Object.keys(lineNotes).forEach(function (k) {
        if (!liveKeys[k]) { delete lineNotes[k]; dropped = true; }
      });
      if (dropped) { saveState(); }
      renderTotals();          // also draws the per-line discount badges (and extra rows)
      refreshOffers(rawCart);  // re-renders once the cart's offer lines are known
      // Extras carry no datasheets/manuals (those come from the /cart HTML), so the
      // Shopify cart alone decides whether that ~117KB fetch is needed.
      refreshDocButtons(rawCart);  // no-ops unless the product set changed
      renderDeliveryNotes(cart);
      syncCaseFromCart(cart);   // attached mode: every cart render diffs against the Case
    }

    // Small delivery/stock line tucked under each stepper. It sits INSIDE the stepper's
    // grid cell, in the slack the 48px image already leaves above and below the ~35px
    // stepper, so the row does not get taller. Recomposed from cached per-variant facts
    // on every render — no fetch, even though the wording depends on the quantity.
    function renderDeliveryNotes(cart) {
      var byKey = {};
      ((cart && cart.items) || []).forEach(function (i) { byKey[i.key] = i; });
      var rows = document.querySelectorAll('[data-cart-drawer-body] [data-cart-key]');
      Array.prototype.forEach.call(rows, function (row) {
        var item = byKey[row.getAttribute('data-cart-key')];
        var host = row.querySelector('.cart-drawer__item-details');
        if (!item || !host) { return; }
        var out = row.querySelector('[data-staff-delivery]');
        if (!out) {
          out = document.createElement('span');
          out.className = 'staff-order__delivery';
          out.setAttribute('data-staff-delivery', '');
          host.appendChild(out);
        }
        var phrase = item.staffExtra ? item.delivery
          : deliveryPhrase(String(item.variant_id), item.quantity);
        out.textContent = phrase;
        out.title = phrase;     // full text on hover when it ellipsises
      });
    }

    // Fetching path — used at init, and for surfaces that mutate without firing
    // cart:updated (the /cart page morphdoms its list).
    //
    // cartSeq drops responses that arrive out of order. Two overlapping /cart.js calls
    // could otherwise install an older snapshot, and the note prune inside applyCart()
    // would then run against it and delete a note for a line that is still in the cart —
    // while the row kept displaying it, so the loss was silent.
    var cartSeq = 0;
    function refreshTotals() {
      var mySeq = ++cartSeq;
      fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (mySeq !== cartSeq) { return; }   // a newer request already answered
          applyCart(cart);
        })
        .catch(function () {});
    }

    // Recompute instantly when the discount preset changes; persist the choice.
    discountEl.addEventListener('change', function () { renderTotals(); saveState(); });

    function noteLabel(k) { return panel.getAttribute('data-note-' + k) || ''; }

    // Commit every open note field immediately, without waiting for its 300ms debounce.
    // Every mouse route out of the page blurs the field first (which commits via
    // `change`), but a keyboard-only exit — Cmd+W, F5, Alt+Left — does not, so a note
    // typed in the last 300ms would be lost. Deliberately does not go through the
    // per-row `commit` closures: those aren't reachable from here, and the write is the
    // same one they perform.
    function flushOpenNotes() {
      var dirty = false;
      Array.prototype.forEach.call(document.querySelectorAll('.staff-order__note-input'), function (field) {
        if (field.hidden) { return; }
        var row = field.closest('[data-cart-key], [data-cartitem-key]');
        if (!row) { return; }
        var key = row.getAttribute('data-cart-key') || row.getAttribute('data-cartitem-key');
        if (!key) { return; }
        var v = field.value;
        var had = lineNotes[key];
        if (v.trim()) { lineNotes[key] = v; } else { delete lineNotes[key]; }
        if (lineNotes[key] !== had) { dirty = true; }
      });
      if (dirty) { saveState(); }
    }
    window.addEventListener('pagehide', flushOpenNotes);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { flushOpenNotes(); }
    });
    function searchLabel(k) { return panel.getAttribute('data-search-' + k) || ''; }

    // A tokenless staffFetch() rejects before it reaches the network, so an
    // unauthenticated action would look identical to one that simply found
    // nothing. There is exactly ONE notice for this — the Connect button at the
    // top of the panel — so instead of repeating its text next to every dead
    // control, bring the eye to it.
    function flashConnect(listEl) {
      if (listEl) { listEl.innerHTML = ''; listEl.hidden = true; }
      renderCaseBox();
      var btn = caseBox && caseBox.querySelector('[data-case-do="connect"]');
      if (!btn) return;
      btn.scrollIntoView({ block: 'nearest' });
      btn.classList.remove('is-flashing');
      void btn.offsetWidth;                  // restart the animation on repeats
      btn.classList.add('is-flashing');
      setTimeout(function () { btn.classList.remove('is-flashing'); }, 1600);
    }

    // Per-line staff note. cart-drawer.js rebuilds its item list with innerHTML on
    // every qty change, add and remove, so the button is re-injected after each
    // re-render and its text restored from lineNotes by cart line key. Skipping rows
    // that already carry a button keeps this idempotent, which matters: the
    // MutationObserver below watches the very subtree this writes into, so a second
    // pass has to mutate nothing and let the cycle stop.
    function injectLineNotes() {
      // Detach the cart observer while we mutate line DOM — matches
      // renderLineDiscounts() above: our own [data-staff-note] writes are childList
      // changes inside the watched subtree, which would otherwise retrigger the
      // observer for a second refreshTotals()/refreshDocButtons() cycle that ends
      // up mutating nothing (the guard below is already idempotent).
      if (cartObserver) cartObserver.disconnect();
      // Note pruning (dropping lineNotes entries for lines that left the cart)
      // lives in refreshTotals()'s success handler now, not here — that's where
      // the /cart.js payload is fresh. This function is purely injective: it only
      // paints note widgets onto existing rows, keyed by whatever lineNotes
      // currently holds.
      // Cart lines render on two different surfaces with two different
      // attributes for the same Shopify cart line item.key: the client-side
      // drawer (cart-drawer.js renderItem()) stamps data-cart-key, the
      // server-rendered /cart page (snippets/cart-item.liquid) stamps
      // data-cartitem-key. Query both; read whichever attribute the row has.
      var rows = document.querySelectorAll('[data-cart-key], [data-cartitem-key]');
      Array.prototype.forEach.call(rows, function (row) {
        var key = row.getAttribute('data-cart-key') || row.getAttribute('data-cartitem-key');
        if (!key) return;
        if (row.querySelector('[data-staff-note]')) return;
        var host = row.querySelector('.cart-drawer__item-details') ||
          row.querySelector('.cart-item--content') || row;
        var wrap = document.createElement('div');
        wrap.className = 'staff-order__note';
        wrap.setAttribute('data-staff-note', '');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'staff-order__note-btn';
        btn.textContent = noteLabel('label');
        btn.setAttribute('aria-expanded', 'false');
        var text = document.createElement('span');
        text.className = 'staff-order__note-text';
        var field = document.createElement('input');
        field.type = 'text';
        field.className = 'staff-order__note-input';
        field.hidden = true;
        field.placeholder = noteLabel('placeholder');
        // A placeholder is not an accessible name — it disappears on input.
        field.setAttribute('aria-label', noteLabel('placeholder'));
        // Bound at the point of entry, not just server-side: the backend
        // silently truncates at 500 chars, so cap the input here too rather
        // than letting staff type past a limit they can't see.
        field.maxLength = 500;
        field.value = lineNotes[key] || '';
        function sync() {
          var v = (lineNotes[key] || '').trim();
          btn.classList.toggle('has-note', !!v);
          text.textContent = field.hidden ? v : '';
        }
        // Single commit path used by the debounce (typing then pausing), the
        // change handler (typing then blurring — including the mousedown-blur
        // that precedes a Create click) and the Enter handler below, so all
        // three write lineNotes the same way instead of three copies drifting.
        function commit(v) {
          if (v.trim()) { lineNotes[key] = v; } else { delete lineNotes[key]; }
          sync();
          saveState();
        }
        // Value as it stood when the field was opened, so Escape can restore what was
        // there before this edit rather than whatever the debounce last autosaved.
        var preEditValue = field.value;
        btn.addEventListener('click', function () {
          field.hidden = !field.hidden;
          if (!field.hidden) { preEditValue = field.value; }
          btn.setAttribute('aria-expanded', field.hidden ? 'false' : 'true');
          sync();
          if (!field.hidden) field.focus();
        });
        // Own debounce timer per row — a single shared timer would let one
        // row's pending commit cancel another row's, silently dropping the
        // first note whenever two lines are edited within the same window.
        var rowNoteTimer = null;
        field.addEventListener('input', function () {
          clearTimeout(rowNoteTimer);
          var v = field.value;
          rowNoteTimer = setTimeout(function () { commit(v); }, 300);
        });
        // A mousedown on the Create button blurs this field, firing `change`
        // synchronously before the click handler runs — this is what actually
        // saves a note typed in the 300ms right before Create is clicked,
        // instead of shipping note: '' with no warning.
        field.addEventListener('change', function () {
          clearTimeout(rowNoteTimer);
          commit(field.value);
        });
        // The field sits inside the /cart page's <form method="post">, whose
        // first submit button is name="checkout" — Enter here implicitly submits
        // that form and navigates to checkout before the debounce timer ever
        // fires, silently losing the note. Commit immediately and collapse.
        field.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            clearTimeout(rowNoteTimer);
            commit(field.value);
            field.hidden = true;
            sync();
          } else if (e.key === 'Escape' || e.keyCode === 27) {
            // Without this, Escape bubbles up to site-drawer.js and closes
            // the whole cart drawer instead of just collapsing this field.
            e.stopPropagation();
            clearTimeout(rowNoteTimer);
            // Restore the pre-edit value, not lineNotes[key] — mid-edit the debounce
            // may already have autosaved, so the latter would "cancel" back to a value
            // the staffer never chose to keep.
            field.value = preEditValue;
            commit(preEditValue);
            field.hidden = true;
            btn.setAttribute('aria-expanded', 'false');
            sync();
          }
        });
        sync();
        wrap.appendChild(btn);
        wrap.appendChild(text);
        wrap.appendChild(field);
        host.appendChild(wrap);
      });
      observeCart();
    }

    // Keep totals in sync when the cart re-renders its line items (qty
    // steppers, remove). Debounced; refetches /cart.js. Two surfaces need
    // watching: the drawer body (cart-drawer.js re-render) and, on the
    // standalone /cart page, the cartitems--list that a qty change morphdoms
    // in a separate subtree (snippets/cart-item-list.liquid). Both targets
    // share one observer + one debounce so a re-render on either surface
    // re-runs the same callback exactly once.
    var cartBody = $('[data-cart-drawer-body]');
    var cartItemList = $('[data-cart-item-list]');
    function observeCart() {
      if (!cartObserver) return;
      if (cartBody) cartObserver.observe(cartBody, { childList: true, subtree: true });
      if (cartItemList) cartObserver.observe(cartItemList, { childList: true, subtree: true });
    }
    // Our own writes inside the watched subtree are not cart re-renders. applyCart() repaints
    // the panel (download counts) and the per-line delivery notes on every pass with the
    // observer connected; taking those for a re-render refetched /cart.js 300ms later and
    // repainted again — ~2 requests a second, forever, in every staff tab with items
    // (2026-10-12, spec tests/staff-cart/idle-loop.spec.js). A record counts as ours when
    // its target, or every node it added/removed, sits inside a staff-owned element.
    var OWN_DOM = '[data-staff-panel], [data-staff-cp], [data-staff-delivery], [data-staff-note], [data-staff-qa-new]';
    function ownNode(n) {
      var el = n.nodeType === 1 ? n : n.parentElement;
      return !!(el && el.closest(OWN_DOM));
    }
    function ownRecord(r) {
      if (ownNode(r.target)) return true;
      var nodes = Array.prototype.slice.call(r.addedNodes).concat(Array.prototype.slice.call(r.removedNodes));
      return nodes.length > 0 && nodes.every(function (n) { return n.nodeType === 1 && n.matches(OWN_DOM); });
    }
    if ((cartBody || cartItemList) && typeof MutationObserver === 'function') {
      cartObserver = new MutationObserver(function (records) {
        if (isStaffDragging) return;
        if (records.every(ownRecord)) return;
        clearTimeout(totalsTimer);
        // refreshTotals() drives refreshDocButtons() itself, off the fresh /cart.js payload.
        totalsTimer = setTimeout(function () { refreshTotals(); injectLineNotes(); }, 300);
      });
      observeCart();
    }

    // Do the whole post-render pass in the SAME tick the drawer finishes rendering.
    // cart-drawer.js replaces its item list with innerHTML then fires cart:updated
    // synchronously, whereas the MutationObserver above only reacts 300ms later —
    // long enough that every row visibly collapsed by the note's height and regrew,
    // which is the bounce staff reported on every qty tap.
    //
    // This handler must call refreshTotals() as well, not just the injection:
    // injectLineNotes() disconnects the observer around itself, and disconnect()
    // DISCARDS pending records. Running here (before the observer's callback for this
    // render) therefore suppresses that callback entirely, so anything left only to the
    // observer — the totals, and the note prune that rides on refreshTotals — would
    // silently stop happening on the drawer path.
    //
    // The observer still covers /cart, which morphdoms its list and fires no cart:updated.
    document.addEventListener('cart:updated', function (e) {
      if (isStaffDragging) return;
      clearTimeout(totalsTimer);
      var cart = e && e.detail && e.detail.cart;
      if (cart) { applyCart(cart); }   // the event carries the payload cart-drawer just fetched
      else { refreshTotals(); }        // defensive: some other dispatcher, fetch it ourselves
      injectLineNotes();
    });

    refreshTotals();     // also does the first refreshDocButtons(), unconditionally
    injectLineNotes();

    searchEl.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchEl.value.trim();
      if (q.length < 2) {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        return;
      }
      timer = setTimeout(function () {
        if (searchWrap) searchWrap.classList.add('is-searching');
        staffFetch('/staff/contacts?q=' + encodeURIComponent(q))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            resultsEl.innerHTML = '';
            (d.results || []).forEach(function (c) {
              var li = document.createElement('li');
              li.className = 'staff-order__result-item';
              var label = c.contact_name + ' · ' + (c.afm || '—') + (c.city ? ' · ' + c.city : '');
              // When the match came via a contact person, show who — so staff
              // know they reached e.g. Γιάννης under the company account.
              if (c.matched_person) label += ' — ' + c.matched_person;
              li.textContent = label;
              li.setAttribute('data-staff-result-item', '');
              li.addEventListener('click', function () { selectContact(c); });
              resultsEl.appendChild(li);
            });
            // No match used to hide the list entirely, which read as "the search did
            // nothing". Say so, and offer the create action inline with the text already
            // typed — the staffer is one keystroke from the thing they were about to do.
            if (!(d.results || []).length) {
              var none = document.createElement('li');
              none.className = 'staff-order__result-empty';
              none.textContent = searchLabel('none') + ' «' + q + '»';
              resultsEl.appendChild(none);
            }
            var create = document.createElement('li');
            create.className = 'staff-order__result-create';
            create.setAttribute('data-staff-result-create', '');
            create.setAttribute('tabindex', '0');
            create.setAttribute('role', 'button');
            create.innerHTML = '<span class="staff-order__result-create-plus" aria-hidden="true">+</span>';
            create.appendChild(document.createTextNode(searchLabel('new')));
            var qs = document.createElement('span');
            qs.className = 'staff-order__result-create-q';
            qs.textContent = ' «' + q + '»';
            create.appendChild(qs);
            function fire() { resultsEl.hidden = true; openNewForm(q); }
            create.addEventListener('click', fire);
            create.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fire(); }
            });
            resultsEl.appendChild(create);
            resultsEl.hidden = false;   // always open while a query is active
            // A 9-digit ΑΦΜ none of our contacts carries: ask AADE (via listen)
            // who it is, and whether it's one of our ΑΦΜ-less customers who has
            // since registered a business (order #12047).
            var afmQ = asAfm(q);
            if (afmQ && !(d.results || []).some(function (c) { return asAfm(c.afm) === afmQ; })) {
              renderAadeCard(afmQ, q, create);
            }
          })
          .catch(function (e) {
            if (e && e.status === 401) flashConnect(resultsEl);
          })
          .then(function () { if (searchWrap) searchWrap.classList.remove('is-searching'); });
      }, 250);
    });

    // ---- ΑΦΜ not in our contacts → AADE card (listen /staff/afm-check) ----
    // "EL 102463122", "102463122" → "102463122"; anything else → ''.
    function asAfm(v) {
      var s = String(v || '').replace(/^\s*EL/i, '').replace(/\s/g, '');
      return /^\d{9}$/.test(s) ? s : '';
    }
    // A Greek phone number searched (10 digits on 2… or 69…, with or without +30 /
    // 0030 / 30, spaces, dashes, dots): «new customer» puts it in Τηλέφωνο (ORG-197).
    // A letter, or any other digit count, keeps today's behaviour: it is a name.
    function asGrPhone(v) {
      var s = String(v || '').trim();
      if (!/^\+?[\d\s().\/-]+$/.test(s)) return '';
      var d = normPhone(s);
      return /^(2\d{9}|69\d{8})$/.test(d) ? d : '';
    }
    function afmLabel(k) { return panel.getAttribute('data-afm-' + k) || ''; }
    function mk(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }
    function aadeBadge(a) {
      if (!a) return ['unknown', afmLabel('unavailable')];
      if (a.status === 'invalid') return ['bad', afmLabel('invalid')];
      if (a.deactivated) return ['bad', afmLabel('inactive')];
      return a.is_business ? ['ok', afmLabel('business')] : ['warn', afmLabel('personal')];
    }
    function renderAadeCard(afm, q, beforeEl) {
      var card = mk('li', 'staff-order__aade is-loading', afmLabel('checking'));
      card.setAttribute('data-staff-aade', '');
      resultsEl.insertBefore(card, beforeEl);
      staffFetch('/staff/afm-check?afm=' + afm)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (searchEl.value.trim() !== q || !card.parentNode) return;   // typed on
          card.classList.remove('is-loading');
          card.textContent = '';
          if (!d || !d.ok) throw d;
          if (d.match) { card.remove(); return; }   // exact ΑΦΜ hit the search missed
          // The card says it all — drop the bare "no results" line above it.
          var none = resultsEl.querySelector('.staff-order__result-empty');
          if (none) none.remove();
          var a = d.aade, badge = aadeBadge(a);
          var head = mk('div', 'staff-order__aade-head');
          head.appendChild(mk('span', 'staff-order__aade-title',
            afmLabel(a && a.status === 'ok' ? 'found' : 'notfound') + ' · ' + tr('afm', 'ΑΦΜ') + '\u00a0' + afm));
          var b = mk('span', 'staff-order__aade-badge staff-order__aade-badge--' + badge[0], badge[1]);
          b.setAttribute('data-staff-aade-badge', badge[0]);
          head.appendChild(b);
          card.appendChild(head);
          if (a && a.status === 'ok') {
            card.appendChild(mk('div', 'staff-order__aade-name', a.name || ''));
            var where = [a.doy ? tr('doy', 'ΔΟΥ') + ' ' + a.doy : '', [a.address, a.city].filter(Boolean).join(', ')]
              .filter(Boolean).join(' · ');
            if (where) card.appendChild(mk('div', 'staff-order__aade-sub', where));
            if (a.deactivated) {
              card.appendChild(mk('div', 'staff-order__aade-hint staff-order__aade-hint--bad', afmLabel('inactive_hint')));
            } else if (!a.is_business) {
              card.appendChild(mk('div', 'staff-order__aade-hint', afmLabel('personal_hint')));
            }
          } else if (!a) {
            card.appendChild(mk('div', 'staff-order__aade-hint', afmLabel('unavailable_hint')));
          } else if (a.status === 'invalid') {
            card.appendChild(mk('div', 'staff-order__aade-hint staff-order__aade-hint--bad', afmLabel('invalid_hint')));
          }
          // Same person already with us, without ΑΦΜ → add it to them, don't duplicate.
          var usable = a && a.status === 'ok' && !a.deactivated;
          if (usable && (d.candidates || []).length) {
            card.appendChild(mk('div', 'staff-order__aade-cands-label', afmLabel('candidates')));
            d.candidates.forEach(function (c) {
              var row = mk('div', 'staff-order__aade-cand');
              row.setAttribute('data-staff-aade-cand', c.contact_id);
              row.appendChild(mk('span', 'staff-order__aade-cand-name',
                '«' + c.contact_name + '»' + (c.city ? ' · ' + c.city : '')));
              var add = mk('button', 'staff-order__aade-btn staff-order__aade-btn--primary', afmLabel('attach'));
              add.type = 'button';
              add.setAttribute('data-staff-aade-attach', '');
              var err = mk('span', 'staff-order__aade-err');
              err.hidden = true;
              add.addEventListener('click', function (e) {
                e.stopPropagation();
                add.disabled = true; err.hidden = true;
                staffFetch('/staff/contact-afm', { method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ contact_id: c.contact_id, afm: afm }) })
                  .then(function (r) { return r.json(); })
                  .then(function (res) {
                    if (!res || !res.ok || !res.contact) throw res;
                    resultsEl.hidden = true;
                    selectContact(res.contact);
                  })
                  .catch(function (res) {
                    add.disabled = false; err.hidden = false;
                    err.textContent = afmLabel('attach_err') + (res && res.error ? ' (' + res.error + ')' : '');
                  });
              });
              row.appendChild(add);
              row.appendChild(err);
              card.appendChild(row);
            });
          }
          // An ΑΦΜ that can't be invoiced (invalid / inactive) gets no create button:
          // the card is a stop sign, not a shortcut.
          if (a && (a.status === 'invalid' || a.deactivated)) {
            if (beforeEl && beforeEl.parentNode) beforeEl.remove();
            return;
          }
          var actions = mk('div', 'staff-order__aade-actions');
          var nb = mk('button', 'staff-order__aade-btn', usable ? afmLabel('new_from_aade') : afmLabel('new_plain'));
          nb.type = 'button';
          nb.setAttribute('data-staff-aade-new', '');
          nb.addEventListener('click', function (e) {
            e.stopPropagation();
            resultsEl.hidden = true;
            openNewForm(usable ? { afm: afm, aade: a } : { afm: afm });
          });
          actions.appendChild(nb);
          card.appendChild(actions);
          // The generic "+ Νέος πελάτης «102463122»" row is now redundant.
          if (beforeEl && beforeEl.parentNode) beforeEl.remove();
        })
        .catch(function (e) {
          if (e && e.status === 401) { flashConnect(resultsEl); card.remove(); return; }
          card.classList.remove('is-loading');
          card.textContent = afmLabel('unavailable_hint');
        });
    }

    function renderSelected(c) {
      if (selNameEl) selNameEl.textContent = c.contact_name || '';
      var sub = []; if (c.afm) sub.push(tr('afm', 'ΑΦΜ') + ' ' + c.afm); if (c.city) sub.push(c.city);
      if (selSubEl) selSubEl.textContent = sub.join(' · ');
      // Contact-person the customer was found through (phone/email match) —
      // context only; the document still goes to the company.
      if (selPersonEl) {
        if (c.matched_person) {
          selPersonEl.textContent = (selPersonEl.getAttribute('data-label') || '') + ' ' + c.matched_person;
          selPersonEl.hidden = false;
        } else {
          selPersonEl.textContent = '';
          selPersonEl.hidden = true;
        }
      }
      // Billing address line — a phone-call confirmation aid for staff.
      if (selAddrEl) {
        var addr = [];
        if (c.billing_address) addr.push(c.billing_address);
        var cz = [c.billing_zip, c.city].filter(Boolean).join(' ');
        if (cz) addr.push(cz);
        selAddrEl.textContent = addr.join(', ');
        selAddrEl.hidden = addr.length === 0;
      }
      selectedEl.hidden = false;
      // ORG-773: the card opens the contact panel. Queried here, not cached, because a
      // restored selection renders before the contact-panel block further down runs.
      var cpBtn = $('[data-staff-cp-open]', panel);
      if (cpBtn) cpBtn.disabled = !c.contact_id;
      if (searchWrap) searchWrap.hidden = true;
      if (newBtn) newBtn.hidden = true;
      if (retailBtn) retailBtn.hidden = true;
      if (newForm) newForm.hidden = true;
      resultsEl.hidden = true;
      createBtn.disabled = false;
      if (createHintEl) createHintEl.hidden = true;
    }
    function clearSelection(opts) {
      chosen = null;
      setContactVat(24);
      catalogData = null; catalogPicked = {}; renderCatalogs();
      selectedEl.hidden = true;
      cpReset();
      if (searchWrap) searchWrap.hidden = false;
      if (newBtn) newBtn.hidden = false;
      if (retailBtn) retailBtn.hidden = false;
      if (newForm) newForm.hidden = true;
      searchEl.value = '';
      createBtn.disabled = true;
      if (createHintEl) createHintEl.hidden = false;
      saveState();
      if (!opts || opts.focus !== false) searchEl.focus();
    }
    // Full-field address cards (view mode: radio + street/badge/meta/actions;
    // edit mode: inline field grid with save/cancel; delete: inline confirm
    // bar). Labels come from data-l-* attrs on shipAddrWrap (Task 4). Update
    // and delete hit the Task 3 endpoints and always re-fetch via
    // loadShipAddresses on success (no optimistic mutation).
    function shipAddrLabel(name) {
      return (shipAddrWrap && shipAddrWrap.getAttribute('data-l-' + name)) || '';
    }
    function shipAddrPost(path, body) {
      return staffFetch(path, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }
    function shipAddrMeta(a) {
      var bits = [];
      if (a.attention) bits.push(shipAddrLabel('attention') + ': ' + a.attention);
      var cz = [a.city, a.zip].filter(Boolean).join(' ');
      if (cz) bits.push(cz);
      var line = bits.join(' · ');
      if (a.phone) line += (line ? '\n' : '') + '☎ ' + a.phone;
      return line;
    }
    function shipAddrSyncSelected() {
      Array.prototype.forEach.call(shipAddrList.querySelectorAll('.staff-order__addr'), function (c) {
        var r = c.querySelector('.staff-order__addr-radio');
        c.classList.toggle('is-selected', !!(r && r.checked));
      });
    }
    function shipAddrViewMode(card, a) {
      card.className = 'staff-order__addr' + (a.address_id === chosenAddrId ? ' is-selected' : '');
      card.innerHTML = '';
      var radio = document.createElement('input');
      radio.type = 'radio'; radio.name = 'staff-ship-addr'; radio.className = 'staff-order__addr-radio';
      radio.value = a.address_id; radio.checked = (a.address_id === chosenAddrId);
      radio.addEventListener('change', function () { chosenAddrId = a.address_id; shipAddrSyncSelected(); saveState(); });
      var body = document.createElement('div'); body.className = 'staff-order__addr-body';
      // Each card leads with the Zoho role it fills. A contact's billing and shipping
      // rows are frequently the same street, so the address alone doesn't tell them
      // apart; an address holding both roles names both.
      // One chip per role, each with its own colour, so billing vs shipping is a
      // glance rather than a read. An address holding both gets both chips.
      var roleRow = document.createElement('div');
      roleRow.className = 'staff-order__addr-roles';
      [['billing', a.is_billing], ['shipping', a.is_default_shipping]].forEach(function (pair) {
        if (!pair[1]) { return; }
        var chip = document.createElement('span');
        chip.className = 'staff-order__addr-role staff-order__addr-role--' + pair[0];
        chip.textContent = shipAddrLabel(pair[0]);
        roleRow.appendChild(chip);
      });
      if (roleRow.childNodes.length) { body.appendChild(roleRow); }
      var top = document.createElement('div'); top.className = 'staff-order__addr-top';
      var street = document.createElement('span'); street.className = 'staff-order__addr-street';
      street.textContent = a.address || '—'; top.appendChild(street);
      var meta = document.createElement('div'); meta.className = 'staff-order__addr-meta';
      meta.textContent = shipAddrMeta(a);
      var actions = document.createElement('div'); actions.className = 'staff-order__addr-actions';
      var edit = document.createElement('button');
      edit.type = 'button'; edit.className = 'staff-order__addr-link'; edit.textContent = shipAddrLabel('edit');
      edit.addEventListener('click', function () { shipAddrEditMode(card, a); });
      actions.appendChild(edit);
      // Zoho refuses to delete EITHER default address — billing or default shipping.
      // Offering the button on the shipping default just produced a confirm prompt
      // that always came back «Αδυναμία διαγραφής», so don't offer it at all. Both
      // stay editable; only deletion is blocked.
      if (!a.is_billing && !a.is_default_shipping) {
        var del = document.createElement('button');
        del.type = 'button'; del.className = 'staff-order__addr-link staff-order__addr-link--danger';
        del.textContent = shipAddrLabel('delete');
        del.addEventListener('click', function () { shipAddrConfirmDelete(card, a); });
        actions.appendChild(del);
      }
      body.appendChild(top); body.appendChild(meta); body.appendChild(actions);
      card.appendChild(radio); card.appendChild(body);
    }
    function shipAddrEditMode(card, a) {
      card.className = 'staff-order__addr is-editing'; card.innerHTML = '';
      var grid = document.createElement('div'); grid.className = 'staff-order__addr-edit';
      var inputs = {};
      function field(name, val, into) {
        var wrap = document.createElement('div');
        var lab = document.createElement('span'); lab.className = 'staff-order__label'; lab.textContent = shipAddrLabel(name);
        var inp = document.createElement('input'); inp.className = 'staff-order__input'; inp.value = val || '';
        inputs[name] = inp; wrap.appendChild(lab); wrap.appendChild(inp); (into || grid).appendChild(wrap);
      }
      field('attention', a.attention); field('address', a.address);
      var row = document.createElement('div'); row.className = 'staff-order__row2';
      field('city', a.city, row); field('zip', a.zip, row); grid.appendChild(row);
      field('phone', a.phone);
      var err = document.createElement('p'); err.className = 'staff-order__addr-err'; err.hidden = true;
      var actions = document.createElement('div'); actions.className = 'staff-order__addr-actions';
      var save = document.createElement('button'); save.type = 'button'; save.className = 'staff-order__addr-save'; save.textContent = shipAddrLabel('save');
      var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'staff-order__addr-link'; cancel.textContent = shipAddrLabel('cancel');
      cancel.addEventListener('click', function () { shipAddrViewMode(card, a); });
      save.addEventListener('click', function () {
        err.hidden = true; save.disabled = true;
        shipAddrPost('/staff/contact-address/update', {
          contact_id: chosen && chosen.contact_id, address_id: a.address_id,
          attention: inputs.attention.value.trim(), address: inputs.address.value.trim(),
          city: inputs.city.value.trim(), zip: inputs.zip.value.trim(),
          phone: normPhone(inputs.phone.value)   // card re-renders from Zoho on success
        }).then(function (res) {
          save.disabled = false;
          if (res && res.ok) { loadShipAddresses(chosen.contact_id, a.address_id); }
          else { err.hidden = false; err.textContent = shipAddrLabel('save_err'); }
        }).catch(function () { save.disabled = false; err.hidden = false; err.textContent = shipAddrLabel('save_err'); });
      });
      actions.appendChild(save); actions.appendChild(cancel);
      grid.appendChild(err); grid.appendChild(actions);
      card.appendChild(grid);
      if (inputs.address) inputs.address.focus();
    }
    function shipAddrConfirmDelete(card, a) {
      shipAddrViewMode(card, a);
      var body = card.querySelector('.staff-order__addr-body');
      var bar = document.createElement('div'); bar.className = 'staff-order__addr-confirm';
      var msg = document.createElement('span'); msg.textContent = shipAddrLabel('delete_confirm');
      var yes = document.createElement('button'); yes.type = 'button'; yes.className = 'staff-order__addr-link staff-order__addr-link--danger'; yes.textContent = shipAddrLabel('delete_yes');
      var no = document.createElement('button'); no.type = 'button'; no.className = 'staff-order__addr-link'; no.textContent = shipAddrLabel('cancel');
      no.addEventListener('click', function () { shipAddrViewMode(card, a); });
      yes.addEventListener('click', function () {
        yes.disabled = true;
        shipAddrPost('/staff/contact-address/delete', {
          contact_id: chosen && chosen.contact_id, address_id: a.address_id
        }).then(function (res) {
          if (res && res.ok) {
            var keep = (chosenAddrId === a.address_id) ? null : chosenAddrId;
            loadShipAddresses(chosen.contact_id, keep);
          } else { yes.disabled = false; msg.textContent = shipAddrLabel('delete_err'); }
        }).catch(function () { yes.disabled = false; msg.textContent = shipAddrLabel('delete_err'); });
      });
      bar.appendChild(msg); bar.appendChild(yes); bar.appendChild(no);
      body.appendChild(bar);
    }
    // Render the fetched shipping addresses as full-field cards, always with one
    // picked when the contact has any address. Order: preselectId (state
    // restore / just-edited) if it still exists → the default-shipping address →
    // the single non-billing address when there is exactly one → billing.
    // A stale preselectId (address deleted) falls through instead of leaving
    // nothing chosen. chosenAddrId is set in a first pass so shipAddrViewMode
    // checks the right radio when cards are built in the second pass.
    function pickShipAddress(addrs, preselectId) {
      var find = function (fn) { return addrs.filter(fn)[0]; };
      var others = addrs.filter(function (a) { return !a.is_billing; });
      var hit = (preselectId && find(function (a) { return a.address_id === preselectId; }))
        || find(function (a) { return a.is_default_shipping; })
        || (others.length === 1 ? others[0] : null)
        || find(function (a) { return a.is_billing; });
      return hit ? hit.address_id : null;
    }
    function renderShipAddresses(addrs, preselectId) {
      if (!shipAddrList) return;
      shipAddrList.innerHTML = '';
      chosenAddrId = pickShipAddress(addrs || [], preselectId);
      (addrs || []).forEach(function (a) {
        var card = document.createElement('div');
        shipAddrViewMode(card, a);
        shipAddrList.appendChild(card);
      });
    }
    // Fetch the contact's saved shipping addresses (Task 4 endpoint) and render
    // them. preselectId re-applies a staff pick across a drawer re-render.
    function loadShipAddresses(contactId, preselectId) {
      if (!shipAddrList) return;
      shipAddrList.innerHTML = '';
      chosenAddrId = null;
      staffFetch('/staff/contact-addresses?contact_id=' + encodeURIComponent(contactId))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          setContactVat(d && d.ok ? d.vat_pct : 24);
          if (d && d.ok) {
            renderShipAddresses(d.addresses, preselectId);
            if (shipAddrWrap) shipAddrWrap.hidden = false;
          } else {
            if (shipAddrWrap) shipAddrWrap.hidden = true;
          }
          saveState();
        })
        .catch(function () { if (shipAddrWrap) shipAddrWrap.hidden = true; });
    }
    function saVal(name) { var el = panel.querySelector('[data-sa="' + name + '"]'); return el ? el.value.trim() : ''; }
    // Phone field of the new-shipping-address form — same Zoho normalisation as
    // the new-customer form, echoed back so the staffer sees what was saved.
    function saPhone() {
      var el = panel.querySelector('[data-sa="phone"]');
      if (!el) return '';
      var v = normPhone(el.value);
      el.value = v;
      return v;
    }
    if (shipAddrNewBtn) shipAddrNewBtn.addEventListener('click', function () {
      if (shipAddrForm) shipAddrForm.hidden = !shipAddrForm.hidden;
    });
    if (shipAddrSave) shipAddrSave.addEventListener('click', function () {
      if (shipAddrErr) shipAddrErr.hidden = true;
      if (!chosen || !chosen.contact_id || !saVal('address')) {
        if (shipAddrErr) { shipAddrErr.hidden = false; shipAddrErr.textContent = shipAddrErr.getAttribute('data-label') || '!'; }
        return;
      }
      shipAddrSave.disabled = true;
      var body = {
        contact_id: chosen.contact_id, attention: saVal('attention'), address: saVal('address'),
        city: saVal('city'), zip: saVal('zip'), phone: saPhone()
      };
      staffFetch('/staff/contact-address', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          shipAddrSave.disabled = false;
          if (res && res.ok) {
            panel.querySelectorAll('[data-sa]').forEach(function (f) { f.value = ''; });
            if (shipAddrForm) shipAddrForm.hidden = true;
            loadShipAddresses(chosen.contact_id, res.address_id);   // reselect the new one
          } else if (shipAddrErr) {
            shipAddrErr.hidden = false; shipAddrErr.textContent = shipAddrErr.getAttribute('data-label') || 'error';
          }
        })
        .catch(function () { shipAddrSave.disabled = false; if (shipAddrErr) { shipAddrErr.hidden = false; shipAddrErr.textContent = shipAddrErr.getAttribute('data-label') || ''; } });
    });
    function selectContact(c) {
      cpReset();
      chosen = c;
      renderSelected(c);
      searchEl.value = '';
      discountEl.value = presetFromEkptosi(c.ekptosi);
      // Prefill the shipping method from the contact's saved courier (cf_f44e1d).
      // Setting .value to a non-matching string leaves the dropdown unselected.
      if (shippingMethodEl) shippingMethodEl.value = c.courier || '';
      // Prefill the payment term from the contact's saved Zoho term. Options are
      // "<days>|<label>" (staff-order-payment-options.liquid); rebuild that shape
      // from the contact fields. Same graceful-degrade as the courier above — a
      // value matching no <option> leaves the dropdown unselected.
      if (paymentEl) {
        paymentEl.value = c.payment_terms_label
          ? ((c.payment_terms || '0') + '|' + c.payment_terms_label)
          : '';
      }
      if (c.contact_id) loadShipAddresses(c.contact_id);
      loadCatalogs(c.contact_id);
      saveState();
      renderTotals();
    }

    // ---- Contact panel (ORG-773) ------------------------------------------------
    // «Στοιχεία πελάτη» under the selected card opens a full-height panel over the page:
    // basics (ΑΦΜ/ΔΟΥ locked) and address cards on the left, the persons table on the
    // right. Every value saves on its own — Enter saves that one field to Zoho, Esc
    // cancels, Tab saves and opens the next — through listen's per-field routes
    // (ORG-774), which merge only the sent key onto the live Zoho record. Saves run one
    // at a time (cpQueue): listen reads the live person/address before it writes, so two
    // saves on one person in flight together would each write back the other's old value.
    // The basics Τηλέφωνο/Email ARE the primary person's (Zoho derives them; PUT
    // /staff/contact routes them there), so editing one repaints the other.
    var cpOpenBtn = $('[data-staff-cp-open]', panel);
    var cpEl = $('[data-staff-cp]', panel);
    var cpBody = cpEl && $('[data-cp-body]', cpEl);
    var cpTitle = cpEl && $('[data-cp-title]', cpEl);
    var cpStatus = cpEl && $('[data-cp-status]', cpEl);
    var CP = null;               // panel state for the open contact (null: closed / not loaded)
    var cpQueue = Promise.resolve();
    var cpSeq = 0;               // local ids for rows (a new person has no Zoho id yet)
    var cpLoadSeq = 0;           // drops a late load for a contact no longer shown
    var CP_EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    var CP_FIELDS = {
      c: ['name', 'phone', 'email', 'notes'],
      p: ['name', 'designation', 'email', 'phone', 'mobile'],
      a: ['address', 'zip', 'city', 'attention', 'phone']
    };
    var CP_TYPE = { phone: 'tel', mobile: 'tel', email: 'email', notes: 'textarea' };
    var CP_ICONS = {
      check: '<polyline points="20 6 9 17 4 12"/>',
      alert: '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
      edit: '<path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>',
      lock: '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
      plus: '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
      star: '<polygon fill="currentColor" points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
      starO: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
      trash: '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>',
      user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
      brief: '<rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>',
      mail: '<rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22 6 12 13 2 6"/>',
      phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>',
      mobile: '<rect x="6" y="2" width="12" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>',
      search: '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>',
      receipt: '<path d="M4 2v20l3-2 3 2 3-2 3 2 3-2 1 .7V2l-1 .7-3-2-3 2-3-2-3 2-3-2z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/>',
      truck: '<rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>'
    };
    function cpIc(n) {
      return '<svg class="staff-cp__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + CP_ICONS[n] + '</svg>';
    }
    function cpL(k, vars) {
      var s = (cpEl && cpEl.getAttribute('data-l-' + k)) || k;
      Object.keys(vars || {}).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); });
      return s;
    }
    function cpNow() { var d = new Date(); return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2); }
    function cpPrimary() { return CP.persons.filter(function (p) { return p.primary; })[0] || null; }
    function cpEnt(kind, uid) {
      if (kind === 'c') return CP.contact;
      var list = kind === 'p' ? CP.persons : CP.addrs;
      return list.filter(function (x) { return x.uid === uid; })[0] || null;
    }
    function cpLinked(kind, f) { return kind === 'c' && (f === 'phone' || f === 'email'); }
    function cpGet(kind, uid, f) {
      if (cpLinked(kind, f)) { var p = cpPrimary(); if (p) return p[f] || ''; }
      var o = cpEnt(kind, uid); return o ? o[f] || '' : '';
    }
    function cpSet(kind, uid, f, v) {
      if (cpLinked(kind, f)) { var p = cpPrimary(); if (p) { p[f] = v; return; } }
      var o = cpEnt(kind, uid); if (o) o[f] = v;
    }
    function cpKey(kind, uid, f) { return kind + ':' + uid + ':' + f; }
    function cpParse(key) { var s = key.split(':'); return { kind: s[0], uid: s[1], f: s[2] }; }
    function cpLabel(k) { return cpL(k.kind + '-' + k.f); }
    // The keys showing the same Zoho value: the basics phone/email and the primary's.
    function cpPaired(key) {
      var k = cpParse(key), p = cpPrimary(), out = [key];
      if (!p) return out;
      if (cpLinked(k.kind, k.f)) out.push(cpKey('p', p.uid, k.f));
      if (k.kind === 'p' && k.uid === p.uid && (k.f === 'phone' || k.f === 'email')) out.push(cpKey('c', 'c', k.f));
      return out;
    }

    function cpStatusSay(ok, text) {
      if (!cpStatus) return;
      cpStatus.hidden = false;
      cpStatus.className = 'staff-cp__status ' + (ok ? 'is-ok' : 'is-err');
      cpStatus.innerHTML = cpIc(ok ? 'check' : 'alert') + '<span>' + escapeHtml(text) + '</span>';
    }
    function cpErrText(e) {
      if (e && e.status === 401) return cpL('e-auth');
      var code = e && e.error;
      if (code === 'person_not_found' || code === 'address_not_found') return cpL('e-gone');
      if (code === 'primary_person') return cpL('e-primary');
      if (code === 'name_required') return cpL('need-name');
      if (code === 'missing_fields') return cpL('need-street');
      return code ? String(code) : cpL('e-other');
    }
    // One listen write. Resolves with the JSON body; rejects with {status, error}.
    function cpReq(method, path, body) {
      return staffFetch(path, { method: method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !j || !j.ok) throw { status: r.status, error: j && j.error };
            return j;
          });
        });
    }
    function cpEnqueue(fn) {
      var run = cpQueue.then(fn);
      cpQueue = run.catch(function () {});
      return run;
    }

    // ---- one editable value ----
    function cpCellInner(key) {
      var k = cpParse(key), label = cpLabel(k), val = cpGet(k.kind, k.uid, k.f);
      if (CP.ef === key) {
        var bad = CP.efErr ? ' is-bad' : '', type = CP_TYPE[k.f] || 'text', dv = escapeHtml(CP.efDraft);
        var input = type === 'textarea'
          ? '<textarea class="staff-cp__in' + bad + '" data-cp-in="' + key + '" rows="3" aria-label="' + escapeHtml(label) + '">' + dv + '</textarea>'
          : '<input class="staff-cp__in' + bad + '" data-cp-in="' + key + '" type="' + type + '" value="' + dv + '" aria-label="' + escapeHtml(label) + '" autocomplete="off">';
        return input + (CP.efErr ? '<span class="staff-cp__err" role="alert">' + cpIc('alert') + escapeHtml(CP.efErr) + '</span>' : '');
      }
      var st = CP.st[key], mark;
      if (st && st.s === 'saving') mark = '<span class="staff-cp__spin" data-cp-mark="saving" title="' + escapeHtml(cpL('saving')) + '"></span>';
      else if (st && st.s === 'saved') mark = '<span class="staff-cp__ok" data-cp-mark="saved" title="' + escapeHtml(cpL('saved', { t: st.t })) + '">' + cpIc('check') + '<span class="staff-cp__sr">' + escapeHtml(cpL('saved', { t: st.t })) + '</span></span>';
      else if (st && st.s === 'err') mark = '<span class="staff-cp__bad" data-cp-mark="err" title="' + escapeHtml(st.msg) + '">' + cpIc('alert') + '<span class="staff-cp__sr">' + escapeHtml(st.msg) + '</span></span>';
      else mark = '<span class="staff-cp__pen">' + cpIc('edit') + '</span>';
      return '<button type="button" class="staff-cp__ef' + (st && st.s === 'err' ? ' is-err' : '') + '" data-cp-ef="' + key + '" title="' + escapeHtml(val || label) + '"'
        + ' aria-label="' + escapeHtml(label + ': ' + (val || cpL('empty')) + '. ' + cpL('edit')) + '">'
        + '<span class="staff-cp__v">' + (val ? escapeHtml(val) : '<span class="staff-cp__empty">—</span>') + '</span>' + mark + '</button>';
    }
    function cpCell(kind, uid, f) {
      var key = cpKey(kind, uid, f);
      return '<span class="staff-cp__cell" data-cp-cell="' + key + '">' + cpCellInner(key) + '</span>';
    }
    function cpPaint(key) {
      if (!cpEl) return;
      cpEl.querySelectorAll('[data-cp-cell="' + key + '"]').forEach(function (el) { el.innerHTML = cpCellInner(key); });
    }
    function cpFocusEditor() {
      var el = cpEl.querySelector('[data-cp-in]');
      if (!el) return;
      el.focus();
      try { el.setSelectionRange(el.value.length, el.value.length); } catch (e) {}
    }
    function cpFocusCell(key) {
      var b = cpEl.querySelector('[data-cp-cell="' + key + '"] [data-cp-ef]');
      if (b) b.focus();
    }

    // ---- render ----
    function cpAddrHtml(a) {
      if (CP.delAsk === a.uid) {
        return '<div class="staff-cp__ad is-del"><p class="staff-cp__delq">' + cpIc('trash') + '<span>' + escapeHtml(cpL('del-addr', { x: a.address })) + '</span></p>'
          + '<div class="staff-cp__row"><button type="button" class="staff-cp__btn-red" data-cp-act="a-del-yes" data-uid="' + a.uid + '">' + escapeHtml(cpL('yes')) + '</button>'
          + '<button type="button" class="staff-cp__btn" data-cp-act="del-no">' + escapeHtml(cpL('no')) + '</button></div></div>';
      }
      var chips = '';
      if (a.billing) chips += '<span class="staff-cp__chip staff-cp__chip--bill">' + cpIc('receipt') + escapeHtml(cpL('billing')) + '</span>';
      if (!a.billing || a.shipDefault) chips += '<span class="staff-cp__chip staff-cp__chip--ship">' + cpIc('truck') + escapeHtml(cpL('shipping')) + '</span>';
      if (a.pending) chips += '<span class="staff-cp__chip staff-cp__chip--new">' + escapeHtml(cpL('new')) + '</span>';
      // Zoho refuses to delete either default address (billing / default shipping).
      var del = (a.billing || a.shipDefault || a.pending) ? ''
        : '<button type="button" class="staff-cp__icon" data-cp-act="a-del" data-uid="' + a.uid + '" title="' + escapeHtml(cpL('delete')) + '" aria-label="' + escapeHtml(cpL('delete') + ' ' + a.address) + '">' + cpIc('trash') + '</button>';
      return '<div class="staff-cp__ad" data-cp-addr="' + a.uid + '"><div class="staff-cp__ad-h">' + chips + '<span class="staff-cp__grow"></span>' + del + '</div>'
        + '<dl class="staff-cp__kv">' + cpKv('a', a.uid, 'address', true) + cpKv('a', a.uid, 'zip') + cpKv('a', a.uid, 'city')
        + cpKv('a', a.uid, 'attention') + cpKv('a', a.uid, 'phone') + '</dl></div>';
    }
    // A label + value pair in a two-pairs-per-row list; `wide` takes the rest of the row.
    function cpKv(kind, uid, f, wide) {
      return '<dt>' + escapeHtml(cpL(kind + '-' + f)) + '</dt><dd' + (wide ? ' class="is-wide"' : '') + '>' + cpCell(kind, uid, f) + '</dd>';
    }
    // One person: a grid whose tracks every row shares, so the columns line up down the
    // list (name / email | Θέση / Τηλέφωνο | Κινητό); each value has its own icon.
    function cpRowHtml(p) {
      if (CP.delAsk === p.uid) {
        return '<div class="staff-cp__p"><div class="staff-cp__delrow">' + cpIc('trash') + '<span>' + escapeHtml(cpL('del-person', { x: p.name })) + '</span>'
          + '<button type="button" class="staff-cp__btn-red" data-cp-act="p-del-yes" data-uid="' + p.uid + '">' + escapeHtml(cpL('yes')) + '</button>'
          + '<button type="button" class="staff-cp__btn" data-cp-act="del-no">' + escapeHtml(cpL('no')) + '</button></div></div>';
      }
      var busy = CP.st['p:' + p.uid + ':*'];
      var star = p.pending ? '<span class="staff-cp__chip staff-cp__chip--new">' + escapeHtml(cpL('new')) + '</span>'
        : busy ? '<span class="staff-cp__spin" title="' + escapeHtml(cpL('saving')) + '"></span>'
        : p.primary ? '<span class="staff-cp__star is-on" role="img" data-cp-primary title="' + escapeHtml(cpL('primary')) + '" aria-label="' + escapeHtml(cpL('primary')) + '">' + cpIc('star') + '</span>'
        : '<button type="button" class="staff-cp__star" data-cp-act="p-primary" data-uid="' + p.uid + '" title="' + escapeHtml(cpL('make-primary')) + '" aria-label="' + escapeHtml(cpL('make-primary') + ': ' + p.name) + '">' + cpIc('starO') + '</button>';
      var del = (p.primary || p.pending) ? ''
        : '<button type="button" class="staff-cp__icon" data-cp-act="p-del" data-uid="' + p.uid + '" title="' + escapeHtml(cpL('delete')) + '" aria-label="' + escapeHtml(cpL('delete') + ' ' + p.name) + '">' + cpIc('trash') + '</button>';
      var slot = function (f, icon) {
        return '<span class="staff-cp__slot s-' + f + '" title="' + escapeHtml(cpL('p-' + f)) + '">' + cpIc(icon) + cpCell('p', p.uid, f) + '</span>';
      };
      return '<div class="staff-cp__p' + (p.primary ? ' is-primary' : '') + '" data-cp-person="' + p.uid + '"><span class="staff-cp__p-star">' + star + '</span>'
        + slot('name', 'user') + slot('designation', 'brief') + slot('email', 'mail') + slot('phone', 'phone') + slot('mobile', 'mobile')
        + '<span class="staff-cp__p-del">' + del + '</span></div>';
    }
    function cpTbodyHtml() {
      var q = foldGreek(CP.q);
      var list = CP.persons.filter(function (p) {
        return p.pending || !q || foldGreek([p.name, p.designation, p.email, p.phone, p.mobile].join(' ')).indexOf(q) !== -1;
      });
      // pending first, then the primary, then Zoho's order (a stable sort keeps it)
      list = list.map(function (p, i) { return [p, i]; }).sort(function (a, b) {
        var ra = a[0].pending ? 2 : a[0].primary ? 1 : 0, rb = b[0].pending ? 2 : b[0].primary ? 1 : 0;
        return (rb - ra) || (a[1] - b[1]);
      }).map(function (x) { return x[0]; });
      if (!list.length) {
        var none = CP.persons.length ? cpL('none', { q: CP.q }) : cpL('no-persons');
        return '<p class="staff-cp__none">' + escapeHtml(none) + '</p>';
      }
      return list.map(cpRowHtml).join('');
    }
    function cpRender() {
      if (!CP || !cpBody) return;
      if (CP.loading || CP.loadErr) {
        cpBody.innerHTML = '<p class="staff-cp__msg" data-cp-loading>' + (CP.loading ? '<span class="staff-cp__spin"></span>' + escapeHtml(cpL('loading'))
          : cpIc('alert') + escapeHtml(cpL('load-err')) + ' <button type="button" class="staff-cp__btn" data-cp-act="retry">' + escapeHtml(cpL('retry')) + '</button>') + '</p>';
        return;
      }
      var top = cpBody.scrollTop;
      var filterHad = document.activeElement && document.activeElement.hasAttribute && document.activeElement.hasAttribute('data-cp-filter');
      var c = CP.contact;
      var ro = function (label, v) {
        return '<dt>' + escapeHtml(cpL(label)) + '</dt><dd class="staff-cp__ro" title="' + escapeHtml(cpL('locked')) + '">' + cpIc('lock') + '<span>' + escapeHtml(v || '—') + '</span></dd>';
      };
      var sec = function (label, extra) { return '<div class="staff-cp__sec"><h3>' + escapeHtml(label) + '</h3>' + (extra || '') + '</div>'; };
      var n = CP.persons.filter(function (p) { return !p.pending; }).length;
      var h = sec(cpL('sec-persons', { n: n }))
        + '<div class="staff-cp__tools"><label class="staff-cp__filter">' + cpIc('search')
        + '<input type="search" data-cp-filter value="' + escapeHtml(CP.q) + '" autocomplete="off" aria-label="' + escapeHtml(cpL('search', { n: n })) + '" placeholder="' + escapeHtml(cpL('search', { n: n })) + '"></label>'
        + '<button type="button" class="staff-cp__add" data-cp-act="p-add">' + cpIc('plus') + escapeHtml(cpL('add-person')) + '</button></div>'
        + '<div class="staff-cp__plist" data-cp-tbody>' + cpTbodyHtml() + '</div>'
        + sec(cpL('sec-basics')) + '<dl class="staff-cp__kv" data-cp-basics>' + ro('afm', c.afm) + ro('doy', c.doy)
        + cpKv('c', 'c', 'name', true) + cpKv('c', 'c', 'phone') + cpKv('c', 'c', 'email') + cpKv('c', 'c', 'notes', true) + '</dl>'
        + sec(cpL('sec-addrs'), '<button type="button" class="staff-cp__add" data-cp-act="a-add">' + cpIc('plus') + escapeHtml(cpL('add-addr')) + '</button>')
        + '<div class="staff-cp__addrs">' + CP.addrs.map(cpAddrHtml).join('') + '</div>';
      cpBody.innerHTML = h;
      cpBody.scrollTop = top;
      if (CP.ef) cpFocusEditor();
      else if (filterHad) { var f = cpBody.querySelector('[data-cp-filter]'); f.focus(); f.setSelectionRange(f.value.length, f.value.length); }
    }
    function cpSyncOpenBtn() {}   // the card shows no counts (John 2026-10-15)

    // ---- load ----
    function cpLoad() {
      var cid = chosen && chosen.contact_id;
      if (!cid) return;
      var my = ++cpLoadSeq;
      CP = { contactId: cid, loading: true, contact: {}, persons: [], addrs: [], st: {}, q: '', ef: null, efDraft: '', efErr: null, delAsk: null, addrDirty: false };
      cpRender();
      var q = '?contact_id=' + encodeURIComponent(cid);
      var json = function (r) { return r.json(); };
      Promise.all([staffFetch('/staff/contact-live' + q).then(json), staffFetch('/staff/contact-addresses' + q).then(json)])
        .then(function (res) {
          if (my !== cpLoadSeq) return;
          var live = res[0] && res[0].ok && res[0].contact;
          if (!live || !(res[1] && res[1].ok)) throw new Error('load');
          CP.loading = false;
          CP.contact = { name: live.contact_name || '', afm: live.afm || '', doy: live.doy || '',
                         phone: live.phone || '', email: live.email || '', notes: live.remarks || '' };
          CP.persons = (live.contact_persons || []).map(function (p) {
            return { uid: 'p' + (++cpSeq), id: p.contact_person_id, name: p.name || '', designation: p.designation || '',
                     email: p.email || '', phone: p.phone || '', mobile: p.mobile || '', primary: !!p.is_primary };
          });
          CP.addrs = (res[1].addresses || []).map(function (a) {
            return { uid: 'a' + (++cpSeq), id: a.address_id, billing: !!a.is_billing, shipDefault: !!a.is_default_shipping,
                     address: a.address || '', zip: a.zip || '', city: a.city || '', attention: a.attention || '', phone: a.phone || '' };
          });
          if (cpTitle) cpTitle.textContent = CP.contact.name || chosen.contact_name || '';
          cpRender(); cpSyncOpenBtn();
        })
        .catch(function () {
          if (my !== cpLoadSeq || !CP) return;
          CP.loading = false; CP.loadErr = true; cpRender();
        });
    }
    // Pushed like a phone app screen (John 2026-10-15): it lives inside the cart drawer's
    // panel, slides in from the right while the cart slides a little left (CSS on
    // .is-open / .staff-cp-pushed), and plays back on close, then hides. The cart under it
    // is inert meanwhile, so Tab stays on this screen.
    var cpHideTimer = null;
    var CP_ANIM_MS = 320;
    function cpHost() { return document.querySelector('#cart-drawer .site-drawer__panel'); }
    function cpSetPushed(on) {
      var host = cpHost();
      if (!host) return;
      host.classList.toggle('staff-cp-pushed', on);
      Array.prototype.forEach.call(host.children, function (ch) { if (ch !== cpEl) ch.inert = on; });
    }
    function cpIsOpen() { return !!(cpEl && cpEl.classList.contains('is-open')); }
    function cpShow() {
      clearTimeout(cpHideTimer);
      cpEl.hidden = false;
      void cpEl.offsetWidth;   // commit the closed state so the transition runs
      cpEl.classList.add('is-open');
      cpSetPushed(true);
    }
    function cpHide(now) {
      cpEl.classList.remove('is-open');
      cpSetPushed(false);
      clearTimeout(cpHideTimer);
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (now || still) { cpEl.hidden = true; return; }
      cpHideTimer = setTimeout(function () { if (!cpIsOpen()) cpEl.hidden = true; }, CP_ANIM_MS);
    }
    function cpOpen() {
      if (!cpEl || !chosen || !chosen.contact_id) return;
      var host = cpHost();
      if (!host) return;
      if (cpEl.parentNode !== host) host.appendChild(cpEl);
      if (cpTitle) cpTitle.textContent = chosen.contact_name || '';
      if (cpStatus) cpStatus.hidden = true;
      cpShow();
      cpLoad();
      var back = cpEl.querySelector('[data-cp-act="close"]');
      if (back) back.focus();
    }
    function cpClose() {
      if (!cpIsOpen()) return;
      if (CP && CP.ef && !cpCommit()) return;
      cpHide();
      // The drawer's own address cards read the same Zoho addresses: re-fetch once
      // they may have changed (the queue first, so the read sees the last write).
      if (CP && CP.addrDirty && chosen && chosen.contact_id) {
        var cid = chosen.contact_id;
        cpQueue.then(function () { if (chosen && chosen.contact_id === cid) loadShipAddresses(cid, chosenAddrId); });
        CP.addrDirty = false;
      }
      if (cpOpenBtn && selectedEl && !selectedEl.hidden) cpOpenBtn.focus();
    }
    // A different (or no) contact: drop the panel state.
    function cpReset() {
      cpLoadSeq++;
      if (cpEl && !cpEl.hidden) cpHide(true);
      CP = null;
      cpSyncOpenBtn();
    }

    // The selected card shows the contact name and the billing address: keep both current.
    function cpRefreshCard(k, a) {
      if (!chosen) return;
      if (k.kind === 'c' && k.f === 'name') {
        chosen.contact_name = CP.contact.name;
        if (cpTitle) cpTitle.textContent = CP.contact.name;
      } else if (k.kind === 'a' && a && a.billing && (k.f === 'address' || k.f === 'city' || k.f === 'zip')) {
        if (k.f === 'address') chosen.billing_address = a.address;
        if (k.f === 'city') chosen.city = a.city;
        if (k.f === 'zip') chosen.billing_zip = a.zip;
      } else return;
      renderSelected(chosen);
      saveState();
    }

    // ---- save ----
    function cpValidate(k, v) {
      if (k.f === 'email' && v && !CP_EMAIL.test(v)) return cpL('bad-email');
      if (k.f === 'name' && !v) return k.kind === 'c' ? cpL('need-cname') : cpL('need-name');
      if (k.kind === 'a' && k.f === 'address' && !v) return cpL('need-street');
      return null;
    }
    function cpDrop(k) {
      if (k.kind === 'p') CP.persons = CP.persons.filter(function (p) { return p.uid !== k.uid; });
      if (k.kind === 'a') CP.addrs = CP.addrs.filter(function (a) { return a.uid !== k.uid; });
    }
    // The request for one saved field. Runs inside the queue, so a new row's id from
    // its create (an earlier queue step) is there by the time its other fields save.
    function cpSend(k, v) {
      var cid = CP.contactId, o = cpEnt(k.kind, k.uid);
      if (k.kind === 'c') {
        var body = { contact_id: cid };
        body[k.f === 'name' ? 'contact_name' : k.f] = v;
        return cpReq('PUT', '/staff/contact', body);
      }
      if (!o) return Promise.reject({ error: 'gone' });
      if (k.kind === 'p') {
        if (!o.id) {
          if (k.f !== 'name') return Promise.reject({ error: 'name_required' });
          return cpReq('POST', '/staff/contact-person', { contact_id: cid, name: v })
            .then(function (j) { o.id = j.contact_person_id; return j; });
        }
        var pb = { contact_id: cid, contact_person_id: o.id }; pb[k.f] = v;
        return cpReq('PUT', '/staff/contact-person', pb);
      }
      if (!o.id) {
        if (k.f !== 'address') return Promise.reject({ error: 'missing_fields' });
        return cpReq('POST', '/staff/contact-address', { contact_id: cid, address: v })
          .then(function (j) { o.id = j.address_id; return j; });
      }
      var ab = { contact_id: cid, address_id: o.id }; ab[k.f] = v;
      return cpReq('POST', '/staff/contact-address/update', ab);
    }
    // Close the open editor and save its value. false = the value is invalid and the
    // editor stays open with its message.
    function cpCommit() {
      var key = CP && CP.ef;
      if (!key) return true;
      var k = cpParse(key), o = cpEnt(k.kind, k.uid);
      var v = String(CP.efDraft || '').trim();
      if (CP_TYPE[k.f] === 'tel') v = normPhone(v);
      var creating = !!(o && o.pending);
      if (creating && !v) { CP.ef = null; CP.efErr = null; cpDrop(k); cpRender(); return true; }
      var err = cpValidate(k, v);
      if (err) {
        CP.efErr = err; cpPaint(key); cpFocusEditor();
        return false;
      }
      CP.ef = null; CP.efErr = null;
      var old = cpGet(k.kind, k.uid, k.f);
      if (!creating && v === old) { cpPaint(key); return true; }
      cpSet(k.kind, k.uid, k.f, v);
      if (creating) o.pending = false;
      var keys = cpPaired(key);
      keys.forEach(function (x) { CP.st[x] = { s: 'saving' }; });
      if (creating) cpRender(); else keys.forEach(cpPaint);
      if (k.kind === 'a') CP.addrDirty = true;
      var mine = CP, label = cpLabel(k);
      cpEnqueue(function () {
        if (CP !== mine) return null;
        return cpSend(k, v).then(function () {
          if (CP !== mine) return;
          var t = cpNow();
          keys.forEach(function (x) { CP.st[x] = { s: 'saved', t: t }; if (CP.ef !== x) cpPaint(x); });
          cpStatusSay(true, creating ? cpL(k.kind === 'p' ? 'st-created-p' : 'st-created-a', { x: v }) : cpL('st-saved', { f: label }));
          cpRefreshCard(k, o);
          cpSyncOpenBtn();
          setTimeout(function () {
            keys.forEach(function (x) { if (CP === mine && CP.st[x] && CP.st[x].t === t) { delete CP.st[x]; if (CP.ef !== x) cpPaint(x); } });
          }, 6000);
        }, function (e) {
          if (CP !== mine) return;
          var msg = cpErrText(e);
          cpStatusSay(false, cpL('st-failed', { f: label, e: msg }));
          if (creating && o && !o.id) { cpDrop(k); keys.forEach(function (x) { delete CP.st[x]; }); cpRender(); return; }
          cpSet(k.kind, k.uid, k.f, old);   // the value shown is Zoho's again
          keys.forEach(function (x) { CP.st[x] = { s: 'err', msg: msg }; if (CP.ef !== x) cpPaint(x); });
        });
      });
      return true;
    }
    function cpCancel() {
      var key = CP && CP.ef;
      if (!key) return;
      var k = cpParse(key), o = cpEnt(k.kind, k.uid);
      CP.ef = null; CP.efErr = null;
      if (o && o.pending) { cpDrop(k); cpRender(); return; }
      cpPaint(key);
      cpFocusCell(key);
    }
    function cpEdit(key) {
      if (!CP || CP.ef === key) return;
      if (!cpCommit()) return;
      var k = cpParse(key);
      if (!cpEnt(k.kind, k.uid)) return;
      CP.ef = key; CP.efErr = null; CP.delAsk = null;
      CP.efDraft = cpGet(k.kind, k.uid, k.f);
      if (CP.st[key] && CP.st[key].s === 'err') delete CP.st[key];
      cpPaint(key);
      cpFocusEditor();
    }

    // ---- row actions ----
    function cpPersonAction(uid, path, done) {
      var p = cpEnt('p', uid), mine = CP;
      if (!p || !p.id) return;
      CP.st['p:' + uid + ':*'] = { s: 'saving' };
      CP.delAsk = null;
      cpRender();
      cpEnqueue(function () {
        if (CP !== mine) return null;
        return cpReq('POST', path, { contact_id: CP.contactId, contact_person_id: p.id }).then(function () {
          if (CP !== mine) return;
          delete CP.st['p:' + uid + ':*'];
          done(p);
          cpRender(); cpSyncOpenBtn();
        }, function (e) {
          if (CP !== mine) return;
          delete CP.st['p:' + uid + ':*'];
          cpStatusSay(false, cpL('st-failed', { f: p.name, e: cpErrText(e) }));
          cpRender();
        });
      });
    }
    function cpAct(act, uid) {
      if (act === 'close') { cpClose(); return; }
      if (act === 'retry') { cpLoad(); return; }
      if (!CP || CP.loading || CP.loadErr) return;
      if (CP.ef && !cpCommit()) return;
      if (act === 'p-add') {
        var np = { uid: 'p' + (++cpSeq), id: null, name: '', designation: '', email: '', phone: '', mobile: '', primary: false, pending: true };
        CP.persons.unshift(np);
        CP.q = ''; CP.delAsk = null;
        CP.ef = cpKey('p', np.uid, 'name'); CP.efDraft = ''; CP.efErr = null;
        cpRender();
        cpBody.scrollTop = 0;
      } else if (act === 'a-add') {
        var na = { uid: 'a' + (++cpSeq), id: null, billing: false, shipDefault: false, address: '', zip: '', city: '', attention: '', phone: '', pending: true };
        CP.addrs.push(na);
        CP.delAsk = null;
        CP.ef = cpKey('a', na.uid, 'address'); CP.efDraft = ''; CP.efErr = null;
        cpRender();
      } else if (act === 'p-del' || act === 'a-del') {
        CP.delAsk = uid; cpRender();
        var yes = cpBody.querySelector('[data-cp-act$="-del-yes"]'); if (yes) yes.focus();
      } else if (act === 'del-no') {
        CP.delAsk = null; cpRender();
      } else if (act === 'p-del-yes') {
        cpPersonAction(uid, '/staff/contact-person/delete', function (p) {
          CP.persons = CP.persons.filter(function (x) { return x.uid !== p.uid; });
          cpStatusSay(true, cpL('st-deleted', { x: p.name }));
        });
      } else if (act === 'p-primary') {
        cpPersonAction(uid, '/staff/contact-person/primary', function (p) {
          CP.persons.forEach(function (x) { x.primary = x.uid === p.uid; });
          cpStatusSay(true, cpL('st-primary', { x: p.name }));
        });
      } else if (act === 'a-del-yes') {
        var a = cpEnt('a', uid), mine = CP;
        if (!a || !a.id) return;
        CP.delAsk = null; CP.addrDirty = true;
        cpEnqueue(function () {
          if (CP !== mine) return null;
          return cpReq('POST', '/staff/contact-address/delete', { contact_id: CP.contactId, address_id: a.id }).then(function () {
            if (CP !== mine) return;
            CP.addrs = CP.addrs.filter(function (x) { return x.uid !== a.uid; });
            cpStatusSay(true, cpL('st-deleted', { x: a.address }));
            cpRender(); cpSyncOpenBtn();
          }, function (e) {
            if (CP !== mine) return;
            cpStatusSay(false, cpL('st-failed', { f: a.address, e: cpErrText(e) }));
            cpRender();
          });
        });
        cpRender();
      }
    }

    if (cpOpenBtn) cpOpenBtn.addEventListener('click', cpOpen);
    // Closing the whole drawer (its overlay, or another script) takes the pushed screen
    // with it, so the cart opens on the cart next time.
    document.addEventListener('click', function (e) {
      if (cpIsOpen() && e.target.closest && e.target.closest('#cart-drawer .site-drawer__overlay')) {
        if (CP && CP.ef) cpCommit();
        cpHide(true);
      }
    });
    if (cpEl) {
      cpEl.addEventListener('click', function (e) {
        var ef = e.target.closest('[data-cp-ef]');
        if (ef) { cpEdit(ef.getAttribute('data-cp-ef')); return; }
        var t = e.target.closest('[data-cp-act]');
        if (t) { cpAct(t.getAttribute('data-cp-act'), t.getAttribute('data-uid')); return; }
      });
      // Clicking another value while one is open: keep focus where it is so the
      // focusout commit doesn't race the click that opens the next one.
      cpEl.addEventListener('mousedown', function (e) {
        if (CP && CP.ef && e.target.closest('[data-cp-ef]')) e.preventDefault();
      });
      cpEl.addEventListener('focusout', function (e) {
        var t = e.target;
        if (!t.hasAttribute || !t.hasAttribute('data-cp-in')) return;
        var key = t.getAttribute('data-cp-in');
        setTimeout(function () {
          if (!CP || CP.ef !== key) return;
          var a = document.activeElement;
          if (a && a.hasAttribute && a.hasAttribute('data-cp-in')) return;
          cpCommit();
        }, 0);
      });
      cpEl.addEventListener('input', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-cp-in')) {
          CP.efDraft = t.value;
          if (CP.efErr) {
            CP.efErr = null; t.classList.remove('is-bad');
            var m = t.parentNode.querySelector('.staff-cp__err'); if (m) m.remove();
          }
        } else if (t.hasAttribute('data-cp-filter')) {
          CP.q = t.value;
          var tb = cpBody.querySelector('[data-cp-tbody]'); if (tb) tb.innerHTML = cpTbodyHtml();
        }
      });
    }
    // Window capture: runs before site-drawer.js's document-level Escape (which would
    // close the whole cart drawer), and owns Enter/Tab inside an editor.
    window.addEventListener('keydown', function (e) {
      if (!cpIsOpen() || !CP) {
        if (cpIsOpen() && e.key === 'Escape') { e.stopPropagation(); cpClose(); }
        return;
      }
      var t = e.target, inEd = t && t.hasAttribute && t.hasAttribute('data-cp-in');
      if (e.key === 'Escape') {
        e.stopPropagation(); e.preventDefault();
        if (CP.ef) cpCancel();
        else if (CP.delAsk) { CP.delAsk = null; cpRender(); }
        else cpClose();
        return;
      }
      if (!inEd) return;
      var key = t.getAttribute('data-cp-in');
      if (e.key === 'Enter' && !(t.tagName === 'TEXTAREA' && e.shiftKey)) {
        e.preventDefault();
        if (cpCommit()) cpFocusCell(key);
        return;
      }
      if (e.key === 'Tab') {
        e.preventDefault();
        var cells = Array.prototype.map.call(cpEl.querySelectorAll('[data-cp-cell]'), function (c) { return c.getAttribute('data-cp-cell'); });
        var next = cells[cells.indexOf(key) + (e.shiftKey ? -1 : 1)];
        if (!cpCommit()) return;
        if (next && cpEl.querySelector('[data-cp-cell="' + next + '"]')) cpEdit(next);
        else cpFocusCell(key);
      }
    }, true);
    // «📚 Κατάλογοι» (ops spec 2026-09-23): what the customer already got
    // (one line) + an unticked box per in-stock catalogue they lack.
    // Invoices + receipts only; ticked SKUs ride on create-doc as `catalogs`.
    function fmtCatDate(s) { return s ? s.slice(8, 10) + '/' + s.slice(5, 7) + '/' + s.slice(2, 4) : ''; }
    // «Insize PG-E31»: vendor before the code, unless the code already names it («VERTEX»).
    function catName(x) {
      var v = x.vendor || '';
      var l = x.label || '';
      return (v && l.toUpperCase().indexOf(v.toUpperCase()) === -1) ? v + ' ' + l : l;
    }
    function pickedCatalogs() {
      return Object.keys(catalogPicked).filter(function (k) { return catalogPicked[k]; });
    }
    function renderCatalogs() {
      if (!catalogsEl) return;
      var d = catalogData;
      var show = !!(chosen && d && CATALOG_DOCS[docEl.value]);
      catalogsEl.hidden = !show;
      if (!show) { catalogsEl.innerHTML = ''; return; }
      var L = catalogsEl.dataset;
      var n = pickedCatalogs().length;
      var tab = d.retail ? 'lack' : catalogTab;
      var html = '<div class="staff-order__catalogs-title">' + escapeHtml(L.lTitle) +
        (n ? ' · ' + n + ' ' + escapeHtml(L.lPicked) : '') + '</div>';
      if (!d.retail) {
        html += '<div class="staff-order__catalogs-tabs">' +
          '<button type="button" class="staff-order__catalogs-tab' + (tab === 'lack' ? ' is-on' : '') +
          '" data-cat-tab="lack">' + escapeHtml(L.lTabLack) + ' · ' + d.offer.length + '</button>' +
          '<button type="button" class="staff-order__catalogs-tab' + (tab === 'got' ? ' is-on' : '') +
          '" data-cat-tab="got">' + escapeHtml(L.lTabGot) + ' · ' + d.has.length + '</button></div>';
      }
      if (tab === 'got') {
        html += d.has.length ? d.has.map(function (h) {
          return '<div class="staff-order__catalogs-hist"><b>' + escapeHtml(catName(h)) + '</b><span>' +
            escapeHtml(fmtCatDate(h.date)) + (h.invoice_number ? ' · ' + escapeHtml(h.invoice_number) : '') + '</span></div>';
        }).join('') : '<div class="staff-order__catalogs-empty">' + escapeHtml(L.lNone) + '</div>';
      } else if (d.offer.length) {
        // ORG-465: listen marks the nightly recommendation (`recommended` + `why`,
        // ORG-444) — «⭐ Προτείνεται» (star + word, never colour alone) and the
        // why-line. The box stays UNTICKED: staff decide.
        d.offer.forEach(function (o) {
          var rec = !!o.recommended;
          html += '<label class="staff-order__catalogs-item' + (rec ? ' is-rec' : '') +
            '"><input type="checkbox" data-catalog-sku="' +
            escapeHtml(o.sku) + '"' + (catalogPicked[o.sku] ? ' checked' : '') + '> ' +
            '<span class="staff-order__catalogs-name">' + escapeHtml(catName(o)) +
            (rec ? ' <span class="staff-order__catalogs-rec" data-catalog-rec>' + escapeHtml(L.lRec) + '</span>' : '') +
            (rec && o.why ? '<span class="staff-order__catalogs-why">' + escapeHtml(o.why) + '</span>' : '') +
            '</span><span class="staff-order__catalogs-stock">' + escapeHtml(String(o.stock)) + '</span></label>';
        });
      } else {
        html += '<div class="staff-order__catalogs-empty">' + escapeHtml(L.lAll) + '</div>';
      }
      catalogsEl.innerHTML = html;
    }
    function loadCatalogs(contactId) {
      catalogData = null; catalogPicked = {}; catalogTab = 'lack';
      renderCatalogs();
      if (!contactId) return;
      staffFetch('/staff/contact-catalogs?contact_id=' + encodeURIComponent(contactId))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!chosen || chosen.contact_id !== contactId) return;   // customer changed meanwhile
          catalogData = (d && d.ok) ? d : null;
          renderCatalogs();
        })
        .catch(function () { catalogData = null; renderCatalogs(); });
    }
    if (catalogsEl) catalogsEl.addEventListener('change', function (e) {
      var sku = e.target && e.target.getAttribute('data-catalog-sku');
      if (!sku) return;
      catalogPicked[sku] = e.target.checked;
      renderCatalogs();
    });
    if (catalogsEl) catalogsEl.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-cat-tab]');
      if (!b) return;
      catalogTab = b.getAttribute('data-cat-tab');
      renderCatalogs();
    });
    changeBtn.addEventListener('click', function () { clearSelection(); });

    // --- New customer ---
    function ncVal(name) { var el = panel.querySelector('[data-nc="' + name + '"]'); return el ? el.value.trim() : ''; }
    // Same, for the phone fields: normalised for Zoho and echoed back into the
    // input so the staffer sees the number exactly as it was saved.
    function ncPhone(name) {
      var el = panel.querySelector('[data-nc="' + name + '"]');
      if (!el) return '';
      var v = normPhone(el.value);
      el.value = v;
      return v;
    }
    // prefill: the name typed into the search when the form was opened from the
    // "create «X»" row, so staff never retype what they just searched for.
    // A searched ΑΦΜ goes to the ΑΦΜ field, not Επωνυμία: {afm} runs the usual
    // ΑΦΜ blur (dedup warning + AADE autofill); {afm, aade} fills from the AADE
    // record /staff/afm-check already returned. A searched Greek phone number goes
    // to Τηλέφωνο (normalised like the field's own save), leaving Επωνυμία empty.
    function openNewForm(prefill) {
      hideAfmDup();
      if (searchWrap) searchWrap.hidden = true;
      if (newBtn) newBtn.hidden = true;
      if (retailBtn) retailBtn.hidden = true;
      if (newForm) newForm.hidden = false;
      var nameEl = panel.querySelector('[data-nc="display_name"]');
      var afm = typeof prefill === 'string' ? asAfm(prefill) : (prefill && prefill.afm) || '';
      if (afm && afmEl) {
        afmEl.value = afm;
        var a = prefill && prefill.aade;
        if (a) {
          var setv = function (n, v) { var el = panel.querySelector('[data-nc="' + n + '"]'); if (el && v) el.value = v; };
          setv('display_name', a.name); setv('doy', a.doy);
          setv('b_address', a.address); setv('b_city', a.city); setv('b_zip', a.zip);
          var phoneEl = panel.querySelector('[data-nc="phone"]');
          if (phoneEl) phoneEl.focus();
        } else {
          afmEl.dispatchEvent(new Event('blur'));
          if (nameEl) nameEl.focus();
        }
        return;
      }
      var tel = typeof prefill === 'string' ? asGrPhone(prefill) : '';
      var telEl = panel.querySelector('[data-nc="phone"]');
      if (tel && telEl) {
        telEl.value = tel;
        if (nameEl) nameEl.focus();
        return;
      }
      if (nameEl) {
        if (typeof prefill === 'string' && prefill) { nameEl.value = prefill; }
        nameEl.focus();
      }
    }
    if (newBtn) newBtn.addEventListener('click', function () { openNewForm(''); });
    // One-tap walk-in retail: fetch the live /staff/contacts row for ΠΕΛΑΤΗΣ
    // ΛΙΑΝΙΚΗΣ and hand it to selectContact — the SAME object shape a search
    // click passes, so payment-terms/courier prefill, addresses and the
    // discount preset behave identically. The pinned contact_id guards against
    // similarly-named contacts; exact-name match is the fallback.
    if (retailBtn) retailBtn.addEventListener('click', function () {
      var rid = retailBtn.getAttribute('data-retail-id');
      var rname = retailBtn.getAttribute('data-retail-name');
      var fail = function () {
        retailBtn.disabled = false;
        if (resultEl) { resultEl.hidden = false; resultEl.textContent = retailBtn.getAttribute('data-label-err') || 'error'; }
      };
      retailBtn.disabled = true;
      if (resultEl) { resultEl.hidden = true; resultEl.textContent = ''; }
      staffFetch('/staff/contacts?q=' + encodeURIComponent(rname))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var hit = (d.results || []).filter(function (c) {
            return String(c.contact_id) === rid || c.contact_name === rname;
          })[0];
          if (!hit) { fail(); return; }
          retailBtn.disabled = false;
          hideAfmDup();
          selectContact(hit);
        })
        .catch(fail);
    });
    function closeNewForm() {
      if (newForm) newForm.hidden = true;
      if (searchWrap) searchWrap.hidden = false;
      if (newBtn) newBtn.hidden = false;
      if (retailBtn) retailBtn.hidden = false;
      hideAfmDup();
    }
    if (newBackBtn) newBackBtn.addEventListener('click', closeNewForm);
    if (shipDiff) shipDiff.addEventListener('change', function () { if (shipWrap) shipWrap.hidden = !shipDiff.checked; });

    var AFM_SVC = (window.AFM_SERVICE || '').replace(/\/$/, '');
    var afmEl = panel.querySelector('[data-nc="afm"]');
    var afmWrapEl = panel.querySelector('[data-nc-afm-wrap]');
    var afmDupEl = panel.querySelector('[data-nc-afm-dup]');
    var afmDupMsg = panel.querySelector('[data-nc-afm-dup-msg]');
    var afmDupSelect = panel.querySelector('[data-nc-afm-dup-select]');
    var afmDupMatch = null;
    function hideAfmDup() { afmDupMatch = null; if (afmDupEl) afmDupEl.hidden = true; }
    if (afmDupSelect) afmDupSelect.addEventListener('click', function () {
      if (afmDupMatch) { selectContact(afmDupMatch); hideAfmDup(); }
    });
    if (afmEl) {
      afmEl.addEventListener('blur', function () {
        var afm = (afmEl.value || '').replace(/\D/g, '');
        if (afm.length !== 9) { hideAfmDup(); return; }
        // Dedup warning — always, independent of the AADE autofill service.
        staffFetch('/staff/contact-by-afm?afm=' + afm)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok && d.match) {
              afmDupMatch = d.match;
              if (afmDupMsg) afmDupMsg.textContent =
                (afmDupEl.getAttribute('data-label') || '') + ' «' + (d.match.contact_name || '') + '»';
              if (afmDupEl) afmDupEl.hidden = false;
            } else { hideAfmDup(); }
          })
          .catch(function () { hideAfmDup(); });
        // AADE ΑΦΜ autofill — only when the afm-service is configured.
        if (!AFM_SVC) return;
        afmEl.classList.add('staff-order__input--loading');
        if (afmWrapEl) afmWrapEl.classList.add('is-loading');
        fetch(AFM_SVC + '/afm/' + afm).then(function (r) { return r.json(); })
          .then(function (d) {
            afmEl.classList.remove('staff-order__input--loading');
            if (afmWrapEl) afmWrapEl.classList.remove('is-loading');
            if (!d || d.error || !d.name) return;
            var setv = function (n, v) { var el = panel.querySelector('[data-nc="' + n + '"]'); if (el && v) el.value = v; };
            setv('display_name', d.name);
            setv('doy', d.doy);
            setv('b_address', d.address);
            setv('b_city', d.city);
            setv('b_zip', d.zip);
          })
          .catch(function () {
            afmEl.classList.remove('staff-order__input--loading');
            if (afmWrapEl) afmWrapEl.classList.remove('is-loading');
          });
      });
    }

    if (newSaveBtn) newSaveBtn.addEventListener('click', function () {
      var name = ncVal('display_name'), afm = ncVal('afm');
      newErr.hidden = true;
      // Επωνυμία is the only hard requirement — ΑΦΜ is often unknown at the
      // counter and can be filled in later, so it must not block the save.
      if (!name) { newErr.hidden = false; newErr.textContent = newErr.getAttribute('data-label-req') || ''; return; }
      newSaveBtn.disabled = true;
      var pp = (panel.querySelector('[data-nc="payment"]').value || '0|μετρητοις').split('|');
      var body = {
        display_name: name, afm: afm, doy: ncVal('doy'),
        phone: ncPhone('phone'), email: ncVal('email'),
        first_name: ncVal('first_name'), last_name: ncVal('last_name'),
        contact_phone: ncPhone('contact_phone'), contact_mobile: ncPhone('contact_mobile'),
        contact_email: ncVal('contact_email'),
        billing: { address: ncVal('b_address'), city: ncVal('b_city'), zip: ncVal('b_zip') },
        payment_terms: parseInt(pp[0], 10) || 0, payment_terms_label: pp.slice(1).join('|')
      };
      if (shipDiff && shipDiff.checked) body.shipping = { address: ncVal('s_address'), city: ncVal('s_city'), zip: ncVal('s_zip') };
      staffFetch('/staff/create-contact', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          newSaveBtn.disabled = false;
          if (res && res.ok) {
            selectContact({ contact_id: res.contact_id, contact_name: res.contact_name || name, afm: afm, city: ncVal('b_city'), billing_address: ncVal('b_address'), billing_zip: ncVal('b_zip'), ekptosi: '' });
          } else {
            newErr.hidden = false;
            newErr.textContent = (newErr.getAttribute('data-label-err') || '') + ': ' + ((res && res.error) || 'unknown');
          }
        })
        .catch(function (e) {
          newSaveBtn.disabled = false; newErr.hidden = false;
          // 401 is not a network fault — the panel has no CRM bearer. Name that,
          // and let the message double as the Connect control.
          // 401 is not a network fault — the panel has no CRM bearer. The
          // Connect button says so; point at it rather than restate it here.
          if (e && e.status === 401) { newErr.hidden = true; flashConnect(); }
          else { newErr.textContent = 'network error'; }
        });
    });

    // --- Payment terms / shipping visibility by doc type ---
    function syncDocTerms() {
      var dt = docEl.value;
      var show = dt === 'salesorder' || dt === 'invoice' || dt === 'receipt' || dt === 'receipt_novat';
      if (docTermsEl) docTermsEl.hidden = !show;
      // Reference only where the backend applies it: quotes, sales orders + invoices.
      if (referenceWrapEl) {
        referenceWrapEl.hidden = !(dt === 'quote' || dt === 'salesorder' || dt === 'invoice');
        // Έκπτωση shares its row with Αναφορά. When the reference half is hidden, collapse
        // the grid to one column so the select fills the row instead of leaving a gap.
        var pair = referenceWrapEl.parentNode;
        if (pair && pair.classList && pair.classList.contains('staff-order__pair')) {
          if (referenceWrapEl.hidden) { pair.classList.add('is-solo'); }
          else { pair.classList.remove('is-solo'); }
        }
      }
      // Adjustment (± on the Zoho total) only where the backend applies it:
      // invoices + receipts.
      if (adjustmentWrapEl) {
        adjustmentWrapEl.hidden = !(dt === 'invoice' || dt === 'receipt' || dt === 'receipt_novat');
      }
      syncRefAttn();
    }
    function setDocType(v) {
      docEl.value = v;
      if (orderAllWrap) orderAllWrap.hidden = v !== 'salesorder';
      if (orderAllEl && v !== 'salesorder') orderAllEl.checked = false;
      docBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-doctype') === v); });
      syncDocTerms();
      hideRefNudge();
      renderCatalogs();
      renderTotals();   // VAT/final rows depend on the doc type
      saveState();
    }
    docBtns.forEach(function (b) {
      b.addEventListener('click', function () { setDocType(b.getAttribute('data-doctype')); });
    });
    setDocType(docEl.value || 'quote');

    // Full reset — «Άδειασμα καλαθιού» empties the line items, but /cart/clear.js
    // touches nothing else: without this the next order inherits the previous
    // customer, discount and doc type, and it's easy to bill the wrong one.
    function resetAll() {
      clearSelection({ focus: false });     // drawer is re-rendering; don't grab focus
      discountEl.value = 'none';
      setDocType('quote');
      if (shippingMethodEl) shippingMethodEl.value = '';   // '' matches no option → unselected
      if (paymentEl) paymentEl.selectedIndex = 0;
      if (referenceEl) referenceEl.value = '';
      syncRefAttn();
      if (orderAllEl) orderAllEl.checked = false;
      if (adjustmentEl) adjustmentEl.value = '';
      chosenAddrId = null;
      lineNotes = {};
      activeCase = null; caseItems = null; cartSeen = {};   // the TOKEN stays — auth, not order state
      saveExtras([]); paintExtraCounts();   // ORG-406 extra lines are order state too
      renderCaseBox();
      if (shipAddrList) shipAddrList.innerHTML = '';
      if (shipAddrForm) shipAddrForm.hidden = true;
      if (shippingNoteEl) { shippingNoteEl.hidden = true; shippingNoteEl.textContent = ''; }
      if (resultEl) { resultEl.hidden = true; resultEl.textContent = ''; }
      hideAfmDup();
      // New-customer draft: text fields + the payment select, plus the shipping toggle.
      panel.querySelectorAll('[data-nc]').forEach(function (f) {
        if (f.tagName === 'SELECT') f.selectedIndex = 0; else f.value = '';
      });
      var ncShipDiff = $('[data-nc-shipdiff]', panel);
      var ncShipWrap = $('[data-nc-shipwrap]', panel);
      if (ncShipDiff) ncShipDiff.checked = false;
      if (ncShipWrap) ncShipWrap.hidden = true;
      // Last: clearSelection() and setDocType() both saveState(), so dropping the
      // keys earlier would just let them write the state straight back.
      try { sessionStorage.removeItem(STORE_KEY); sessionStorage.removeItem(ORDER_KEY); } catch (e) {}
      renderTotals();
      return (window.Timologio && window.Timologio.reset) ? window.Timologio.reset() : Promise.resolve();
    }

    // Public API — cart-drawer.js calls this from the [data-cart-clear] handler.
    // Only ever defined for staff (window.STAFF_ORDER gates this whole module), so
    // a regular customer's cart clear stays untouched.
    window.StaffOrder = { reset: resetAll, clearConfirm: CFG.clearConfirm || '' };

    // «Λήψη PDF» for a doc the panel just created — sits beside the Zoho link
    // so staff get the PDF without opening
    // Zoho. listen proxies Zoho's PDF because the Zoho token stays server-side.
    // Returns null when the backend sent no doc_id (older listen deploy).
    function pdfButton(docType, docId, docNumber) {
      if (!docId || !/^\d+$/.test(String(docId))) return null;
      var label = panel.getAttribute('data-label-pdf') || 'PDF';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'staff-order__pdf';
      btn.textContent = label;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.textContent = label;
        var name = String(docNumber || docId);
        staffFetch('/staff/doc-pdf?doc_type=' + encodeURIComponent(docType)
          + '&doc_id=' + encodeURIComponent(docId)
          + '&name=' + encodeURIComponent(name))
          .then(function (r) {
            if (!r.ok) throw r;
            return r.blob();
          })
          .then(function (blob) {
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name + '.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(function () { URL.revokeObjectURL(a.href); }, 10000);
          })
          .catch(function () {
            btn.textContent = panel.getAttribute('data-label-pdf-error') || 'PDF failed';
          })
          .then(function () {
            btn.disabled = false;
            btn.classList.remove('is-loading');
          });
      });
      return btn;
    }

    // ORG-525: a sales order the cart creates is a Zoho DRAFT, and a draft
    // counts for nothing — no stock reserved, nothing written to Airtable. The
    // result line lists what is short (information only) and offers «Άνοιγμα
    // SO»: listen /staff/confirm-so opens it in Zoho and runs the same reconcile
    // Zoho's webhook runs (stock commit, then the cascade orders exactly what is
    // missing), then we show what was ordered. Nobody picks rows any more.
    function openSoBlock(res) {
      var L = function (k) { return panel.getAttribute('data-' + k) || ''; };
      var box = document.createElement('div');
      box.className = 'staff-order__open-so';
      box.setAttribute('data-open-so', '');
      var hint = document.createElement('p');
      hint.className = 'staff-order__open-so-hint';
      hint.textContent = L('open-so-hint');
      box.appendChild(hint);
      var short = (res.shortfall && res.shortfall.items) || [];
      var sp = null;
      if (res.order_all) {
        sp = document.createElement('p');
        sp.setAttribute('data-open-so-all', '');
        sp.textContent = L('open-so-all');
        box.appendChild(sp);
      } else if (short.length) {
        sp = document.createElement('p');
        sp.setAttribute('data-open-so-short', '');
        sp.textContent = L('open-so-short') + ': ' + short.map(function (it) {
          return it.sku + ' \u00d7 ' + it.shortfall;
        }).join(', ');
        box.appendChild(sp);
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'staff-order__pdf staff-order__open-so-btn';   // same outline style as «Λήψη PDF»
      btn.setAttribute('data-open-so-btn', '');
      btn.textContent = L('open-so');
      var out = document.createElement('p');
      out.setAttribute('data-open-so-result', '');
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        staffFetch('/staff/confirm-so', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ doc_id: String(res.doc_id) })
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !j.ok) throw j;
            return j;
          });
        }).then(function (j) {
          btn.remove();
          hint.remove();
          if (sp) sp.remove();   // what was ordered replaces what was short
          var acts = { split: L('open-so-act-split'), create: L('open-so-act-create'),
                       raise: L('open-so-act-create'), topup_stock: L('open-so-act-topup-stock') };
          var done = (j.ordered || []).filter(function (o) { return acts[o.action]; });
          out.textContent = L('open-so-done') + ' (' + (j.so_number || '') + '). ' + (done.length
            ? L('open-so-ordered') + ': ' + done.map(function (o) {
                return o.vendor + ' ' + o.sku + ' \u00d7 ' + o.qty + ' ' + acts[o.action];
              }).join('; ')
            : L('open-so-nothing'));
        }).catch(function (e) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          out.textContent = L('open-so-error') + ((e && e.message) ? ': ' + e.message
            : (e && e.error) ? ': ' + e.error : '');
        });
      });
      box.appendChild(btn);
      box.appendChild(out);
      return box;
    }

    // Idempotency token of a Create whose outcome is unknown (the POST went out
    // but no reply was read). A retry of the SAME request reuses it, so the
    // server's dedup returns the already-created doc instead of a second one.
    // Cleared on any definite outcome. { fp: request fingerprint, token }.
    var pendingCreate = null;

    createBtn.addEventListener('click', function () {
      // Defensive flush: don't rely on the mousedown-blur -> change-event path
      // alone to commit a note being typed right as Create is clicked. Force
      // it here too, before any fetch starts.
      var _af = document.activeElement;
      if (_af && _af.classList && _af.classList.contains('staff-order__note-input')) { _af.blur(); }
      if (!chosen) return;
      var refDt = docEl.value;
      if ((refDt === 'quote' || refDt === 'salesorder') && referenceEl && !referenceEl.value.trim()
          && refNudgeEl && refNudgeEl.hidden) {
        refNudgeEl.hidden = false;
        referenceEl.classList.add('is-nudged');
        return;
      }
      hideRefNudge();
      createBtn.disabled = true;
      createBtn.classList.add('is-loading');
      resultEl.hidden = true;

      // Fresh idempotency token per Create. The Shopify cart token is stable for
      // the whole cart, so reusing it makes the server dedup every Create after
      // the first into the same document. Double-clicks are already blocked by
      // disabling the button above. Exception: a retry of an identical request
      // after an unknown outcome reuses pendingCreate's token (see there).
      var submitToken = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : (String(Date.now()) + '-' + Math.random().toString(36).slice(2));
      var submitFp = '';
      var posted = false;

      // Per-line delivery phrase is computed in Liquid on cart-item.liquid and
      // exposed as data-cartitem-delivery — but ONLY on the server-rendered
      // /cart page. The cart DRAWER (where this panel lives) is client-rendered
      // by cart-drawer.js and carries no such attribute, so reading it off the
      // live DOM always came back empty and every Zoho line description shipped
      // blank. Fetch the /cart HTML and parse the phrases keyed by data-cartitem-
      // key (== cart.js item.key) so the mapping is independent of drawer state.
      Promise.all([
        fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }),
        // The primary-locale /cart on purpose (not ROOT): the phrases become the Zoho line
        // description, which stays Greek whichever locale the staff member browses (WORK-259).
        fetch('/cart').then(function (r) { return r.text(); }).catch(function () { return ''; })
      ])
        .then(function (results) {
          var cart = withExtras(results[0]);
          var cartHtml = results[1];
          var deliveryByKey = {};
          if (cartHtml) {
            var parsed = new DOMParser().parseFromString(cartHtml, 'text/html');
            parsed.querySelectorAll('[data-cartitem-key]').forEach(function (el) {
              deliveryByKey[el.getAttribute('data-cartitem-key')] = el.getAttribute('data-cartitem-delivery') || '';
            });
          }
          // Extra lines (ORG-406) are not on /cart; their phrase rode in from the PDP.
          (cart.items || []).forEach(function (i) {
            if (i.staffExtra) deliveryByKey[i.key] = i.delivery || '';
          });
          // Order lines by the staff-chosen cart sequence. Read the flat
          // data-cart-key order straight from the rendered drawer (already
          // grouped: parents precede their children). Items not in the DOM
          // (edge case) keep their cart order at the end.
          var domOrder = Array.prototype.slice
            .call(document.querySelectorAll('.cart-drawer__items [data-cart-key]'))
            .map(function (el) { return el.getAttribute('data-cart-key'); });
          var orderedItems = (cart.items || []).slice().sort(function (a, b) {
            var ia = domOrder.indexOf(a.key); if (ia === -1) ia = Infinity;
            var ib = domOrder.indexOf(b.key); if (ib === -1) ib = Infinity;
            return ia - ib;
          });
          // A calibration-certificate line's delivery phrase is always «Κατόπιν
          // παραγγελίας», which tells the customer nothing. Name the instrument it
          // certifies instead, as the drawer's eyebrow does: «Διακρίβωση για
          // <parent SKU>» (ORG-303). Same companion rule as cart-drawer.js: linked
          // via _related_to_variant, any kind except the varidio.
          // Line 2 is the certificate's delivery time. A Johs certificate ships with
          // its instrument, so it takes the INSTRUMENT line's delivery phrase (John,
          // 2026-09-23); other vendors keep the certificate's own phrase.
          var skuByVariant = {}, keyByVariant = {};
          (cart.items || []).forEach(function (i) {
            if (i.variant_id == null) return;   // a pricelist line certifies nothing
            var v = String(i.variant_id);
            skuByVariant[v] = (window.Box10 && window.Box10.displaySku) ? window.Box10.displaySku(i) : String(i.sku || '');
            var props = i.properties || {};
            if (!keyByVariant[v] && !props._related_to_variant) keyByVariant[v] = i.key;
          });
          function certFor(i) {
            var p = i.properties || {};
            if (!p._related_to_variant || p._companion_kind === 'varidio') return '';
            var pv = String(p._related_to_variant);
            var parent = skuByVariant[pv];
            if (!parent) return '';
            var johs = String(i.vendor || '').trim().toLowerCase() === 'johs';
            var time = johs ? (deliveryByKey[keyByVariant[pv]] || '') : (deliveryByKey[i.key] || '');
            return 'Διακρίβωση για ' + parent + (time ? '\n' + time : '');
          }
          var lines = orderedItems.map(function (i) {
            // product_type rides along so the backend can cap the διακρίβωση discount:
            // those lines never follow a preset above 10%.
            var line = { sku: i.sku, qty: i.quantity, vendor: i.vendor,
                     product_type: i.product_type || '', note: lineNotes[i.key] || '',
                     description: certFor(i) || deliveryByKey[i.key] || '' };
            // A pricelist line (ORG-162) has no variant: the key is left out, and listen
            // resolves (or creates) the Zoho item by SKU and skips it on the Shopify draft.
            if (i.id != null) line.variant_id = i.id;
            // WORK-233: the pieces a YG-DORO gift code makes free on this line, as Shopify
            // allocated them (the same codes a customer's cart gets); listen bills them at 100% off.
            var gift = giftPieces(i);
            if (gift.qty > 0) { line.free_qty = gift.qty; line.gift_code = gift.code; }
            // WORK-295: the pieces Shopify counted toward an earned gift take no preset.
            line.gift_used = giftUsed(i);
            return line;
          });
          var body = {
            contact_id:      chosen.contact_id,
            doc_type:        docEl.value,
            discount_preset: discountEl.value,
            lines:           lines,
            email:           CFG.email
          };
          // Free-text reference → Zoho reference_number (quotes, sales orders + invoices).
          var refVal = referenceEl ? referenceEl.value.trim() : '';
          if (refVal && (docEl.value === 'quote' || docEl.value === 'salesorder' || docEl.value === 'invoice')) {
            body.reference = refVal;
          }
          // ORG-526: order-everything sales order («Παραγγελία όλων»).
          if (docEl.value === 'salesorder' && orderAllEl && orderAllEl.checked) body.order_all = true;
          // ± rounding of the Zoho total → the document's native adjustment field.
          // Invoices + receipts only; zero/unparsable values are simply not sent.
          if (docEl.value === 'invoice' || docEl.value === 'receipt' || docEl.value === 'receipt_novat') {
            var adjVal = adjustmentEl ? parseFloat(adjustmentEl.value) : NaN;
            if (adjVal && isFinite(adjVal)) body.adjustment = Math.round(adjVal * 100) / 100;
          }
          // Ticked printed catalogues → 0€ lines (invoices + receipts only).
          if (CATALOG_DOCS[docEl.value]) {
            var cats = pickedCatalogs();
            if (cats.length) body.catalogs = cats;
          }
          // Payment terms + shipping method for invoice/salesorder/receipt.
          if (docEl.value !== 'quote' && paymentEl && paymentEl.value) {
            var pp = paymentEl.value.split('|');
            body.payment_terms = parseInt(pp[0], 10) || 0;
            body.payment_terms_label = pp.slice(1).join('|');
          }
          // Shipping method drives the Zoho charge line + the contact's cf_f44e1d.
          // charge_shipping is the free-shipping decision computed from this same
          // (freshly fetched) cart; the backend owns the method→SKU mapping.
          if (docEl.value !== 'quote' && shippingMethodEl && shippingMethodEl.value) {
            body.shipping_method = shippingMethodEl.value;
            body.charge_shipping = computeShipping(cart).charge;
          }
          // Chosen shipping address (existing customers only) for shipping docs.
          if (docEl.value !== 'quote' && chosenAddrId) {
            body.shipping_address_id = chosenAddrId;
          }
          // Same request as the one whose reply was lost → same token.
          submitFp = JSON.stringify(body);
          if (pendingCreate && pendingCreate.fp === submitFp) submitToken = pendingCreate.token;
          body.token = submitToken;
          posted = true;
          return staffFetch('/staff/create-doc', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          pendingCreate = null;   // a readable reply is a definite outcome
          resultEl.hidden = false;
          if (res && res.ok) {
            var labelCreated = resultEl.dataset.labelCreated || 'staff_order.created';
            var labelWarnings = resultEl.dataset.labelWarnings || 'SKU not found';
            var warn = (res.warnings && res.warnings.length)
              ? ' — ' + res.warnings.length + ' ' + labelWarnings : '';
            resultEl.textContent = '';
            var createdSpan = document.createElement('span');
            createdSpan.textContent = labelCreated + ' ' + String(res.doc_number || '');
            resultEl.appendChild(createdSpan);
            var url = String(res.zoho_url || '');
            if (url.indexOf('https://') === 0) {
              resultEl.appendChild(document.createTextNode(' '));
              var link = document.createElement('a');
              link.textContent = 'Zoho';
              link.target = '_blank';
              link.rel = 'noopener';
              link.setAttribute('href', url);
              resultEl.appendChild(link);
            }
            var pdfBtn = pdfButton(res.doc_type || docEl.value, res.doc_id, res.doc_number);
            if (pdfBtn) {
              resultEl.appendChild(document.createTextNode(' '));
              resultEl.appendChild(pdfBtn);
            }
            if (warn) resultEl.appendChild(document.createTextNode(warn));
            // Doc case-tagging (spec 2026-08-18, calls repo): tell the
            // CRM about the new doc if a case is active. One retry; on
            // final failure the case page's manual attach is the repair.
            if (activeCase && crmToken()) {
              var tagBody = JSON.stringify({
                doc_type: docEl.value,
                doc_number: String(res.doc_number || ''),
                zoho_url: String(res.zoho_url || '') || undefined,
                source: 'auto'
              });
              // crmFetch already rejects on non-2xx (see its definition:
              // `if (!r.ok) throw r;`), so no extra r.ok check is needed
              // here — the .catch below is the failure path.
              var tagOnce = function () {
                return crmFetch('/api/cases/' + activeCase.public_id
                  + '/docs', { method: 'POST', body: tagBody });
              };
              tagOnce().catch(function () {
                return new Promise(function (ok) { setTimeout(ok, 1500); })
                  .then(tagOnce);
              }).catch(function () {
                resultEl.appendChild(document.createTextNode(
                  ' — case tagging failed; attach it from the case page'));
              });
            }
            // A draft sales order: what is short + «Άνοιγμα SO» (ORG-525).
            if ((res.doc_type || docEl.value) === 'salesorder' && /^\d+$/.test(String(res.doc_id || ''))) {
              try { resultEl.appendChild(openSoBlock(res)); } catch (e) { /* never disturb the created-SO flow */ }
            }
            // Catalogue ticks must not survive a successful create — otherwise a
            // second document for the same customer would resend them.
            catalogPicked = {};
            if (chosen) loadCatalogs(chosen.contact_id);
          } else {
            var labelError = resultEl.dataset.labelError || 'staff_order.error';
            resultEl.textContent = labelError + ': ' + ((res && res.error) ? res.error : 'unknown');
          }
          createBtn.disabled = false;
          createBtn.classList.remove('is-loading');
        })
        .catch(function (e) {
          var labelError = resultEl.dataset.labelError || 'staff_order.error';
          resultEl.hidden = false;
          // Once the POST has gone out, a failure to read the reply does NOT mean
          // nothing was created (a lost reply after a successful Create is how a
          // colleague made a duplicate invoice, 2026-09-22). Say so, and keep the
          // token so a retry of the same request dedups server-side. A 401/403
          // is the server refusing — definitely not created.
          if (posted && !(e && e.status === 401)) {
            pendingCreate = { fp: submitFp, token: submitToken };
            resultEl.textContent = resultEl.dataset.labelErrorUnknown || labelError;
          } else {
            pendingCreate = null;
            resultEl.textContent = labelError + ': network error';
          }
          createBtn.disabled = false;
          createBtn.classList.remove('is-loading');
        });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
